(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './curity-ssi-libs-jose.js', './curity-ssi-libs-verifiable-credentials-vc-ks-data.js', './kotlinx-serialization-kotlinx-serialization-core.js', './ktor-ktor-client-content-negotiation.js', './ktor-ktor-serialization-kotlinx-json.js', './ktor-ktor-http.js', './kotlinx-serialization-kotlinx-serialization-json.js', './ktor-ktor-client-core.js', './ktor-ktor-utils.js', './curity-ssi-libs-oauth.js', './curity-ssi-libs-core-json.js', './curity-ssi-libs-did-resolvers-jwk.js', './Kotlin-DateTime-library-kotlinx-datetime.js', './curity-ssi-libs-sd-jwt.js', './curity-ssi-libs-did.js', './curity-ssi-libs-core.js', './curity-ssi-libs-verifiable-credentials.js', './curity-ssi-libs-did-json.js', './kotlinx.coroutines-kotlinx-coroutines-core-js-ir.js', './kotlin_org_jetbrains_kotlin_kotlin_dom_api_compat.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./curity-ssi-libs-jose.js'), require('./curity-ssi-libs-verifiable-credentials-vc-ks-data.js'), require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./ktor-ktor-client-content-negotiation.js'), require('./ktor-ktor-serialization-kotlinx-json.js'), require('./ktor-ktor-http.js'), require('./kotlinx-serialization-kotlinx-serialization-json.js'), require('./ktor-ktor-client-core.js'), require('./ktor-ktor-utils.js'), require('./curity-ssi-libs-oauth.js'), require('./curity-ssi-libs-core-json.js'), require('./curity-ssi-libs-did-resolvers-jwk.js'), require('./Kotlin-DateTime-library-kotlinx-datetime.js'), require('./curity-ssi-libs-sd-jwt.js'), require('./curity-ssi-libs-did.js'), require('./curity-ssi-libs-core.js'), require('./curity-ssi-libs-verifiable-credentials.js'), require('./curity-ssi-libs-did-json.js'), require('./kotlinx.coroutines-kotlinx-coroutines-core-js-ir.js'), require('./kotlin_org_jetbrains_kotlin_kotlin_dom_api_compat.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'io.curity.ssi:vc-ks-services'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'io.curity.ssi:vc-ks-services'.");
    }
    if (typeof this['curity-ssi-libs-jose'] === 'undefined') {
      throw new Error("Error loading module 'io.curity.ssi:vc-ks-services'. Its dependency 'curity-ssi-libs-jose' was not found. Please, check whether 'curity-ssi-libs-jose' is loaded prior to 'io.curity.ssi:vc-ks-services'.");
    }
    if (typeof this['curity-ssi-libs-verifiable-credentials-vc-ks-data'] === 'undefined') {
      throw new Error("Error loading module 'io.curity.ssi:vc-ks-services'. Its dependency 'curity-ssi-libs-verifiable-credentials-vc-ks-data' was not found. Please, check whether 'curity-ssi-libs-verifiable-credentials-vc-ks-data' is loaded prior to 'io.curity.ssi:vc-ks-services'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'io.curity.ssi:vc-ks-services'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'io.curity.ssi:vc-ks-services'.");
    }
    if (typeof this['ktor-ktor-client-content-negotiation'] === 'undefined') {
      throw new Error("Error loading module 'io.curity.ssi:vc-ks-services'. Its dependency 'ktor-ktor-client-content-negotiation' was not found. Please, check whether 'ktor-ktor-client-content-negotiation' is loaded prior to 'io.curity.ssi:vc-ks-services'.");
    }
    if (typeof this['ktor-ktor-serialization-kotlinx-json'] === 'undefined') {
      throw new Error("Error loading module 'io.curity.ssi:vc-ks-services'. Its dependency 'ktor-ktor-serialization-kotlinx-json' was not found. Please, check whether 'ktor-ktor-serialization-kotlinx-json' is loaded prior to 'io.curity.ssi:vc-ks-services'.");
    }
    if (typeof this['ktor-ktor-http'] === 'undefined') {
      throw new Error("Error loading module 'io.curity.ssi:vc-ks-services'. Its dependency 'ktor-ktor-http' was not found. Please, check whether 'ktor-ktor-http' is loaded prior to 'io.curity.ssi:vc-ks-services'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-json'] === 'undefined') {
      throw new Error("Error loading module 'io.curity.ssi:vc-ks-services'. Its dependency 'kotlinx-serialization-kotlinx-serialization-json' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-json' is loaded prior to 'io.curity.ssi:vc-ks-services'.");
    }
    if (typeof this['ktor-ktor-client-core'] === 'undefined') {
      throw new Error("Error loading module 'io.curity.ssi:vc-ks-services'. Its dependency 'ktor-ktor-client-core' was not found. Please, check whether 'ktor-ktor-client-core' is loaded prior to 'io.curity.ssi:vc-ks-services'.");
    }
    if (typeof this['ktor-ktor-utils'] === 'undefined') {
      throw new Error("Error loading module 'io.curity.ssi:vc-ks-services'. Its dependency 'ktor-ktor-utils' was not found. Please, check whether 'ktor-ktor-utils' is loaded prior to 'io.curity.ssi:vc-ks-services'.");
    }
    if (typeof this['curity-ssi-libs-oauth'] === 'undefined') {
      throw new Error("Error loading module 'io.curity.ssi:vc-ks-services'. Its dependency 'curity-ssi-libs-oauth' was not found. Please, check whether 'curity-ssi-libs-oauth' is loaded prior to 'io.curity.ssi:vc-ks-services'.");
    }
    if (typeof this['curity-ssi-libs-core-json'] === 'undefined') {
      throw new Error("Error loading module 'io.curity.ssi:vc-ks-services'. Its dependency 'curity-ssi-libs-core-json' was not found. Please, check whether 'curity-ssi-libs-core-json' is loaded prior to 'io.curity.ssi:vc-ks-services'.");
    }
    if (typeof this['curity-ssi-libs-did-resolvers-jwk'] === 'undefined') {
      throw new Error("Error loading module 'io.curity.ssi:vc-ks-services'. Its dependency 'curity-ssi-libs-did-resolvers-jwk' was not found. Please, check whether 'curity-ssi-libs-did-resolvers-jwk' is loaded prior to 'io.curity.ssi:vc-ks-services'.");
    }
    if (typeof this['Kotlin-DateTime-library-kotlinx-datetime'] === 'undefined') {
      throw new Error("Error loading module 'io.curity.ssi:vc-ks-services'. Its dependency 'Kotlin-DateTime-library-kotlinx-datetime' was not found. Please, check whether 'Kotlin-DateTime-library-kotlinx-datetime' is loaded prior to 'io.curity.ssi:vc-ks-services'.");
    }
    if (typeof this['curity-ssi-libs-sd-jwt'] === 'undefined') {
      throw new Error("Error loading module 'io.curity.ssi:vc-ks-services'. Its dependency 'curity-ssi-libs-sd-jwt' was not found. Please, check whether 'curity-ssi-libs-sd-jwt' is loaded prior to 'io.curity.ssi:vc-ks-services'.");
    }
    if (typeof this['curity-ssi-libs-did'] === 'undefined') {
      throw new Error("Error loading module 'io.curity.ssi:vc-ks-services'. Its dependency 'curity-ssi-libs-did' was not found. Please, check whether 'curity-ssi-libs-did' is loaded prior to 'io.curity.ssi:vc-ks-services'.");
    }
    if (typeof this['curity-ssi-libs-core'] === 'undefined') {
      throw new Error("Error loading module 'io.curity.ssi:vc-ks-services'. Its dependency 'curity-ssi-libs-core' was not found. Please, check whether 'curity-ssi-libs-core' is loaded prior to 'io.curity.ssi:vc-ks-services'.");
    }
    if (typeof this['curity-ssi-libs-verifiable-credentials'] === 'undefined') {
      throw new Error("Error loading module 'io.curity.ssi:vc-ks-services'. Its dependency 'curity-ssi-libs-verifiable-credentials' was not found. Please, check whether 'curity-ssi-libs-verifiable-credentials' is loaded prior to 'io.curity.ssi:vc-ks-services'.");
    }
    if (typeof this['curity-ssi-libs-did-json'] === 'undefined') {
      throw new Error("Error loading module 'io.curity.ssi:vc-ks-services'. Its dependency 'curity-ssi-libs-did-json' was not found. Please, check whether 'curity-ssi-libs-did-json' is loaded prior to 'io.curity.ssi:vc-ks-services'.");
    }
    if (typeof this['kotlinx.coroutines-kotlinx-coroutines-core-js-ir'] === 'undefined') {
      throw new Error("Error loading module 'io.curity.ssi:vc-ks-services'. Its dependency 'kotlinx.coroutines-kotlinx-coroutines-core-js-ir' was not found. Please, check whether 'kotlinx.coroutines-kotlinx-coroutines-core-js-ir' is loaded prior to 'io.curity.ssi:vc-ks-services'.");
    }
    if (typeof kotlin_org_jetbrains_kotlin_kotlin_dom_api_compat === 'undefined') {
      throw new Error("Error loading module 'io.curity.ssi:vc-ks-services'. Its dependency 'kotlin_org_jetbrains_kotlin_kotlin_dom_api_compat' was not found. Please, check whether 'kotlin_org_jetbrains_kotlin_kotlin_dom_api_compat' is loaded prior to 'io.curity.ssi:vc-ks-services'.");
    }
    root['io.curity.ssi:vc-ks-services'] = factory(typeof this['io.curity.ssi:vc-ks-services'] === 'undefined' ? {} : this['io.curity.ssi:vc-ks-services'], this['kotlin-kotlin-stdlib'], this['curity-ssi-libs-jose'], this['curity-ssi-libs-verifiable-credentials-vc-ks-data'], this['kotlinx-serialization-kotlinx-serialization-core'], this['ktor-ktor-client-content-negotiation'], this['ktor-ktor-serialization-kotlinx-json'], this['ktor-ktor-http'], this['kotlinx-serialization-kotlinx-serialization-json'], this['ktor-ktor-client-core'], this['ktor-ktor-utils'], this['curity-ssi-libs-oauth'], this['curity-ssi-libs-core-json'], this['curity-ssi-libs-did-resolvers-jwk'], this['Kotlin-DateTime-library-kotlinx-datetime'], this['curity-ssi-libs-sd-jwt'], this['curity-ssi-libs-did'], this['curity-ssi-libs-core'], this['curity-ssi-libs-verifiable-credentials'], this['curity-ssi-libs-did-json'], this['kotlinx.coroutines-kotlinx-coroutines-core-js-ir'], kotlin_org_jetbrains_kotlin_kotlin_dom_api_compat);
  }
}(globalThis, function (_, kotlin_kotlin, kotlin_io_curity_ssi_jose, kotlin_io_curity_ssi_vc_ks_data, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_io_ktor_ktor_client_content_negotiation, kotlin_io_ktor_ktor_serialization_kotlinx_json, kotlin_io_ktor_ktor_http, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json, kotlin_io_ktor_ktor_client_core, kotlin_io_ktor_ktor_utils, kotlin_io_curity_ssi_oauth, kotlin_io_curity_ssi_core_json, kotlin_io_curity_ssi_jwk, kotlin_org_jetbrains_kotlinx_kotlinx_datetime, kotlin_io_curity_ssi_sd_jwt, kotlin_io_curity_ssi_did, kotlin_io_curity_ssi_core, kotlin_io_curity_ssi_verifiable_credentials, kotlin_io_curity_ssi_did_json, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core, kotlin_org_jetbrains_kotlin_kotlin_dom_api_compat) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var VOID = kotlin_kotlin.$_$.f;
  var JsonJwsHeader = kotlin_io_curity_ssi_jose.$_$.s;
  var JsonJwtClaimsSet = kotlin_io_curity_ssi_jose.$_$.u;
  var JwsUtil_getInstance = kotlin_io_curity_ssi_jose.$_$.j;
  var protoOf = kotlin_kotlin.$_$.kb;
  var initMetadataForObject = kotlin_kotlin.$_$.oa;
  var JsonSupportedCredentialSerializer_getInstance = kotlin_io_curity_ssi_vc_ks_data.$_$.v;
  var ArrayListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q1;
  var initMetadataForCompanion = kotlin_kotlin.$_$.ja;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
  var $serializer_getInstance = kotlin_io_curity_ssi_vc_ks_data.$_$.t;
  var $serializer_getInstance_0 = kotlin_io_curity_ssi_vc_ks_data.$_$.s;
  var equals = kotlin_kotlin.$_$.ba;
  var $serializer_getInstance_1 = kotlin_io_curity_ssi_vc_ks_data.$_$.u;
  var Unit_instance = kotlin_kotlin.$_$.h5;
  var THROW_CCE = kotlin_kotlin.$_$.te;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e;
  var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s1;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t1;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e2;
  var objectCreate = kotlin_kotlin.$_$.jb;
  var toString = kotlin_kotlin.$_$.ob;
  var hashCode = kotlin_kotlin.$_$.ha;
  var initMetadataForClass = kotlin_kotlin.$_$.ia;
  var Plugin_getInstance = kotlin_io_ktor_ktor_client_content_negotiation.$_$.a;
  var json = kotlin_io_ktor_ktor_serialization_kotlinx_json.$_$.a;
  var CoroutineImpl = kotlin_kotlin.$_$.n9;
  var URLBuilder = kotlin_io_ktor_ktor_http.$_$.v;
  var Exception_init_$Create$ = kotlin_kotlin.$_$.n1;
  var singleOrNull = kotlin_kotlin.$_$.d8;
  var Default_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.a;
  var JsonOffer = kotlin_io_curity_ssi_vc_ks_data.$_$.g1;
  var getKClass = kotlin_kotlin.$_$.e;
  var arrayOf = kotlin_kotlin.$_$.hf;
  var createKType = kotlin_kotlin.$_$.b;
  var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t2;
  var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k2;
  var isInterface = kotlin_kotlin.$_$.xa;
  var HttpClient = kotlin_io_ktor_ktor_client_core.$_$.v;
  var HttpRequestBuilder = kotlin_io_ktor_ktor_client_core.$_$.o;
  var takeFrom = kotlin_io_ktor_ktor_http.$_$.p1;
  var Companion_getInstance = kotlin_io_ktor_ktor_http.$_$.f;
  var HttpStatement = kotlin_io_ktor_ktor_client_core.$_$.u;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.z8;
  var JsType_instance = kotlin_io_ktor_ktor_utils.$_$.b;
  var typeInfoImpl = kotlin_io_ktor_ktor_utils.$_$.l;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.a6;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.m;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.ka;
  var first = kotlin_kotlin.$_$.x6;
  var OAuthPreAuthorizedCodeFlowClient = kotlin_io_curity_ssi_oauth.$_$.g;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.rf;
  var JsonOAuthErrorTokenResponse = kotlin_io_curity_ssi_oauth.$_$.a;
  var OAuthRefreshFlowClient = kotlin_io_curity_ssi_oauth.$_$.h;
  var JsonOAuthSuccessTokenResponse = kotlin_io_curity_ssi_oauth.$_$.b;
  var VcSdJwtAuthorizationDetail_init_$Create$ = kotlin_io_curity_ssi_vc_ks_data.$_$.r;
  var listOf = kotlin_kotlin.$_$.n7;
  var KtList = kotlin_kotlin.$_$.p5;
  var VcSdJwtAuthorizationDetail = kotlin_io_curity_ssi_vc_ks_data.$_$.u1;
  var createInvariantKTypeProjection = kotlin_kotlin.$_$.a;
  var VcSdJwtCredentialConfigurationsSupported = kotlin_io_curity_ssi_vc_ks_data.$_$.v1;
  var toSet = kotlin_kotlin.$_$.r8;
  var JwtVcJsonAuthorizationDetail_init_$Create$ = kotlin_io_curity_ssi_vc_ks_data.$_$.q;
  var JwtVcJsonAuthorizationDetail = kotlin_io_curity_ssi_vc_ks_data.$_$.i1;
  var JwtVcJsonCredentialConfigurationsSupported = kotlin_io_curity_ssi_vc_ks_data.$_$.j1;
  var Default_getInstance_0 = kotlin_kotlin.$_$.x4;
  var encodeBase64url = kotlin_io_curity_ssi_jose.$_$.o;
  var OAuthAuthorizationRequest = kotlin_io_curity_ssi_oauth.$_$.c;
  var OAuthCodeFlowClient = kotlin_io_curity_ssi_oauth.$_$.f;
  var getKClassFromExpression = kotlin_kotlin.$_$.d;
  var DefaultJsonMultiValue_init_$Create$ = kotlin_io_curity_ssi_core_json.$_$.b;
  var JsonPrimitive = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.j;
  var to = kotlin_kotlin.$_$.wf;
  var mapOf = kotlin_kotlin.$_$.q7;
  var JwkDid_instance = kotlin_io_curity_ssi_jwk.$_$.a;
  var JsonDictionary = kotlin_io_curity_ssi_core_json.$_$.o;
  var JsonProofOfPossession = kotlin_io_curity_ssi_vc_ks_data.$_$.h1;
  var VcSdJwtVerifiableCredentialRequest = kotlin_io_curity_ssi_vc_ks_data.$_$.y1;
  var CredentialDefinition = kotlin_io_curity_ssi_vc_ks_data.$_$.o1;
  var JwtVcJsonVerifiableCredentialRequest = kotlin_io_curity_ssi_vc_ks_data.$_$.p1;
  var Companion_getInstance_0 = kotlin_io_curity_ssi_vc_ks_data.$_$.x;
  var System_instance = kotlin_org_jetbrains_kotlinx_kotlinx_datetime.$_$.b;
  var UserVerifiableCredential = kotlin_io_curity_ssi_vc_ks_data.$_$.t1;
  var Companion_getInstance_1 = kotlin_io_ktor_ktor_http.$_$.j;
  var URLBuilder_0 = kotlin_io_ktor_ktor_http.$_$.w;
  var plus = kotlin_kotlin.$_$.v7;
  var emptyList = kotlin_kotlin.$_$.r6;
  var isBlank = kotlin_kotlin.$_$.uc;
  var toList = kotlin_kotlin.$_$.k8;
  var listOf_0 = kotlin_kotlin.$_$.o7;
  var isSuccess = kotlin_io_ktor_ktor_http.$_$.k1;
  var JsonCredentialIssuerMetadata = kotlin_io_curity_ssi_vc_ks_data.$_$.b1;
  var getOrNull = kotlin_kotlin.$_$.a7;
  var JsonOAuthMetadata = kotlin_io_curity_ssi_vc_ks_data.$_$.f1;
  var JsonCredentialIssuer = kotlin_io_curity_ssi_vc_ks_data.$_$.c1;
  var Url = kotlin_io_ktor_ktor_http.$_$.z;
  var PrimitiveClasses_getInstance = kotlin_kotlin.$_$.y4;
  var JsonVcSdJwtIssuerMetadata = kotlin_io_curity_ssi_sd_jwt.$_$.e;
  var UnsupportedOperationException_init_$Create$ = kotlin_kotlin.$_$.m2;
  var Companion_getInstance_2 = kotlin_io_curity_ssi_did.$_$.b;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.n;
  var mapCapacity = kotlin_kotlin.$_$.p7;
  var coerceAtLeast = kotlin_kotlin.$_$.rb;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.v;
  var emptyMap = kotlin_kotlin.$_$.s6;
  var ValidationScope = kotlin_io_curity_ssi_core.$_$.n;
  var JwtVcJsonVerifiableCredentialResponse = kotlin_io_curity_ssi_vc_ks_data.$_$.q1;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.y1;
  var Deferred = kotlin_io_curity_ssi_vc_ks_data.$_$.k1;
  var DidValidatedJwtVcJsonCredentialResponse = kotlin_io_curity_ssi_vc_ks_data.$_$.a1;
  var initMetadataForLambda = kotlin_kotlin.$_$.na;
  var suspendableValidationScope = kotlin_io_curity_ssi_core.$_$.a;
  var JsonPrimitive_0 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.m;
  var JsonObject = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.i;
  var _Duration___get_absoluteValue__impl__vr7i6w = kotlin_kotlin.$_$.n2;
  var _Duration___get_inWholeSeconds__impl__hpy7b3 = kotlin_kotlin.$_$.o2;
  var Long = kotlin_kotlin.$_$.ne;
  var Companion_getInstance_3 = kotlin_org_jetbrains_kotlinx_kotlinx_datetime.$_$.c;
  var Companion_instance = kotlin_io_curity_ssi_vc_ks_data.$_$.w;
  var IssuerURI = kotlin_io_curity_ssi_verifiable_credentials.$_$.e;
  var IssuerObject = kotlin_io_curity_ssi_verifiable_credentials.$_$.d;
  var DidResolutionException = kotlin_io_curity_ssi_did.$_$.d;
  var Companion_instance_0 = kotlin_io_curity_ssi_jose.$_$.e;
  var Companion_instance_1 = kotlin_io_curity_ssi_did_json.$_$.a;
  var JsonPublicKeyJwk = kotlin_io_curity_ssi_did_json.$_$.d;
  var CryptoException = kotlin_io_curity_ssi_jose.$_$.k;
  var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.w;
  var IllegalArgumentException = kotlin_kotlin.$_$.le;
  var SerializationException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.n2;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p;
  var LinkedHashMapSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v1;
  var startsWith = kotlin_kotlin.$_$.hd;
  var header = kotlin_io_ktor_ktor_client_core.$_$.q;
  var Plugin_getInstance_0 = kotlin_io_ktor_ktor_client_core.$_$.c;
  var plugin = kotlin_io_ktor_ktor_client_core.$_$.n;
  var Sender = kotlin_io_ktor_ktor_client_core.$_$.m;
  var initMetadataForFunctionReference = kotlin_kotlin.$_$.la;
  var url = kotlin_io_ktor_ktor_client_core.$_$.s;
  var Application_getInstance = kotlin_io_ktor_ktor_http.$_$.b;
  var contentType = kotlin_io_ktor_ktor_http.$_$.g1;
  var OutgoingContent = kotlin_io_ktor_ktor_http.$_$.q;
  var NullBody_instance = kotlin_io_ktor_ktor_http.$_$.a;
  var JwtVcJsonCredentialResponse = kotlin_io_curity_ssi_vc_ks_data.$_$.l1;
  var VcSdJwtCredentialResponse = kotlin_io_curity_ssi_vc_ks_data.$_$.x1;
  var path = kotlin_io_ktor_ktor_http.$_$.o1;
  var JwtVcJsonLdVerifiableCredentialRequest = kotlin_io_curity_ssi_vc_ks_data.$_$.n1;
  var JwtVcJsonLdCredentialResponse = kotlin_io_curity_ssi_vc_ks_data.$_$.m1;
  var LdpVerifiableCredentialRequest = kotlin_io_curity_ssi_vc_ks_data.$_$.s1;
  var LdpVcCredentialResponse = kotlin_io_curity_ssi_vc_ks_data.$_$.r1;
  var Deferred_0 = kotlin_io_curity_ssi_vc_ks_data.$_$.w1;
  var VcSdJwtVerifiableCredentialResponse = kotlin_io_curity_ssi_vc_ks_data.$_$.z1;
  var Companion_instance_2 = kotlin_io_curity_ssi_sd_jwt.$_$.c;
  var VcSdJwtIssuerJwtValidator = kotlin_io_curity_ssi_sd_jwt.$_$.f;
  var DefaultValidatedVcSdJwtCredentialResponse = kotlin_io_curity_ssi_vc_ks_data.$_$.z;
  var Pair = kotlin_kotlin.$_$.qe;
  var Collection = kotlin_kotlin.$_$.j5;
  var JsonStringFilter = kotlin_io_curity_ssi_vc_ks_data.$_$.f2;
  var JsonArrayContainsFilter = kotlin_io_curity_ssi_vc_ks_data.$_$.a2;
  var Regex_init_$Create$ = kotlin_kotlin.$_$.f1;
  var IssuerObject_0 = kotlin_io_curity_ssi_vc_ks_data.$_$.d1;
  var IssuerURI_0 = kotlin_io_curity_ssi_vc_ks_data.$_$.e1;
  var get_jsonObject = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.s;
  var get_jsonPrimitive = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.t;
  var Companion_instance_3 = kotlin_io_curity_ssi_jose.$_$.d;
  var JsonPresentationSubmission = kotlin_io_curity_ssi_vc_ks_data.$_$.e2;
  var checkIndexOverflow = kotlin_kotlin.$_$.z5;
  var DefaultJsonMultiValue_init_$Create$_0 = kotlin_io_curity_ssi_core_json.$_$.a;
  var JsonDescriptorMapObject = kotlin_io_curity_ssi_vc_ks_data.$_$.b2;
  var StringCredential = kotlin_io_curity_ssi_verifiable_credentials.$_$.c;
  var SerializableW3CVerifiablePresentation = kotlin_io_curity_ssi_vc_ks_data.$_$.j2;
  var toString_0 = kotlin_kotlin.$_$.vf;
  var JsonPathNested = kotlin_io_curity_ssi_vc_ks_data.$_$.c2;
  var JsonStringVerifiablePresentation = kotlin_io_curity_ssi_vc_ks_data.$_$.g2;
  var toLong = kotlin_kotlin.$_$.mb;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.t1;
  var SdJwtKeyBindingBuilder_instance = kotlin_io_curity_ssi_sd_jwt.$_$.b;
  var Companion_instance_4 = kotlin_io_curity_ssi_sd_jwt.$_$.a;
  var RuntimeException_init_$Create$ = kotlin_kotlin.$_$.h2;
  var Companion_getInstance_4 = kotlin_io_ktor_ktor_http.$_$.h;
  var DefaultJsonMultiValue = kotlin_io_curity_ssi_core_json.$_$.l;
  var JsonVerifiablePresentation = kotlin_io_curity_ssi_vc_ks_data.$_$.h2;
  var Companion_getInstance_5 = kotlin_io_ktor_ktor_http.$_$.i;
  var ParametersBuilder = kotlin_io_ktor_ktor_http.$_$.u;
  var submitForm = kotlin_io_ktor_ktor_client_core.$_$.a;
  var JsonVerifierDirectPostAuthorizationResponse = kotlin_io_curity_ssi_vc_ks_data.$_$.i2;
  var getStringHashCode = kotlin_kotlin.$_$.ga;
  var LinkedHashSetSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.w1;
  var setOf = kotlin_kotlin.$_$.c8;
  var JsonPresentationDefinition = kotlin_io_curity_ssi_vc_ks_data.$_$.d2;
  var intersect = kotlin_kotlin.$_$.f7;
  var Companion_instance_5 = kotlin_io_curity_ssi_verifiable_credentials.$_$.a;
  var ensureNotNull = kotlin_kotlin.$_$.kf;
  var Companion_instance_6 = kotlin_io_curity_ssi_jose.$_$.f;
  var $serializer_getInstance_2 = kotlin_io_curity_ssi_jose.$_$.i;
  var $serializer_getInstance_3 = kotlin_io_curity_ssi_vc_ks_data.$_$.y;
  var LongSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o;
  var Js_instance = kotlin_io_ktor_ktor_client_core.$_$.b;
  var OAuthClient = kotlin_io_curity_ssi_oauth.$_$.e;
  var JwkDidResolver = kotlin_io_curity_ssi_jwk.$_$.b;
  var CompositeDidResolver = kotlin_io_curity_ssi_did.$_$.c;
  var HttpClient_0 = kotlin_io_ktor_ktor_client_core.$_$.w;
  var JsDefaultKeyStore = kotlin_io_curity_ssi_jose.$_$.a;
  var NotImplementedError = kotlin_kotlin.$_$.pe;
  var Json = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.n;
  var joinToString = kotlin_kotlin.$_$.g7;
  var get_authority = kotlin_io_ktor_ktor_http.$_$.b1;
  var putAll = kotlin_io_ktor_ktor_utils.$_$.x;
  var get_supportedCapabilities = kotlin_io_ktor_ktor_client_core.$_$.h;
  var install = kotlin_io_ktor_ktor_client_core.$_$.g;
  var HttpClientEngine = kotlin_io_ktor_ktor_client_core.$_$.i;
  var OnRequestContext = kotlin_io_ktor_ktor_client_core.$_$.j;
  var get_authority_0 = kotlin_io_ktor_ktor_http.$_$.a1;
  var set_port = kotlin_io_ktor_ktor_client_core.$_$.r;
  var createClientPlugin = kotlin_io_ktor_ktor_client_core.$_$.k;
  var convertJwtVcJsonRequest = kotlin_io_curity_ssi_vc_ks_data.$_$.e;
  var convertJwtVcJsonResponse = kotlin_io_curity_ssi_vc_ks_data.$_$.f;
  var convertJwtVcJsonLdRequest = kotlin_io_curity_ssi_vc_ks_data.$_$.c;
  var convertJwtVcJsonLdResponse = kotlin_io_curity_ssi_vc_ks_data.$_$.d;
  var convertLdpVcJsonRequest = kotlin_io_curity_ssi_vc_ks_data.$_$.g;
  var convertLdpVcJsonResponse = kotlin_io_curity_ssi_vc_ks_data.$_$.h;
  var inner = kotlin_io_curity_ssi_vc_ks_data.$_$.n;
  var CancellationException = kotlin_kotlin.$_$.y8;
  var CancellationException_init_$Init$ = kotlin_kotlin.$_$.a1;
  var captureStack = kotlin_kotlin.$_$.t9;
  var promise = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.h1;
  var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.w;
  var printStackTrace = kotlin_kotlin.$_$.tf;
  var getRootCause = kotlin_io_curity_ssi_vc_ks_data.$_$.m;
  var EventListener = kotlin_org_jetbrains_kotlin_kotlin_dom_api_compat.$_$.a;
  var appendParameters = kotlin_io_curity_ssi_oauth.$_$.i;
  var Exception = kotlin_kotlin.$_$.ke;
  var Companion_instance_7 = kotlin_kotlin.$_$.c5;
  var _Result___init__impl__xyqfz8 = kotlin_kotlin.$_$.z2;
  var parameters = kotlin_io_ktor_ktor_http.$_$.m1;
  var formUrlEncode = kotlin_io_ktor_ktor_http.$_$.i1;
  var intercepted = kotlin_kotlin.$_$.b9;
  var CancellableContinuationImpl = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.r;
  var returnIfSuspended = kotlin_kotlin.$_$.k;
  var OAuthAuthorizationResponse = kotlin_io_curity_ssi_oauth.$_$.d;
  var GlobalScope_instance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.l;
  var createJsCredentialIssuer = kotlin_io_curity_ssi_vc_ks_data.$_$.k;
  var JsCredentialIssuer = kotlin_io_curity_ssi_vc_ks_data.$_$.a;
  var copyToArray = kotlin_kotlin.$_$.o6;
  var inner_0 = kotlin_io_curity_ssi_vc_ks_data.$_$.p;
  var createJsUserVerifiableCredential = kotlin_io_curity_ssi_vc_ks_data.$_$.l;
  var createJsCredentialIssuerSupportedCredential = kotlin_io_curity_ssi_vc_ks_data.$_$.j;
  var lazy = kotlin_kotlin.$_$.qf;
  var defineProp = kotlin_kotlin.$_$.aa;
  var cancel = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.b1;
  var inner_1 = kotlin_io_curity_ssi_vc_ks_data.$_$.o;
  var NativeSigningKey = kotlin_io_curity_ssi_jose.$_$.v;
  var NativeVerificationKey = kotlin_io_curity_ssi_jose.$_$.w;
  var SigningKeyPair = kotlin_io_curity_ssi_jose.$_$.l;
  var coroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.d;
  var KProperty1 = kotlin_kotlin.$_$.ac;
  var getPropertyCallableRef = kotlin_kotlin.$_$.fa;
  var KtMutableMap = kotlin_kotlin.$_$.t5;
  var JsJwsHeaderAndPayload = kotlin_io_curity_ssi_jose.$_$.b;
  var createJSObject = kotlin_io_curity_ssi_vc_ks_data.$_$.i;
  var toList_0 = kotlin_kotlin.$_$.l8;
  var JsPair = kotlin_io_curity_ssi_vc_ks_data.$_$.b;
  var toLong_0 = kotlin_kotlin.$_$.rd;
  var toSet_0 = kotlin_kotlin.$_$.s8;
  //endregion
  //region block: pre-declaration
  initMetadataForObject(ProofOfPossessionBuilder, 'ProofOfPossessionBuilder', VOID, VOID, VOID, [7, 6]);
  initMetadataForCompanion(Companion);
  initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ResolvedOffer, 'ResolvedOffer', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_4});
  initMetadataForCoroutine($startHandleOfferCOROUTINE$0, CoroutineImpl);
  initMetadataForCoroutine($continueHandleOfferCOROUTINE$1, CoroutineImpl);
  initMetadataForCoroutine($requestCredentialsUsingPreAuthorizedCodeCOROUTINE$2, CoroutineImpl);
  initMetadataForCoroutine($requestCredentialsCOROUTINE$3, CoroutineImpl);
  initMetadataForCoroutine($requestCredentialCOROUTINE$4, CoroutineImpl);
  initMetadataForClass(CredentialIssuanceCoordinator, 'CredentialIssuanceCoordinator', VOID, VOID, VOID, [1, 4, 5, 3]);
  initMetadataForClass(OfferResult, 'OfferResult');
  initMetadataForClass(IssuedCredentials, 'IssuedCredentials', VOID, OfferResult);
  initMetadataForObject(InvalidOfferOrUserCode, 'InvalidOfferOrUserCode', VOID, OfferResult);
  initMetadataForCompanion(Companion_0);
  initMetadataForCoroutine($loadCOROUTINE$5, CoroutineImpl);
  initMetadataForClass(DefaultCredentialIssuerLoader, 'DefaultCredentialIssuerLoader', VOID, VOID, VOID, [1]);
  initMetadataForCompanion(Companion_1);
  initMetadataForCoroutine($getCOROUTINE$6, CoroutineImpl);
  initMetadataForClass(DefaultVcSdJwtIssuerMetadataLoader, 'DefaultVcSdJwtIssuerMetadataLoader', VOID, VOID, VOID, [1]);
  initMetadataForClass(DidSubjectVerifiableCredentialResponseValidator, 'DidSubjectVerifiableCredentialResponseValidator', VOID, VOID, VOID, [1]);
  initMetadataForCompanion(Companion_2);
  initMetadataForLambda(JwtVcJsonCredentialWithDidSubjectValidator$validate$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($validateCOROUTINE$7, CoroutineImpl);
  initMetadataForClass(JwtVcJsonCredentialWithDidSubjectValidator, 'JwtVcJsonCredentialWithDidSubjectValidator', VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($validateJwtSignatureCOROUTINE$8, CoroutineImpl);
  initMetadataForObject(JwtCredentialValidationHelper, 'JwtCredentialValidationHelper', VOID, VOID, VOID, [3]);
  initMetadataForClass(InMemoryKeyAliasStore, 'InMemoryKeyAliasStore', InMemoryKeyAliasStore, VOID, VOID, [2, 1]);
  initMetadataForCompanion(Companion_3);
  initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(InMemoryVerifiableCredentialStore, 'InMemoryVerifiableCredentialStore', InMemoryVerifiableCredentialStore, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_5});
  initMetadataForCoroutine($interceptCOROUTINE$9, CoroutineImpl);
  initMetadataForCoroutine($withTokenCOROUTINE$10, CoroutineImpl);
  initMetadataForClass(OAuthTokenInterceptor, 'OAuthTokenInterceptor', VOID, VOID, VOID, [2]);
  initMetadataForFunctionReference(OAuthTokenInterceptor$intercept$ref, VOID, VOID, [2]);
  initMetadataForCoroutine($requestCredentialCOROUTINE$11, CoroutineImpl);
  initMetadataForCoroutine($requestCredentialCOROUTINE$12, CoroutineImpl);
  initMetadataForCoroutine($requestCredentialCOROUTINE$13, CoroutineImpl);
  initMetadataForCoroutine($requestCredentialCOROUTINE$14, CoroutineImpl);
  initMetadataForClass(VcClient, 'VcClient', VOID, VOID, VOID, [1]);
  initMetadataForLambda(VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($validateVcSdJwtCOROUTINE$15, CoroutineImpl);
  initMetadataForClass(VcSdJwtVerifiableCredentialResponseValidator, 'VcSdJwtVerifiableCredentialResponseValidator', VOID, VOID, VOID, [1]);
  initMetadataForClass(CredentialFinderResult, 'CredentialFinderResult');
  initMetadataForClass(InMemoryPreRegisteredClientStore, 'InMemoryPreRegisteredClientStore', InMemoryPreRegisteredClientStore, VOID, VOID, [1, 0]);
  initMetadataForCompanion(Companion_4);
  initMetadataForObject($serializer_1, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(InMemoryRequestJwtStore, 'InMemoryRequestJwtStore', InMemoryRequestJwtStore, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_6});
  initMetadataForCompanion(Companion_5);
  initMetadataForClass(JwtVcJsonIssuer, 'JwtVcJsonIssuer');
  initMetadataForClass(JwtVcJsonType, 'JwtVcJsonType');
  initMetadataForClass(VcSdJwtIssuer, 'VcSdJwtIssuer');
  initMetadataForClass(VcSdJwtType, 'VcSdJwtType');
  initMetadataForClass(OpenIdWalletAuthenticatorCredentialFinder, 'OpenIdWalletAuthenticatorCredentialFinder', VOID, VOID, VOID, [1]);
  initMetadataForCompanion(Companion_6);
  initMetadataForLambda(PresentationResponseCreator$createVpSdJwt$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($createVerifiablePresentationResponseCOROUTINE$19, CoroutineImpl);
  initMetadataForCoroutine($createVerifiablePresentationCOROUTINE$20, CoroutineImpl);
  initMetadataForCoroutine($createVpJwtCOROUTINE$21, CoroutineImpl);
  initMetadataForCoroutine($createVpSdJwtCOROUTINE$22, CoroutineImpl);
  initMetadataForClass(PresentationResponseCreator, 'PresentationResponseCreator', VOID, VOID, VOID, [2, 5, 3, 4]);
  initMetadataForClass(UserSelectedCredentials, 'UserSelectedCredentials');
  initMetadataForClass(UserSelectedCredential, 'UserSelectedCredential');
  initMetadataForClass(PresentationDisclosure, 'PresentationDisclosure');
  initMetadataForCoroutine($fetchRequestObjectJwtCOROUTINE$23, CoroutineImpl);
  initMetadataForCoroutine($postDirectPostAuthorizationResponseCOROUTINE$24, CoroutineImpl);
  initMetadataForClass(VerifierClient, 'VerifierClient', VOID, VOID, VOID, [1, 2]);
  initMetadataForCompanion(Companion_7);
  initMetadataForObject($serializer_2, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(PreRegisteredClient, 'PreRegisteredClient', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_7});
  initMetadataForCompanion(Companion_8);
  initMetadataForObject($serializer_3, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(VpFormat, 'VpFormat', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_8});
  initMetadataForObject(WalletMetadata, 'WalletMetadata');
  initMetadataForCompanion(Companion_9);
  initMetadataForClass(VerifiablePresentationResponseParameters, 'VerifiablePresentationResponseParameters');
  initMetadataForLambda(DefaultRequestObjectJwtValidator$validate$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($validateCOROUTINE$25, CoroutineImpl);
  initMetadataForCoroutine($validateSignatureForPreRegisteredClientCOROUTINE$26, CoroutineImpl);
  initMetadataForCoroutine($fetchJwksCOROUTINE$27, CoroutineImpl);
  initMetadataForClass(DefaultRequestObjectJwtValidator, 'DefaultRequestObjectJwtValidator', VOID, VOID, VOID, [1, 2]);
  initMetadataForLambda(HaipRequestObjectJwtValidator$validate$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($validateCOROUTINE$28, CoroutineImpl);
  initMetadataForClass(HaipRequestObjectJwtValidator, 'HaipRequestObjectJwtValidator', VOID, DefaultRequestObjectJwtValidator, VOID, [1]);
  initMetadataForCompanion(Companion_10);
  initMetadataForObject($serializer_4, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ValidatedRequestJwt, 'ValidatedRequestJwt', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_9});
  initMetadataForClass(JsHttpProxy, 'JsHttpProxy');
  initMetadataForClass(ProxyPluginConfig, 'ProxyPluginConfig', ProxyPluginConfig);
  initMetadataForClass(ProxyEngine, 'ProxyEngine', VOID, VOID, [HttpClientEngine], [1]);
  initMetadataForLambda(ProxyPlugin$lambda$slambda, CoroutineImpl, VOID, [3]);
  initMetadataForLambda(JsVcClient$requestJwtVcJsonCredential$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForLambda(JsVcClient$requestJwtVcJsonLdCredential$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForLambda(JsVcClient$requestLdpVcJsonCredential$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForClass(JsVcClient, 'JsVcClient');
  initMetadataForClass(UserCancellationException, 'UserCancellationException', UserCancellationException, CancellationException);
  initMetadataForLambda(safePromise$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(JsProxy, 'JsProxy');
  initMetadataForCoroutine($authorizeCOROUTINE$29, CoroutineImpl);
  initMetadataForClass(BrowserWindowOAuthAuthorizer, 'BrowserWindowOAuthAuthorizer', BrowserWindowOAuthAuthorizer, VOID, VOID, [2]);
  initMetadataForClass(JsOAuthSupport, 'JsOAuthSupport');
  initMetadataForClass(BrowserWindowOAuthSupport, 'BrowserWindowOAuthSupport', VOID, VOID, VOID, [1]);
  initMetadataForLambda(JsKeyAliasStore$add$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(JsKeyAliasStore$get$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(JsKeyAliasStore, 'JsKeyAliasStore');
  initMetadataForLambda(JsCredentialIssuerLoader$load$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(JsCredentialIssuerLoader, 'JsCredentialIssuerLoader');
  initMetadataForLambda(JsCredentialIssuerStore$upsert$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(JsCredentialIssuerStore$getAll$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(JsCredentialIssuerStore$getById$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(JsCredentialIssuerStore$removeById$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(JsCredentialIssuerStore, 'JsCredentialIssuerStore');
  initMetadataForClass(JsVerifiableCredentialStore, 'JsVerifiableCredentialStore');
  initMetadataForClass(JsResolvedOffer, 'JsResolvedOffer');
  initMetadataForClass(JsTxCode, 'JsTxCode');
  initMetadataForClass(JsOfferResult, 'JsOfferResult');
  initMetadataForLambda(JsCredentialIssuanceCoordinator$startHandleOffer$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(JsCredentialIssuanceCoordinator$continueHandleOffer$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(JsCredentialIssuanceCoordinator$requestCredentials$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(JsCredentialIssuanceCoordinator$startHandleOffer$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForLambda(JsCredentialIssuanceCoordinator$continueHandleOffer$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForLambda(JsCredentialIssuanceCoordinator$requestCredentials$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForClass(JsCredentialIssuanceCoordinator, 'JsCredentialIssuanceCoordinator');
  initMetadataForCompanion(Companion_11);
  initMetadataForClass(LocalStorageCredentialIssuerStore, 'LocalStorageCredentialIssuerStore', LocalStorageCredentialIssuerStore, VOID, VOID, [1, 0]);
  initMetadataForCompanion(Companion_12);
  initMetadataForClass(LocalStorageVerifiableCredentialStore, 'LocalStorageVerifiableCredentialStore');
  initMetadataForClass(JsValidatedRequestJwt, 'JsValidatedRequestJwt');
  initMetadataForClass(JsPresentationDefinition, 'JsPresentationDefinition');
  initMetadataForClass(JsFormat, 'JsFormat');
  initMetadataForClass(JsAlgFormat, 'JsAlgFormat');
  initMetadataForClass(JsProofTypeFormat, 'JsProofTypeFormat');
  initMetadataForClass(JsInputDescriptor, 'JsInputDescriptor');
  initMetadataForClass(JsConstraint, 'JsConstraint');
  initMetadataForClass(JsField, 'JsField');
  initMetadataForCompanion(Companion_13);
  initMetadataForClass(AbstractJsfilter, 'AbstractJsfilter');
  initMetadataForClass(JsStringFilter, 'JsStringFilter', VOID, AbstractJsfilter);
  initMetadataForClass(JsArrayContainsFilter, 'JsArrayContainsFilter', VOID, AbstractJsfilter);
  initMetadataForClass(JsContains, 'JsContains');
  initMetadataForClass(JsVerifiablePresentationResponseParameters, 'JsVerifiablePresentationResponseParameters');
  initMetadataForClass(JsPresentationSubmission, 'JsPresentationSubmission');
  initMetadataForClass(JsDescriptorMapObject, 'JsDescriptorMapObject');
  initMetadataForClass(JsPathNested, 'JsPathNested');
  initMetadataForClass(JsVerifierDirectPostAuthorizationResponse, 'JsVerifierDirectPostAuthorizationResponse');
  initMetadataForClass(JsUserSelectedCredentials, 'JsUserSelectedCredentials');
  initMetadataForClass(JsUserSelectedCredential, 'JsUserSelectedCredential');
  initMetadataForClass(JsPresentationDisclosure, 'JsPresentationDisclosure');
  initMetadataForCompanion(Companion_14);
  initMetadataForLambda(JsPresentationResponseCreator$createVerifiablePresentationResponse$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForClass(JsPresentationResponseCreator, 'JsPresentationResponseCreator');
  initMetadataForClass(JsRequestJwtStore, 'JsRequestJwtStore');
  initMetadataForLambda(JsVerifierClient$fetchRequestObjectJwt$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForLambda(JsVerifierClient$postDirectPostAuthorizationResponse$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForClass(JsVerifierClient, 'JsVerifierClient');
  initMetadataForCompanion(Companion_15);
  initMetadataForClass(LocalStorageRequestJwtStore, 'LocalStorageRequestJwtStore');
  initMetadataForLambda(JsOpenIdWalletAuthenticatorCredentialFinder$find$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForClass(JsOpenIdWalletAuthenticatorCredentialFinder, 'JsOpenIdWalletAuthenticatorCredentialFinder');
  initMetadataForClass(JsCredentialFinderResult, 'JsCredentialFinderResult');
  initMetadataForLambda(JsPreRegisteredClientStore$getByClientId$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForLambda(JsPreRegisteredClientStore$upsert$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForLambda(JsPreRegisteredClientStore$getAll$slambda, CoroutineImpl, VOID, [0]);
  initMetadataForClass(JsPreRegisteredClientStore, 'JsPreRegisteredClientStore');
  initMetadataForClass(JsPreRegisteredClient, 'JsPreRegisteredClient');
  initMetadataForClass(JsVpFormat, 'JsVpFormat');
  //endregion
  function ProofOfPossessionBuilder() {
  }
  protoOf(ProofOfPossessionBuilder).z5x = function (signingKeyPair, kid, alg, iss, aud, iat, additionalClaims, $completion) {
    var tmp0_kid = kid.toString();
    var jwsHeader = new JsonJwsHeader(alg, 'openid4vci-proof+jwt', VOID, VOID, VOID, tmp0_kid);
    var jwsPayload = new JsonJwtClaimsSet(iss, VOID, aud, VOID, VOID, iat.f1m(), VOID, VOID, additionalClaims);
    return JwsUtil_getInstance().j2d(signingKeyPair.u28_1, jwsHeader, jwsPayload, $completion);
  };
  protoOf(ProofOfPossessionBuilder).a5y = function (signingKeyPair, alg, iss, aud, iat, additionalClaims, $completion) {
    var tmp1_jwk = signingKeyPair.v28_1.u2f();
    var jwsHeader = new JsonJwsHeader(alg, 'openid4vci-proof+jwt', VOID, VOID, tmp1_jwk);
    var jwsPayload = new JsonJwtClaimsSet(iss, VOID, aud, VOID, VOID, iat.f1m(), VOID, VOID, additionalClaims);
    return JwsUtil_getInstance().j2d(signingKeyPair.u28_1, jwsHeader, jwsPayload, $completion);
  };
  var ProofOfPossessionBuilder_instance;
  function ProofOfPossessionBuilder_getInstance() {
    return ProofOfPossessionBuilder_instance;
  }
  function Companion() {
    Companion_instance_8 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.b5y_1 = [null, null, new ArrayListSerializer(JsonSupportedCredentialSerializer_getInstance()), null];
  }
  var Companion_instance_8;
  function Companion_getInstance_6() {
    if (Companion_instance_8 == null)
      new Companion();
    return Companion_instance_8;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vc.serialization.ResolvedOffer', this, 4);
    tmp0_serialDesc.wy('offer', false);
    tmp0_serialDesc.wy('issuer', false);
    tmp0_serialDesc.wy('credentialsSupported', false);
    tmp0_serialDesc.wy('txCode', true);
    this.c5y_1 = tmp0_serialDesc;
  }
  protoOf($serializer).d5y = function (encoder, value) {
    var tmp0_desc = this.c5y_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    var tmp2_cached = Companion_getInstance_6().b5y_1;
    tmp1_output.bt(tmp0_desc, 0, $serializer_getInstance(), value.e5y_1);
    tmp1_output.bt(tmp0_desc, 1, $serializer_getInstance_0(), value.f5y_1);
    tmp1_output.bt(tmp0_desc, 2, tmp2_cached[2], value.g5y_1);
    var tmp;
    if (tmp1_output.ht(tmp0_desc, 3)) {
      tmp = true;
    } else {
      var tmp2_safe_receiver = value.e5y_1.j32_1;
      var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.d32_1;
      tmp = !equals(value.h5y_1, tmp3_safe_receiver == null ? null : tmp3_safe_receiver.x31_1);
    }
    if (tmp) {
      tmp1_output.dt(tmp0_desc, 3, $serializer_getInstance_1(), value.h5y_1);
    }
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer).zn = function (encoder, value) {
    return this.d5y(encoder, value instanceof ResolvedOffer ? value : THROW_CCE());
  };
  protoOf($serializer).ao = function (decoder) {
    var tmp0_desc = this.c5y_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.lr(tmp0_desc);
    var tmp9_cached = Companion_getInstance_6().b5y_1;
    if (tmp8_input.as()) {
      tmp4_local0 = tmp8_input.xr(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.xr(tmp0_desc, 1, $serializer_getInstance_0(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.xr(tmp0_desc, 2, tmp9_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.zr(tmp0_desc, 3, $serializer_getInstance_1(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.xr(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.xr(tmp0_desc, 1, $serializer_getInstance_0(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.xr(tmp0_desc, 2, tmp9_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.zr(tmp0_desc, 3, $serializer_getInstance_1(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.mr(tmp0_desc);
    return ResolvedOffer_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer).yn = function () {
    return this.c5y_1;
  };
  protoOf($serializer).lz = function () {
    var tmp0_cached = Companion_getInstance_6().b5y_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance(), $serializer_getInstance_0(), tmp0_cached[2], get_nullable($serializer_getInstance_1())];
  };
  var $serializer_instance;
  function $serializer_getInstance_4() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function ResolvedOffer_init_$Init$(seen0, offer, issuer, credentialsSupported, txCode, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_4().c5y_1);
    }
    $this.e5y_1 = offer;
    $this.f5y_1 = issuer;
    $this.g5y_1 = credentialsSupported;
    if (0 === (seen0 & 8)) {
      var tmp = $this;
      var tmp2_safe_receiver = $this.e5y_1.j32_1;
      var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.d32_1;
      tmp.h5y_1 = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.x31_1;
    } else
      $this.h5y_1 = txCode;
    return $this;
  }
  function ResolvedOffer_init_$Create$(seen0, offer, issuer, credentialsSupported, txCode, serializationConstructorMarker) {
    return ResolvedOffer_init_$Init$(seen0, offer, issuer, credentialsSupported, txCode, serializationConstructorMarker, objectCreate(protoOf(ResolvedOffer)));
  }
  function ResolvedOffer(offer, issuer, credentialsSupported) {
    Companion_getInstance_6();
    this.e5y_1 = offer;
    this.f5y_1 = issuer;
    this.g5y_1 = credentialsSupported;
    var tmp = this;
    var tmp2_safe_receiver = this.e5y_1.j32_1;
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.d32_1;
    tmp.h5y_1 = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.x31_1;
  }
  protoOf(ResolvedOffer).toString = function () {
    return 'ResolvedOffer(offer=' + this.e5y_1.toString() + ', issuer=' + this.f5y_1.toString() + ', credentialsSupported=' + toString(this.g5y_1) + ')';
  };
  protoOf(ResolvedOffer).hashCode = function () {
    var result = this.e5y_1.hashCode();
    result = imul(result, 31) + this.f5y_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.g5y_1) | 0;
    return result;
  };
  protoOf(ResolvedOffer).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ResolvedOffer))
      return false;
    var tmp0_other_with_cast = other instanceof ResolvedOffer ? other : THROW_CCE();
    if (!this.e5y_1.equals(tmp0_other_with_cast.e5y_1))
      return false;
    if (!this.f5y_1.equals(tmp0_other_with_cast.f5y_1))
      return false;
    if (!equals(this.g5y_1, tmp0_other_with_cast.g5y_1))
      return false;
    return true;
  };
  function requestCredentialsUsingPreAuthorizedCode($this, issuer, credentialSupported, preAuthorizedCode, code, signingKeyPair, $completion) {
    var tmp = new $requestCredentialsUsingPreAuthorizedCodeCOROUTINE$2($this, issuer, credentialSupported, preAuthorizedCode, code, signingKeyPair, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  }
  function requestCredential($this, tokenResponse, refreshFlowClient, issuer, signingKeyPair, credentialSupported, $completion) {
    var tmp = new $requestCredentialCOROUTINE$4($this, tokenResponse, refreshFlowClient, issuer, signingKeyPair, credentialSupported, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  }
  function CredentialIssuanceCoordinator$startHandleOffer$lambda($this$HttpClient) {
    var tmp = Plugin_getInstance();
    $this$HttpClient.t4u(tmp, CredentialIssuanceCoordinator$startHandleOffer$lambda$lambda);
    return Unit_instance;
  }
  function CredentialIssuanceCoordinator$startHandleOffer$lambda$lambda($this$install) {
    json($this$install);
    return Unit_instance;
  }
  function CredentialIssuanceCoordinator$requestCredential$lambda($this$HttpClient) {
    var tmp = Plugin_getInstance();
    $this$HttpClient.t4u(tmp, CredentialIssuanceCoordinator$requestCredential$lambda$lambda);
    return Unit_instance;
  }
  function CredentialIssuanceCoordinator$requestCredential$lambda$lambda($this$install) {
    json($this$install);
    return Unit_instance;
  }
  function $startHandleOfferCOROUTINE$0(_this__u8e3s4, offerString, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.f60_1 = _this__u8e3s4;
    this.g60_1 = offerString;
  }
  protoOf($startHandleOfferCOROUTINE$0).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 5;
            this.h60_1 = URLBuilder(this.g60_1).c3r().d4h_1;
            this.i60_1 = this.h60_1.l43('credential_offer');
            this.j60_1 = this.h60_1.l43('credential_offer_uri');
            if (!(this.i60_1 == null) && !(this.j60_1 == null)) {
              throw Exception_init_$Create$("both 'credential_offer' and 'credential_offer_uri' are present");
            }

            if (!(this.j60_1 == null)) {
              var tmp_0 = this;
              var tmp4_safe_receiver = singleOrNull(this.j60_1);
              var tmp_1;
              if (tmp4_safe_receiver == null) {
                tmp_1 = null;
              } else {
                tmp_1 = URLBuilder(tmp4_safe_receiver).c3r();
              }
              var tmp0_elvis_lhs = tmp_1;
              var tmp_2;
              if (tmp0_elvis_lhs == null) {
                throw Exception_init_$Create$("'credential_offer_uri' is empty or has more than one value");
              } else {
                tmp_2 = tmp0_elvis_lhs;
              }
              tmp_0.l60_1 = tmp_2;
              var tmp_3 = this;
              tmp_3.m60_1 = HttpClient(this.f60_1.c61_1, CredentialIssuanceCoordinator$startHandleOffer$lambda);
              var tmp_4 = this;
              tmp_4.n60_1 = this.m60_1;
              var tmp_5 = this;
              tmp_5.o60_1 = this.l60_1;
              var tmp_6 = this;
              tmp_6.p60_1 = this.n60_1;
              var tmp_7 = this;
              tmp_7.q60_1 = this.p60_1;
              var tmp_8 = this;
              var this_0 = new HttpRequestBuilder();
              takeFrom(this_0.m4t_1, this.o60_1);
              tmp_8.r60_1 = this_0;
              this.r60_1.n4t_1 = Companion_getInstance().n4d_1;
              var tmp_9 = this;
              tmp_9.s60_1 = this.q60_1;
              var tmp_10 = this;
              tmp_10.t60_1 = this.r60_1;
              this.v8_1 = 1;
              suspendResult = (new HttpStatement(this.t60_1, this.s60_1)).q5i(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (!(this.i60_1 == null)) {
                var tmp_11 = this;
                var tmp5_safe_receiver = singleOrNull(this.i60_1);
                var tmp_12;
                if (tmp5_safe_receiver == null) {
                  tmp_12 = null;
                } else {
                  var this_1 = Default_getInstance();
                  var this_2 = this_1.dp();
                  var this_3 = serializer(this_2, createKType(getKClass(JsonOffer), arrayOf([]), false));
                  tmp_12 = this_1.cp(isInterface(this_3, KSerializer) ? this_3 : THROW_CCE(), tmp5_safe_receiver);
                }
                var tmp1_elvis_lhs = tmp_12;
                var tmp_13;
                if (tmp1_elvis_lhs == null) {
                  throw Exception_init_$Create$("'credential_offer' is empty or has more than one value");
                } else {
                  tmp_13 = tmp1_elvis_lhs;
                }
                tmp_11.k60_1 = tmp_13;
                this.v8_1 = 3;
                continue $sm;
              } else {
                var tmp_14 = this;
                throw Exception_init_$Create$("both 'credential_offer' and 'credential_offer_uri' are missing");
              }
            }

          case 1:
            this.u60_1 = suspendResult;
            if (!(this.u60_1.y4v().h4g_1 === 200)) {
              throw Exception_init_$Create$('Communication error while fetching the offer');
            }

            var tmp_15 = this;
            tmp_15.v60_1 = this.u60_1;
            this.v8_1 = 2;
            var tmp_16 = this.v60_1.t4w();
            var tmp_17 = JsType_instance;
            var tmp_18 = getKClass(JsonOffer);
            var tmp_19;
            try {
              tmp_19 = createKType(getKClass(JsonOffer), arrayOf([]), false);
            } catch ($p) {
              var tmp_20;
              if ($p instanceof Error) {
                var cause = $p;
                tmp_20 = null;
              } else {
                throw $p;
              }
              tmp_19 = tmp_20;
            }

            suspendResult = tmp_16.x4v(typeInfoImpl(tmp_17, tmp_18, tmp_19), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp_21 = this;
            tmp_21.k60_1 = suspendResult instanceof JsonOffer ? suspendResult : THROW_CCE();
            this.v8_1 = 3;
            continue $sm;
          case 3:
            this.w60_1 = this.k60_1;
            this.x60_1 = this.w60_1.j32_1;
            if (this.x60_1 == null || (this.x60_1.c32_1 == null && this.x60_1.d32_1 == null)) {
              throw Exception_init_$Create$('Not enough grant information');
            }

            this.v8_1 = 4;
            suspendResult = this.f60_1.d61_1.g61(this.w60_1.h32_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            var issuer = suspendResult;
            var this_4 = this.w60_1.i32_1;
            var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_4, 10));
            var tmp0_iterator = this_4.j();
            while (tmp0_iterator.k()) {
              var item = tmp0_iterator.l();
              var tmp0_elvis_lhs_0 = issuer.t32_1.t33_1.e2(item);
              var tmp_22;
              if (tmp0_elvis_lhs_0 == null) {
                throw Exception_init_$Create$("Issue does not have supported Credential with ID '" + item + "'");
              } else {
                tmp_22 = tmp0_elvis_lhs_0;
              }
              destination.e(tmp_22);
            }

            var credentialsSupported = destination;
            var resolvedOffer = new ResolvedOffer(this.w60_1, issuer, credentialsSupported);
            return resolvedOffer;
          case 5:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 5) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function $continueHandleOfferCOROUTINE$1(_this__u8e3s4, resolvedOffer, credentialsSupported, code, signingKeyPair, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.p61_1 = _this__u8e3s4;
    this.q61_1 = resolvedOffer;
    this.r61_1 = credentialsSupported;
    this.s61_1 = code;
    this.t61_1 = signingKeyPair;
  }
  protoOf($continueHandleOfferCOROUTINE$1).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 4;
            this.u61_1 = this.q61_1.e5y_1;
            this.v61_1 = this.u61_1.j32_1;
            if (this.v61_1 == null || (this.v61_1.c32_1 == null && this.v61_1.d32_1 == null)) {
              throw Exception_init_$Create$('Not enough grant information');
            }

            if (!(this.q61_1.h5y_1 == null) && this.s61_1 == null) {
              throw Exception_init_$Create$('User code is required');
            }

            this.w61_1 = this.v61_1.d32_1;
            if (!(this.w61_1 == null) && (this.w61_1.x31_1 == null || !(this.s61_1 == null))) {
              this.v8_1 = 2;
              suspendResult = requestCredentialsUsingPreAuthorizedCode(this.p61_1, this.q61_1.f5y_1, first(this.r61_1), this.w61_1.w31_1, this.s61_1, this.t61_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (!(this.v61_1.c32_1 == null)) {
                this.v8_1 = 1;
                suspendResult = this.p61_1.y61(this.q61_1.f5y_1, first(this.r61_1), this.t61_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_0 = this;
                throw Exception_init_$Create$('No grant available');
              }
            }

          case 1:
            var ARGUMENT = suspendResult;
            this.x61_1 = new IssuedCredentials(ARGUMENT);
            this.v8_1 = 3;
            continue $sm;
          case 2:
            this.x61_1 = suspendResult;
            this.v8_1 = 3;
            continue $sm;
          case 3:
            return this.x61_1;
          case 4:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 4) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function $requestCredentialsUsingPreAuthorizedCodeCOROUTINE$2(_this__u8e3s4, issuer, credentialSupported, preAuthorizedCode, code, signingKeyPair, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.q5y_1 = _this__u8e3s4;
    this.r5y_1 = issuer;
    this.s5y_1 = credentialSupported;
    this.t5y_1 = preAuthorizedCode;
    this.u5y_1 = code;
    this.v5y_1 = signingKeyPair;
  }
  protoOf($requestCredentialsUsingPreAuthorizedCodeCOROUTINE$2).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 4;
            this.w5y_1 = new OAuthPreAuthorizedCodeFlowClient(this.q5y_1.c61_1, this.q5y_1.z60_1, this.r5y_1.u32_1.t35_1);
            this.v8_1 = 1;
            suspendResult = this.w5y_1.j5x(this.t5y_1, this.u5y_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.x5y_1 = suspendResult;
            var tmp_0 = this.x5y_1;
            if (tmp_0 instanceof JsonOAuthSuccessTokenResponse) {
              this.z5y_1 = new OAuthRefreshFlowClient(this.q5y_1.c61_1, this.q5y_1.z60_1, this.r5y_1.u32_1.t35_1);
              this.v8_1 = 2;
              suspendResult = requestCredential(this.q5y_1, this.x5y_1, this.z5y_1, this.r5y_1, this.v5y_1, this.s5y_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_1 = this.x5y_1;
              if (tmp_1 instanceof JsonOAuthErrorTokenResponse) {
                var tmp_2 = this;
                var tmp_3;
                if (this.x5y_1.c5v_1 === 'invalid_grant') {
                  tmp_3 = InvalidOfferOrUserCode_getInstance();
                } else {
                  throw Exception_init_$Create$('Unexpected error when using the pre-authorized code flow: ' + this.x5y_1.c5v_1);
                }
                tmp_2.y5y_1 = tmp_3;
                this.v8_1 = 3;
                continue $sm;
              } else {
                var tmp_4 = this;
                noWhenBranchMatchedException();
              }
            }

            break;
          case 2:
            var ARGUMENT = suspendResult;
            this.y5y_1 = new IssuedCredentials(ARGUMENT);
            this.v8_1 = 3;
            continue $sm;
          case 3:
            return this.y5y_1;
          case 4:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 4) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function $requestCredentialsCOROUTINE$3(_this__u8e3s4, issuer, credentialSupported, signingKeyPair, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.h62_1 = _this__u8e3s4;
    this.i62_1 = issuer;
    this.j62_1 = credentialSupported;
    this.k62_1 = signingKeyPair;
  }
  protoOf($requestCredentialsCOROUTINE$3).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 4;
            var tmp_0 = this;
            var tmp6_subject = this.j62_1;
            var tmp_1;
            if (tmp6_subject instanceof JwtVcJsonCredentialConfigurationsSupported) {
              var this_0 = this.h62_1.f61_1;
              var value = listOf(JwtVcJsonAuthorizationDetail_init_$Create$(toSet(this.j62_1.i39_1.s39_1), null));
              var this_1 = this_0.dp();
              var this_2 = serializer(this_1, createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(JwtVcJsonAuthorizationDetail), arrayOf([]), false))]), false));
              tmp_1 = this_0.bp(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), value);
            } else {
              if (tmp6_subject instanceof VcSdJwtCredentialConfigurationsSupported) {
                var this_3 = this.h62_1.f61_1;
                var value_0 = listOf(VcSdJwtAuthorizationDetail_init_$Create$(this.j62_1.n37_1, null));
                var this_4 = this_3.dp();
                var this_5 = serializer(this_4, createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(VcSdJwtAuthorizationDetail), arrayOf([]), false))]), false));
                tmp_1 = this_3.bp(isInterface(this_5, KSerializer) ? this_5 : THROW_CCE(), value_0);
              } else {
                throw Exception_init_$Create$("Format '" + this.j62_1.z33() + "' is not supported");
              }
            }

            tmp_0.l62_1 = tmp_1;
            var tmp_2 = this;
            var tmp7_clientId = this.h62_1.z60_1.id;
            var tmp8_redirectUri = this.h62_1.z60_1.redirectUri;
            var tmp9_state = encodeBase64url(Default_getInstance_0().fh(16));
            tmp_2.m62_1 = new OAuthAuthorizationRequest(tmp7_clientId, this.l62_1, VOID, tmp9_state, tmp8_redirectUri);
            this.v8_1 = 1;
            suspendResult = this.h62_1.b61_1.s62(this.i62_1.u32_1.s35_1, this.m62_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.n62_1 = suspendResult;
            if (!(this.n62_1.state === this.m62_1.state)) {
              throw Exception_init_$Create$('Authorization response state is not valid.');
            }

            var tmp_3 = this;
            var tmp0_elvis_lhs = this.n62_1.code;
            var tmp_4;
            if (tmp0_elvis_lhs == null) {
              throw Exception_init_$Create$('authorization response is missing a code');
            } else {
              tmp_4 = tmp0_elvis_lhs;
            }

            tmp_3.o62_1 = tmp_4;
            this.p62_1 = new OAuthCodeFlowClient(this.h62_1.c61_1, this.h62_1.z60_1, this.i62_1.u32_1.t35_1);
            this.q62_1 = new OAuthRefreshFlowClient(this.h62_1.c61_1, this.h62_1.z60_1, this.i62_1.u32_1.t35_1);
            this.v8_1 = 2;
            suspendResult = this.p62_1.p5w(this.o62_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.r62_1 = suspendResult;
            this.v8_1 = 3;
            suspendResult = requestCredential(this.h62_1, this.r62_1, this.q62_1, this.i62_1, this.k62_1, this.j62_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            return suspendResult;
          case 4:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 4) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function $requestCredentialCOROUTINE$4(_this__u8e3s4, tokenResponse, refreshFlowClient, issuer, signingKeyPair, credentialSupported, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.i5z_1 = _this__u8e3s4;
    this.j5z_1 = tokenResponse;
    this.k5z_1 = refreshFlowClient;
    this.l5z_1 = issuer;
    this.m5z_1 = signingKeyPair;
    this.n5z_1 = credentialSupported;
  }
  protoOf($requestCredentialCOROUTINE$4).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 7;
            var tmp_0 = this;
            var tmp0_elvis_lhs = this.j5z_1.w5u_1;
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              throw Exception_init_$Create$('token response is missing the c_nonce');
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0.o5z_1 = tmp_1;
            var tmp_2 = this;
            tmp_2.p5z_1 = HttpClient(this.i5z_1.c61_1, CredentialIssuanceCoordinator$requestCredential$lambda);
            installOAuthSupport(this.p5z_1, this.j5z_1, this.k5z_1);
            this.q5z_1 = this.n5z_1;
            var tmp_3 = this.q5z_1;
            if (tmp_3 instanceof JwtVcJsonCredentialConfigurationsSupported) {
              this.v8_1 = 2;
              suspendResult = ProofOfPossessionBuilder_instance.z5x(this.m5z_1, JwkDid_instance.w3l(this.m5z_1.v28_1), 'ES256', this.i5z_1.z60_1.id, DefaultJsonMultiValue_init_$Create$(this.l5z_1.t32_1.u33_1), this.i5z_1.y60_1.u1l(), mapOf(to('nonce', JsonPrimitive(this.o5z_1))), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_4 = this.q5z_1;
              if (tmp_4 instanceof VcSdJwtCredentialConfigurationsSupported) {
                this.v8_1 = 1;
                suspendResult = ProofOfPossessionBuilder_instance.a5y(this.m5z_1, 'ES256', this.i5z_1.z60_1.id, DefaultJsonMultiValue_init_$Create$(this.l5z_1.t32_1.u33_1), this.i5z_1.y60_1.u1l(), mapOf(to('nonce', JsonPrimitive(this.o5z_1))), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_5 = this;
                throw Exception_init_$Create$('Unsupported supported credential ' + getKClassFromExpression(this.n5z_1).fa());
              }
            }

          case 1:
            this.r5z_1 = suspendResult;
            this.v8_1 = 3;
            continue $sm;
          case 2:
            this.r5z_1 = suspendResult;
            this.v8_1 = 3;
            continue $sm;
          case 3:
            this.s5z_1 = this.r5z_1;
            this.t5z_1 = this.n5z_1;
            var tmp_6 = this.t5z_1;
            if (tmp_6 instanceof JwtVcJsonCredentialConfigurationsSupported) {
              this.v5z_1 = new VcClient(this.p5z_1, this.l5z_1.t32_1, new DidSubjectVerifiableCredentialResponseValidator(this.l5z_1, JwkDid_instance.w3l(this.m5z_1.v28_1), VOID, this.n5z_1, this.i5z_1.a61_1));
              this.v8_1 = 5;
              var tmp12_credentialDefinition = new CredentialDefinition(this.n5z_1.i39_1.s39_1);
              var tmp13_proof = new JsonProofOfPossession('jwt', new JsonDictionary(mapOf(to('jwt', JsonPrimitive(this.s5z_1)))));
              suspendResult = this.v5z_1.y62(new JwtVcJsonVerifiableCredentialRequest(tmp13_proof, tmp12_credentialDefinition), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_7 = this.t5z_1;
              if (tmp_7 instanceof VcSdJwtCredentialConfigurationsSupported) {
                this.w5z_1 = new VcClient(this.p5z_1, this.l5z_1.t32_1, new VcSdJwtVerifiableCredentialResponseValidator(this.i5z_1.y60_1, this.i5z_1.e61_1, this.l5z_1, this.n5z_1, this.m5z_1));
                this.v8_1 = 4;
                var tmp14_vct = this.n5z_1.n37_1;
                var tmp15_proof = new JsonProofOfPossession('jwt', new JsonDictionary(mapOf(to('jwt', JsonPrimitive(this.s5z_1)))));
                suspendResult = this.w5z_1.x62(new VcSdJwtVerifiableCredentialRequest(tmp15_proof, tmp14_vct), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_8 = this;
                throw Exception_init_$Create$('Unsupported credential ' + getKClassFromExpression(this.n5z_1).fa());
              }
            }

          case 4:
            this.u5z_1 = suspendResult;
            this.v8_1 = 6;
            continue $sm;
          case 5:
            this.u5z_1 = suspendResult;
            this.v8_1 = 6;
            continue $sm;
          case 6:
            var validatedResponse = this.u5z_1;
            var tmp16_localId = Companion_getInstance_0().x32();
            var tmp17_issuerId = this.l5z_1.t32_1.u33_1;
            var tmp18_issuedAt = System_instance.u1l();
            return listOf(new UserVerifiableCredential(tmp16_localId, tmp17_issuerId, tmp18_issuedAt, '', validatedResponse));
          case 7:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 7) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function CredentialIssuanceCoordinator(clock, oAuthClient, didResolver, oAuthAuthorizer, httpClientEngine, issuerLoader, vcSdJwtIssuerMetadataLoader) {
    this.y60_1 = clock;
    this.z60_1 = oAuthClient;
    this.a61_1 = didResolver;
    this.b61_1 = oAuthAuthorizer;
    this.c61_1 = httpClientEngine;
    this.d61_1 = issuerLoader;
    this.e61_1 = vcSdJwtIssuerMetadataLoader;
    this.f61_1 = Default_getInstance();
  }
  protoOf(CredentialIssuanceCoordinator).z62 = function (offerString, $completion) {
    var tmp = new $startHandleOfferCOROUTINE$0(this, offerString, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(CredentialIssuanceCoordinator).a63 = function (resolvedOffer, credentialsSupported, code, signingKeyPair, $completion) {
    var tmp = new $continueHandleOfferCOROUTINE$1(this, resolvedOffer, credentialsSupported, code, signingKeyPair, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(CredentialIssuanceCoordinator).y61 = function (issuer, credentialSupported, signingKeyPair, $completion) {
    var tmp = new $requestCredentialsCOROUTINE$3(this, issuer, credentialSupported, signingKeyPair, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  function IssuedCredentials(credentials) {
    OfferResult.call(this);
    this.b63_1 = credentials;
  }
  protoOf(IssuedCredentials).toString = function () {
    return 'IssuedCredentials(credentials=' + toString(this.b63_1) + ')';
  };
  protoOf(IssuedCredentials).hashCode = function () {
    return hashCode(this.b63_1);
  };
  protoOf(IssuedCredentials).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof IssuedCredentials))
      return false;
    var tmp0_other_with_cast = other instanceof IssuedCredentials ? other : THROW_CCE();
    if (!equals(this.b63_1, tmp0_other_with_cast.b63_1))
      return false;
    return true;
  };
  function InvalidOfferOrUserCode() {
    InvalidOfferOrUserCode_instance = this;
    OfferResult.call(this);
  }
  protoOf(InvalidOfferOrUserCode).toString = function () {
    return 'InvalidOfferOrUserCode';
  };
  protoOf(InvalidOfferOrUserCode).hashCode = function () {
    return -1674259812;
  };
  protoOf(InvalidOfferOrUserCode).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof InvalidOfferOrUserCode))
      return false;
    other instanceof InvalidOfferOrUserCode || THROW_CCE();
    return true;
  };
  var InvalidOfferOrUserCode_instance;
  function InvalidOfferOrUserCode_getInstance() {
    if (InvalidOfferOrUserCode_instance == null)
      new InvalidOfferOrUserCode();
    return InvalidOfferOrUserCode_instance;
  }
  function OfferResult() {
  }
  function metadataUrlForIssuerId($this, id) {
    var idUrl = URLBuilder(id).c3r();
    if (!idUrl.z4g_1.equals(Companion_getInstance_1().r4h_1)) {
      throw Exception_init_$Create$('Invalid Issuer identifier - must use HTTPS');
    }
    // Inline function 'kotlin.apply' call
    var this_0 = URLBuilder_0(idUrl);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'io.curity.vc.services.Companion.metadataUrlForIssuerId.<anonymous>' call
    this_0.a4i(plus(this_0.b4i(), Companion_getInstance_7().c63_1));
    return this_0.c3r();
  }
  function metadataUrlForAuthorizationServerId($this, id) {
    var idUrl = URLBuilder(id).c3r();
    if (!idUrl.z4g_1.equals(Companion_getInstance_1().r4h_1)) {
      throw Exception_init_$Create$('Invalid Authorization Server identifier - must use HTTPS');
    }
    // Inline function 'kotlin.apply' call
    var this_0 = URLBuilder_0(idUrl);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'io.curity.vc.services.Companion.metadataUrlForAuthorizationServerId.<anonymous>' call
    this_0.a4i(plus(Companion_getInstance_7().d63_1, removeTrailingEmptySegments(Companion_getInstance_7(), this_0.b4i())));
    return this_0.c3r();
  }
  function removeTrailingEmptySegments($this, segments) {
    var tmp$ret$0;
    $l$block_1: {
      // Inline function 'kotlin.collections.takeLastWhile' call
      if (segments.s()) {
        tmp$ret$0 = emptyList();
        break $l$block_1;
      }
      var iterator = segments.w(segments.m());
      while (iterator.s4()) {
        // Inline function 'io.curity.vc.services.Companion.removeTrailingEmptySegments.<anonymous>' call
        // Inline function 'kotlin.text.isNotBlank' call
        var this_0 = iterator.u4();
        if (!!isBlank(this_0)) {
          iterator.l();
          var expectedSize = segments.m() - iterator.t4() | 0;
          if (expectedSize === 0) {
            tmp$ret$0 = emptyList();
            break $l$block_1;
          }
          // Inline function 'kotlin.apply' call
          var this_1 = ArrayList_init_$Create$(expectedSize);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'kotlin.collections.takeLastWhile.<anonymous>' call
          while (iterator.k()) {
            this_1.e(iterator.l());
          }
          tmp$ret$0 = this_1;
          break $l$block_1;
        }
      }
      tmp$ret$0 = toList(segments);
    }
    return tmp$ret$0;
  }
  function Companion_0() {
    Companion_instance_9 = this;
    this.c63_1 = listOf_0(['.well-known', 'openid-credential-issuer']);
    this.d63_1 = listOf_0(['.well-known', 'oauth-authorization-server']);
  }
  var Companion_instance_9;
  function Companion_getInstance_7() {
    if (Companion_instance_9 == null)
      new Companion_0();
    return Companion_instance_9;
  }
  function $loadCOROUTINE$5(_this__u8e3s4, issuerId, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.m63_1 = _this__u8e3s4;
    this.n63_1 = issuerId;
  }
  protoOf($loadCOROUTINE$5).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 5;
            this.o63_1 = metadataUrlForIssuerId(Companion_getInstance_7(), this.n63_1);
            var tmp_0 = this;
            tmp_0.p63_1 = this.m63_1.m64_1;
            var tmp_1 = this;
            tmp_1.q63_1 = this.o63_1;
            var tmp_2 = this;
            tmp_2.r63_1 = this.p63_1;
            var tmp_3 = this;
            tmp_3.s63_1 = this.r63_1;
            var tmp_4 = this;
            var this_0 = new HttpRequestBuilder();
            takeFrom(this_0.m4t_1, this.q63_1);
            tmp_4.t63_1 = this_0;
            this.t63_1.n4t_1 = Companion_getInstance().n4d_1;
            var tmp_5 = this;
            tmp_5.u63_1 = this.s63_1;
            var tmp_6 = this;
            tmp_6.v63_1 = this.t63_1;
            this.v8_1 = 1;
            suspendResult = (new HttpStatement(this.v63_1, this.u63_1)).q5i(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.w63_1 = suspendResult;
            var tmp_7 = this;
            tmp_7.x63_1 = this.w63_1;
            if (!isSuccess(this.x63_1.y4v())) {
              throw Exception_init_$Create$('Error ' + this.x63_1.y4v().h4g_1 + ' while accessing ' + this.o63_1.toString());
            }

            var tmp_8 = this;
            tmp_8.y63_1 = this.x63_1;
            this.v8_1 = 2;
            var tmp_9 = this.y63_1.t4w();
            var tmp_10 = JsType_instance;
            var tmp_11 = getKClass(JsonCredentialIssuerMetadata);
            var tmp_12;
            try {
              tmp_12 = createKType(getKClass(JsonCredentialIssuerMetadata), arrayOf([]), false);
            } catch ($p) {
              var tmp_13;
              if ($p instanceof Error) {
                var cause = $p;
                tmp_13 = null;
              } else {
                throw $p;
              }
              tmp_12 = tmp_13;
            }

            suspendResult = tmp_9.x4v(typeInfoImpl(tmp_10, tmp_11, tmp_12), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp_14 = this;
            tmp_14.z63_1 = suspendResult instanceof JsonCredentialIssuerMetadata ? suspendResult : THROW_CCE();
            var tmp_15 = this;
            var tmp_16 = Companion_getInstance_7();
            var tmp19_safe_receiver = this.z63_1.o33_1;
            var tmp0_elvis_lhs = tmp19_safe_receiver == null ? null : getOrNull(tmp19_safe_receiver, 0);
            tmp_15.a64_1 = metadataUrlForAuthorizationServerId(tmp_16, tmp0_elvis_lhs == null ? this.z63_1.u33_1 : tmp0_elvis_lhs);
            var tmp_17 = this;
            tmp_17.b64_1 = this.m63_1.m64_1;
            var tmp_18 = this;
            tmp_18.c64_1 = this.a64_1;
            var tmp_19 = this;
            tmp_19.d64_1 = this.b64_1;
            var tmp_20 = this;
            tmp_20.e64_1 = this.d64_1;
            var tmp_21 = this;
            var this_1 = new HttpRequestBuilder();
            takeFrom(this_1.m4t_1, this.c64_1);
            tmp_21.f64_1 = this_1;
            this.f64_1.n4t_1 = Companion_getInstance().n4d_1;
            var tmp_22 = this;
            tmp_22.g64_1 = this.e64_1;
            var tmp_23 = this;
            tmp_23.h64_1 = this.f64_1;
            this.v8_1 = 3;
            suspendResult = (new HttpStatement(this.h64_1, this.g64_1)).q5i(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.i64_1 = suspendResult;
            var tmp_24 = this;
            tmp_24.j64_1 = this.i64_1;
            if (!isSuccess(this.j64_1.y4v())) {
              throw Exception_init_$Create$('Error ' + this.j64_1.y4v().h4g_1 + ' while accessing ' + this.a64_1.toString());
            }

            var tmp_25 = this;
            tmp_25.k64_1 = this.j64_1;
            this.v8_1 = 4;
            var tmp_26 = this.k64_1.t4w();
            var tmp_27 = JsType_instance;
            var tmp_28 = getKClass(JsonOAuthMetadata);
            var tmp_29;
            try {
              tmp_29 = createKType(getKClass(JsonOAuthMetadata), arrayOf([]), false);
            } catch ($p) {
              var tmp_30;
              if ($p instanceof Error) {
                var cause_0 = $p;
                tmp_30 = null;
              } else {
                throw $p;
              }
              tmp_29 = tmp_30;
            }

            suspendResult = tmp_26.x4v(typeInfoImpl(tmp_27, tmp_28, tmp_29), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            var authorizationServerMetadata = suspendResult instanceof JsonOAuthMetadata ? suspendResult : THROW_CCE();
            var now = this.m63_1.l64_1.u1l();
            return new JsonCredentialIssuer(this.z63_1, authorizationServerMetadata, now);
          case 5:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 5) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function DefaultCredentialIssuerLoader(clock, client) {
    Companion_getInstance_7();
    clock = clock === VOID ? System_instance : clock;
    this.l64_1 = clock;
    this.m64_1 = client;
  }
  protoOf(DefaultCredentialIssuerLoader).g61 = function (issuerId, $completion) {
    var tmp = new $loadCOROUTINE$5(this, issuerId, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  function removeTrailingEmptySegments_0($this, segments) {
    var tmp$ret$0;
    $l$block_1: {
      // Inline function 'kotlin.collections.takeLastWhile' call
      if (segments.s()) {
        tmp$ret$0 = emptyList();
        break $l$block_1;
      }
      var iterator = segments.w(segments.m());
      while (iterator.s4()) {
        // Inline function 'io.curity.vc.services.Companion.removeTrailingEmptySegments.<anonymous>' call
        // Inline function 'kotlin.text.isNotBlank' call
        var this_0 = iterator.u4();
        if (!!isBlank(this_0)) {
          iterator.l();
          var expectedSize = segments.m() - iterator.t4() | 0;
          if (expectedSize === 0) {
            tmp$ret$0 = emptyList();
            break $l$block_1;
          }
          // Inline function 'kotlin.apply' call
          var this_1 = ArrayList_init_$Create$(expectedSize);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'kotlin.collections.takeLastWhile.<anonymous>' call
          while (iterator.k()) {
            this_1.e(iterator.l());
          }
          tmp$ret$0 = this_1;
          break $l$block_1;
        }
      }
      tmp$ret$0 = toList(segments);
    }
    return tmp$ret$0;
  }
  function Companion_1() {
  }
  var Companion_instance_10;
  function Companion_getInstance_8() {
    return Companion_instance_10;
  }
  function $getCOROUTINE$6(_this__u8e3s4, issuerId, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.v64_1 = _this__u8e3s4;
    this.w64_1 = issuerId;
  }
  protoOf($getCOROUTINE$6).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 5;
            this.x64_1 = Url(this.w64_1);
            var tmp_0 = this;
            var this_0 = URLBuilder_0(this.x64_1);
            this_0.a4i(plus(listOf_0(['.well-known', 'jwt-vc-issuer']), removeTrailingEmptySegments_0(Companion_instance_10, this_0.b4i())));
            tmp_0.y64_1 = this_0.c3r();
            var tmp_1 = this;
            tmp_1.z64_1 = this.v64_1.j65_1;
            var tmp_2 = this;
            tmp_2.a65_1 = this.y64_1;
            var tmp_3 = this;
            tmp_3.b65_1 = this.z64_1;
            var tmp_4 = this;
            tmp_4.c65_1 = this.b65_1;
            var tmp_5 = this;
            var this_1 = new HttpRequestBuilder();
            takeFrom(this_1.m4t_1, this.a65_1);
            tmp_5.d65_1 = this_1;
            this.d65_1.n4t_1 = Companion_getInstance().n4d_1;
            var tmp_6 = this;
            tmp_6.e65_1 = this.c65_1;
            var tmp_7 = this;
            tmp_7.f65_1 = this.d65_1;
            this.v8_1 = 1;
            suspendResult = (new HttpStatement(this.f65_1, this.e65_1)).q5i(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.g65_1 = suspendResult;
            if (this.g65_1.y4v().h4g_1 >= 400) {
              var tmp_8 = this;
              tmp_8.h65_1 = this.g65_1;
              this.v8_1 = 4;
              var tmp_9 = this.h65_1.t4w();
              var tmp_10 = JsType_instance;
              var tmp_11 = PrimitiveClasses_getInstance().gb();
              var tmp_12;
              try {
                tmp_12 = createKType(PrimitiveClasses_getInstance().gb(), arrayOf([]), false);
              } catch ($p) {
                var tmp_13;
                if ($p instanceof Error) {
                  var cause = $p;
                  tmp_13 = null;
                } else {
                  throw $p;
                }
                tmp_12 = tmp_13;
              }
              suspendResult = tmp_9.x4v(typeInfoImpl(tmp_10, tmp_11, tmp_12), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.v8_1 = 2;
              continue $sm;
            }

          case 2:
            var tmp_14 = this;
            tmp_14.i65_1 = this.g65_1;
            this.v8_1 = 3;
            var tmp_15 = this.i65_1.t4w();
            var tmp_16 = JsType_instance;
            var tmp_17 = getKClass(JsonVcSdJwtIssuerMetadata);
            var tmp_18;
            try {
              tmp_18 = createKType(getKClass(JsonVcSdJwtIssuerMetadata), arrayOf([]), false);
            } catch ($p) {
              var tmp_19;
              if ($p instanceof Error) {
                var cause_0 = $p;
                tmp_19 = null;
              } else {
                throw $p;
              }
              tmp_18 = tmp_19;
            }

            suspendResult = tmp_15.x4v(typeInfoImpl(tmp_16, tmp_17, tmp_18), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            return suspendResult instanceof JsonVcSdJwtIssuerMetadata ? suspendResult : THROW_CCE();
          case 4:
            var body = (!(suspendResult == null) ? typeof suspendResult === 'string' : false) ? suspendResult : THROW_CCE();
            throw Exception_init_$Create$('Issuer metadata request for ' + this.w64_1 + ' with non-success status response: ' + this.g65_1.y4v().h4g_1 + ', ' + body);
          case 5:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 5) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function DefaultVcSdJwtIssuerMetadataLoader(httpClient) {
    this.j65_1 = httpClient;
  }
  protoOf(DefaultVcSdJwtIssuerMetadataLoader).s2y = function (issuerId, $completion) {
    var tmp = new $getCOROUTINE$6(this, issuerId, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  function DidSubjectVerifiableCredentialResponseValidator(issuer, didSubjectIdentifier, clock, supportedCredential, didResolver) {
    clock = clock === VOID ? System_instance : clock;
    this.k65_1 = issuer;
    this.l65_1 = didSubjectIdentifier;
    this.m65_1 = clock;
    this.n65_1 = supportedCredential;
    this.o65_1 = didResolver;
  }
  protoOf(DidSubjectVerifiableCredentialResponseValidator).p65 = function (response, $completion) {
    var validator = new JwtVcJsonCredentialWithDidSubjectValidator(this.k65_1, this.l65_1, this.m65_1, this.n65_1, this.o65_1);
    return validator.v65(response, $completion);
  };
  protoOf(DidSubjectVerifiableCredentialResponseValidator).w65 = function (response, $completion) {
    throw UnsupportedOperationException_init_$Create$("This validator can only handle the 'jwt_vc_json' format");
  };
  protoOf(DidSubjectVerifiableCredentialResponseValidator).x65 = function (response, $completion) {
    throw UnsupportedOperationException_init_$Create$("This validator can only handle the 'jwt_vc_json' format");
  };
  protoOf(DidSubjectVerifiableCredentialResponseValidator).y65 = function (response, $completion) {
    throw UnsupportedOperationException_init_$Create$("This validator can only handle the 'jwt_vc_json' format");
  };
  function ifNull(_this__u8e3s4, $this, action) {
    if (_this__u8e3s4 == null)
      action();
    return _this__u8e3s4;
  }
  function validateHeader(_this__u8e3s4, $this, header) {
    var tmp22_safe_receiver = header.s29_1;
    var tmp;
    if (tmp22_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.vc.services.JwtVcJsonCredentialWithDidSubjectValidator.validateHeader.<anonymous>' call
      var tmp_0 = Companion_getInstance_2().d2i(tmp22_safe_receiver);
      var tmp_1 = Companion_instance_11;
      tmp = ifNull(tmp_0, tmp_1, JwtVcJsonCredentialWithDidSubjectValidator$validateHeader$lambda(_this__u8e3s4));
    }
    var tmp_2 = tmp;
    var tmp_3 = Companion_instance_11;
    return ifNull(tmp_2, tmp_3, JwtVcJsonCredentialWithDidSubjectValidator$validateHeader$lambda_0(_this__u8e3s4));
  }
  function validatePayload(_this__u8e3s4, $this, payload) {
    var w3cCredential = JwtCredentialValidationHelper_instance.z65(_this__u8e3s4, payload, $this.r65_1, $this.s65_1);
    var tmp23_safe_receiver = $this.t65_1.i39_1.t39_1;
    var tmp24_safe_receiver = tmp23_safe_receiver == null ? null : tmp23_safe_receiver.u39_1;
    var tmp25_safe_receiver = tmp24_safe_receiver == null ? null : tmp24_safe_receiver.z();
    var tmp;
    if (tmp25_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination = ArrayList_init_$Create$_0();
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = tmp25_safe_receiver.j();
      while (tmp0_iterator.k()) {
        var element = tmp0_iterator.l();
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        // Inline function 'io.curity.vc.services.JwtVcJsonCredentialWithDidSubjectValidator.validatePayload.<anonymous>' call
        // Inline function 'kotlin.collections.component1' call
        var key = element.a1();
        // Inline function 'kotlin.collections.component2' call
        var value = element.b1();
        var valueDisplay = value.x39_1;
        var tmp_0;
        if (!(valueDisplay == null)) {
          tmp_0 = to(key, valueDisplay);
        } else {
          tmp_0 = null;
        }
        var tmp0_safe_receiver = tmp_0;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination.e(tmp0_safe_receiver);
        }
      }
      tmp = destination;
    }
    var tmp26_safe_receiver = tmp;
    var tmp_1;
    if (tmp26_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.collections.associate' call
      var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(tmp26_safe_receiver, 10)), 16);
      // Inline function 'kotlin.collections.associateTo' call
      var destination_0 = LinkedHashMap_init_$Create$(capacity);
      var tmp0_iterator_0 = tmp26_safe_receiver.j();
      while (tmp0_iterator_0.k()) {
        var element_0 = tmp0_iterator_0.l();
        // Inline function 'kotlin.collections.plusAssign' call
        // Inline function 'io.curity.vc.services.JwtVcJsonCredentialWithDidSubjectValidator.validatePayload.<anonymous>' call
        var key_0 = element_0.ba();
        var value_0 = element_0.ca();
        var pair = to(key_0, value_0);
        destination_0.m2(pair.z9_1, pair.aa_1);
      }
      tmp_1 = destination_0;
    }
    var tmp0_elvis_lhs = tmp_1;
    var subjectDisplayInformation = tmp0_elvis_lhs == null ? emptyMap() : tmp0_elvis_lhs;
    var tmp_2;
    if (_this__u8e3s4.qn_1 && !(w3cCredential == null)) {
      tmp_2 = to(w3cCredential, subjectDisplayInformation);
    } else {
      tmp_2 = null;
    }
    return tmp_2;
  }
  function Companion_2() {
  }
  var Companion_instance_11;
  function Companion_getInstance_9() {
    return Companion_instance_11;
  }
  function JwtVcJsonCredentialWithDidSubjectValidator$validate$slambda($response, this$0, resultContinuation) {
    this.i66_1 = $response;
    this.j66_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(JwtVcJsonCredentialWithDidSubjectValidator$validate$slambda).w66 = function ($this$suspendableValidationScope, $completion) {
    var tmp = this.x66($this$suspendableValidationScope, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(JwtVcJsonCredentialWithDidSubjectValidator$validate$slambda).y9 = function (p1, $completion) {
    return this.w66(p1 instanceof ValidationScope ? p1 : THROW_CCE(), $completion);
  };
  protoOf(JwtVcJsonCredentialWithDidSubjectValidator$validate$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 5;
            var tmp_0 = this;
            var tmp20_subject = this.i66_1;
            var tmp_1;
            if (tmp20_subject instanceof Deferred) {
              var message = 'Cannot handle deferred response';
              throw IllegalStateException_init_$Create$(toString(message));
            } else {
              if (tmp20_subject instanceof JwtVcJsonVerifiableCredentialResponse) {
                tmp_1 = this.i66_1.n38();
              } else {
                noWhenBranchMatchedException();
              }
            }

            tmp_0.l66_1 = tmp_1;
            this.m66_1 = JwsUtil_getInstance().r2a(this.l66_1.o2h_1);
            var tmp_2 = this;
            var header = this.m66_1.j29_1;
            var tmp_3;
            if (header == null) {
              this.k66_1.vn('JWS Header is missing');
              tmp_3 = null;
            } else {
              tmp_3 = validateHeader(this.k66_1, this.j66_1, header);
            }

            tmp_2.n66_1 = tmp_3;
            this.o66_1 = validatePayload(this.k66_1, this.j66_1, this.m66_1.k29_1);
            if (this.o66_1 == null) {
              this.p66_1 = null;
              this.v8_1 = 4;
              continue $sm;
            } else {
              var tmp_4 = this;
              tmp_4.q66_1 = this.o66_1;
              var tmp_5 = this;
              tmp_5.r66_1 = this.q66_1;
              this.s66_1 = this.r66_1.ba();
              this.t66_1 = this.r66_1.ca();
              if (this.k66_1.qn_1 && !(this.n66_1 == null)) {
                this.v8_1 = 1;
                suspendResult = JwtCredentialValidationHelper_instance.y66(this.k66_1, this.l66_1.o2h_1, this.n66_1, this.j66_1.u65_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_6 = this;
                tmp_6.u66_1 = null;
                this.v8_1 = 3;
                continue $sm;
              }
            }

          case 1:
            var ARGUMENT = suspendResult;
            if (!ARGUMENT) {
              var tmp_7 = this;
              this.k66_1.vn('Unable to validate signature');
              tmp_7.v66_1 = null;
              this.v8_1 = 2;
              continue $sm;
            } else {
              var tmp_8 = this;
              tmp_8.v66_1 = new DidValidatedJwtVcJsonCredentialResponse(this.i66_1, this.l66_1.o2h_1, this.s66_1, this.t66_1, this.j66_1.t65_1.k39_1);
              this.v8_1 = 2;
              continue $sm;
            }

          case 2:
            this.u66_1 = this.v66_1;
            this.v8_1 = 3;
            continue $sm;
          case 3:
            this.p66_1 = this.u66_1;
            this.v8_1 = 4;
            continue $sm;
          case 4:
            return this.p66_1;
          case 5:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 5) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  protoOf(JwtVcJsonCredentialWithDidSubjectValidator$validate$slambda).x66 = function ($this$suspendableValidationScope, completion) {
    var i = new JwtVcJsonCredentialWithDidSubjectValidator$validate$slambda(this.i66_1, this.j66_1, completion);
    i.k66_1 = $this$suspendableValidationScope;
    return i;
  };
  function JwtVcJsonCredentialWithDidSubjectValidator$validate$slambda_0($response, this$0, resultContinuation) {
    var i = new JwtVcJsonCredentialWithDidSubjectValidator$validate$slambda($response, this$0, resultContinuation);
    var l = function ($this$suspendableValidationScope, $completion) {
      return i.w66($this$suspendableValidationScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function JwtVcJsonCredentialWithDidSubjectValidator$validateHeader$lambda($this_validateHeader) {
    return function () {
      $this_validateHeader.vn("JWE 'kid' is not a valid DID URL");
      return Unit_instance;
    };
  }
  function JwtVcJsonCredentialWithDidSubjectValidator$validateHeader$lambda_0($this_validateHeader) {
    return function () {
      $this_validateHeader.vn("JWE 'kid' claim is missing");
      return Unit_instance;
    };
  }
  function $validateCOROUTINE$7(_this__u8e3s4, response, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.h67_1 = _this__u8e3s4;
    this.i67_1 = response;
  }
  protoOf($validateCOROUTINE$7).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            this.v8_1 = 1;
            suspendResult = suspendableValidationScope(JwtVcJsonCredentialWithDidSubjectValidator$validate$slambda_0(this.i67_1, this.h67_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return ARGUMENT.xm();
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function JwtVcJsonCredentialWithDidSubjectValidator(issuer, didSubjectIdentifier, clock, supportedCredential, didResolver) {
    this.q65_1 = issuer;
    this.r65_1 = didSubjectIdentifier;
    this.s65_1 = clock;
    this.t65_1 = supportedCredential;
    this.u65_1 = didResolver;
  }
  protoOf(JwtVcJsonCredentialWithDidSubjectValidator).v65 = function (response, $completion) {
    var tmp = new $validateCOROUTINE$7(this, response, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  function validateVcClaim(_this__u8e3s4, $this, vc, iss, sub, jti, iat, exp, didSubjectIdentifier) {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    var typeList = vc.v3b_1;
    _this__u8e3s4.sn("type contains 'VerifiableCredential'", JwtCredentialValidationHelper$validateVcClaim$lambda(typeList));
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    var vcIssuer = vc.e3c();
    _this__u8e3s4.sn('vc.issuer matches jwt.issuer', JwtCredentialValidationHelper$validateVcClaim$lambda_0(vcIssuer, iss));
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    var id = vc.t3b_1;
    _this__u8e3s4.sn('vc.id must match jwt.jti', JwtCredentialValidationHelper$validateVcClaim$lambda_1(id, jti));
    if (!(iat == null)) {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.vc.services.JwtCredentialValidationHelper.validateVcClaim.<anonymous>' call
      var issuedString = vc.y3b_1;
      var tmp = JwtCredentialValidationHelper$validateVcClaim$lambda_2;
      var tmp31_safe_receiver = _this__u8e3s4.xn(tmp, issuedString, JwtCredentialValidationHelper$validateVcClaim$lambda_3(issuedString));
      var tmp_0;
      if (tmp31_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        _this__u8e3s4.sn('vc.issued matches jwt.iat', JwtCredentialValidationHelper$validateVcClaim$lambda_4(tmp31_safe_receiver, iat));
        tmp_0 = Unit_instance;
      }
    }
    var tmp32_safe_receiver = vc.a3c_1;
    if (tmp32_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.vc.services.JwtCredentialValidationHelper.validateVcClaim.<anonymous>' call
      var tmp_1 = JwtCredentialValidationHelper$validateVcClaim$lambda_5;
      var tmp33_safe_receiver = _this__u8e3s4.xn(tmp_1, tmp32_safe_receiver, JwtCredentialValidationHelper$validateVcClaim$lambda_6(tmp32_safe_receiver));
      var tmp_2;
      if (tmp33_safe_receiver == null) {
        tmp_2 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        _this__u8e3s4.sn('vc.expirationDate matches jwt.exp', JwtCredentialValidationHelper$validateVcClaim$lambda_7(tmp33_safe_receiver, exp));
        tmp_2 = Unit_instance;
      }
    }
    vc.w3b_1.rm(JwtCredentialValidationHelper$validateVcClaim$lambda_8(_this__u8e3s4, sub, didSubjectIdentifier));
  }
  function validateVcCredentialSubject(_this__u8e3s4, $this, credentialSubject, sub, didSubjectIdentifier) {
    // Inline function 'io.curity.vc.services.JwtCredentialValidationHelper.claim' call
    var value = credentialSubject.vl('id');
    if (value == null) {
      _this__u8e3s4.vn("Missing claim '" + 'id' + "'");
    } else {
      // Inline function 'io.curity.vc.services.JwtCredentialValidationHelper.validateVcCredentialSubject.<anonymous>' call
      var tmp;
      if (value instanceof JsonPrimitive_0) {
        tmp = value.e1b();
      } else {
        if (value instanceof JsonObject) {
          var tmp_0 = value.vl('id');
          var tmp35_safe_receiver = tmp_0 instanceof JsonPrimitive_0 ? tmp_0 : null;
          tmp = tmp35_safe_receiver == null ? null : tmp35_safe_receiver.e1b();
        } else {
          tmp = null;
        }
      }
      var credentialSubjectId = tmp;
      _this__u8e3s4.sn('credentialSubject.id must match the used subject identifier', JwtCredentialValidationHelper$validateVcCredentialSubject$lambda(credentialSubjectId, didSubjectIdentifier));
      _this__u8e3s4.sn('credentialSubject.id must match jwt.sub', JwtCredentialValidationHelper$validateVcCredentialSubject$lambda_0(credentialSubjectId, sub));
    }
  }
  function sameish($this, i1, i2) {
    return !(i1 == null) && !(i2 == null) && _Duration___get_inWholeSeconds__impl__hpy7b3(_Duration___get_absoluteValue__impl__vr7i6w(i1.g1m(i2))).j1(new Long(2, 0)) <= 0;
  }
  function JwtCredentialValidationHelper$validateCredentialClaims$lambda($sub, $didSubjectIdentifier) {
    return function () {
      return $sub === $didSubjectIdentifier.e2i_1.toString();
    };
  }
  function JwtCredentialValidationHelper$validateCredentialClaims$lambda$lambda($clock, $expInstant) {
    return function () {
      return $clock.u1l().h1m($expInstant) < 0;
    };
  }
  function JwtCredentialValidationHelper$validateCredentialClaims$lambda_0($clock) {
    return function ($this$mandatory, exp) {
      var expInstant = Companion_getInstance_3().d1m(exp);
      $this$mandatory.sn("'exp' claim is in the future", JwtCredentialValidationHelper$validateCredentialClaims$lambda$lambda($clock, expInstant));
      return expInstant;
    };
  }
  function JwtCredentialValidationHelper$validateCredentialClaims$lambda$lambda_0($iatInstant, $clock) {
    return function () {
      return $iatInstant.h1m($clock.u1l()) <= 0;
    };
  }
  function JwtCredentialValidationHelper$validateCredentialClaims$lambda_1($clock) {
    return function ($this$mandatory, iat) {
      var iatInstant = Companion_getInstance_3().d1m(iat);
      $this$mandatory.sn("'iat' is not in the future", JwtCredentialValidationHelper$validateCredentialClaims$lambda$lambda_0(iatInstant, $clock));
      return iatInstant;
    };
  }
  function JwtCredentialValidationHelper$validateCredentialClaims$lambda_2(err) {
    return 'Credential does not conform to w3c data model: ' + err.toString();
  }
  function JwtCredentialValidationHelper$validateCredentialClaims$lambda_3(credential) {
    return Companion_instance.d27(credential);
  }
  function JwtCredentialValidationHelper$validateVcClaim$lambda($typeList) {
    return function () {
      return $typeList.a2('VerifiableCredential');
    };
  }
  function JwtCredentialValidationHelper$validateVcClaim$lambda_0($vcIssuer, $iss) {
    return function () {
      var tmp30_subject = $vcIssuer;
      var tmp;
      if (isInterface(tmp30_subject, IssuerObject)) {
        tmp = $vcIssuer.k2a();
      } else {
        if (tmp30_subject instanceof IssuerURI) {
          tmp = $vcIssuer.q2h_1;
        } else {
          noWhenBranchMatchedException();
        }
      }
      var issuerId = tmp;
      return issuerId === $iss;
    };
  }
  function JwtCredentialValidationHelper$validateVcClaim$lambda_1($id, $jti) {
    return function () {
      return $id == $jti;
    };
  }
  function JwtCredentialValidationHelper$validateVcClaim$lambda_2(err) {
    return 'vc.issued is invalid: ' + err.toString();
  }
  function JwtCredentialValidationHelper$validateVcClaim$lambda_3($issuedString) {
    return function (it) {
      return Companion_getInstance_3().a1m($issuedString);
    };
  }
  function JwtCredentialValidationHelper$validateVcClaim$lambda_4($issued, $iat) {
    return function () {
      return sameish(JwtCredentialValidationHelper_instance, $issued, $iat);
    };
  }
  function JwtCredentialValidationHelper$validateVcClaim$lambda_5(err) {
    return 'vc.expirationDate is invalid: ' + err.toString();
  }
  function JwtCredentialValidationHelper$validateVcClaim$lambda_6($expirationDate) {
    return function (it) {
      return Companion_getInstance_3().a1m($expirationDate);
    };
  }
  function JwtCredentialValidationHelper$validateVcClaim$lambda_7($expiration, $exp) {
    return function () {
      return sameish(JwtCredentialValidationHelper_instance, $expiration, $exp);
    };
  }
  function JwtCredentialValidationHelper$validateVcClaim$lambda_8($this_validateVcClaim, $sub, $didSubjectIdentifier) {
    return function (subject) {
      validateVcCredentialSubject($this_validateVcClaim, JwtCredentialValidationHelper_instance, subject, $sub, $didSubjectIdentifier);
      return Unit_instance;
    };
  }
  function JwtCredentialValidationHelper$validateVcCredentialSubject$lambda($credentialSubjectId, $didSubjectIdentifier) {
    return function () {
      return $credentialSubjectId === $didSubjectIdentifier.e2i_1.toString();
    };
  }
  function JwtCredentialValidationHelper$validateVcCredentialSubject$lambda_0($credentialSubjectId, $sub) {
    return function () {
      return $credentialSubjectId == $sub;
    };
  }
  function $validateJwtSignatureCOROUTINE$8(_this__u8e3s4, _this__u8e3s4_0, jwt, didUrl, didResolver, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.r67_1 = _this__u8e3s4;
    this.s67_1 = _this__u8e3s4_0;
    this.t67_1 = jwt;
    this.u67_1 = didUrl;
    this.v67_1 = didResolver;
  }
  protoOf($validateJwtSignatureCOROUTINE$8).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 9;
            this.w8_1 = 2;
            this.v8_1 = 1;
            suspendResult = this.v67_1.k2j(this.u67_1.e2i_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.x67_1 = suspendResult;
            this.y67_1 = this.x67_1.h3k();
            this.z67_1 = this.y67_1.b3l(this.u67_1);
            this.a68_1 = this.z67_1 == null ? null : this.z67_1.k3l();
            if (this.a68_1 == null) {
              this.s67_1.vn('Unable to find usable key in DID document');
            }

            this.w67_1 = this.a68_1;
            this.w8_1 = 9;
            this.v8_1 = 3;
            continue $sm;
          case 2:
            this.w8_1 = 9;
            var tmp_0 = this.y8_1;
            if (tmp_0 instanceof DidResolutionException) {
              this.b68_1 = this.y8_1;
              var tmp_1 = this;
              this.s67_1.vn('Unable to find DID document');
              return false;
            } else {
              throw this.y8_1;
            }

          case 3:
            this.w8_1 = 9;
            this.c68_1 = this.w67_1;
            var tmp_2 = this;
            var tmp_3;
            if (this.c68_1 == null) {
              return false;
            } else {
              tmp_3 = this.c68_1;
            }

            tmp_2.d68_1 = tmp_3;
            this.w8_1 = 5;
            this.v8_1 = 4;
            var tmp_4 = Companion_instance_0;
            var this_0 = Default_getInstance();
            var value = Companion_instance_1.a3k(this.d68_1);
            var this_1 = this_0.dp();
            var this_2 = serializer(this_1, createKType(getKClass(JsonPublicKeyJwk), arrayOf([]), false));
            suspendResult = tmp_4.x28(this_0.bp(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), value), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.e68_1 = suspendResult;
            this.w8_1 = 9;
            this.v8_1 = 6;
            continue $sm;
          case 5:
            this.w8_1 = 9;
            var tmp_5 = this.y8_1;
            if (tmp_5 instanceof CryptoException) {
              this.f68_1 = this.y8_1;
              var tmp_6 = this;
              this.s67_1.vn('Unable to use key resolved from DID URL');
              return false;
            } else {
              throw this.y8_1;
            }

          case 6:
            this.w8_1 = 9;
            this.g68_1 = this.e68_1;
            this.w8_1 = 8;
            this.v8_1 = 7;
            suspendResult = JwsUtil_getInstance().w2d(this.g68_1, this.t67_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            this.h68_1 = true;
            this.w8_1 = 9;
            this.v8_1 = 10;
            continue $sm;
          case 8:
            this.w8_1 = 9;
            var tmp_7 = this.y8_1;
            if (tmp_7 instanceof CryptoException) {
              var ex = this.y8_1;
              var tmp_8 = this;
              this.s67_1.vn('Signature is not valid');
              tmp_8.h68_1 = false;
              this.v8_1 = 10;
              continue $sm;
            } else {
              throw this.y8_1;
            }

          case 9:
            throw this.y8_1;
          case 10:
            this.w8_1 = 9;
            return this.h68_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 9) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function JwtCredentialValidationHelper() {
  }
  protoOf(JwtCredentialValidationHelper).y66 = function (_this__u8e3s4, jwt, didUrl, didResolver, $completion) {
    var tmp = new $validateJwtSignatureCOROUTINE$8(this, _this__u8e3s4, jwt, didUrl, didResolver, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(JwtCredentialValidationHelper).z65 = function (_this__u8e3s4, payload, didSubjectIdentifier, clock) {
    var iss = payload.z29_1;
    // Inline function 'kotlin.also' call
    var this_0 = payload.a2a_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'io.curity.vc.services.JwtCredentialValidationHelper.validateCredentialClaims.<anonymous>' call
    _this__u8e3s4.sn("'sub' claim matches subject identifier", JwtCredentialValidationHelper$validateCredentialClaims$lambda(this_0, didSubjectIdentifier));
    var sub = this_0;
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'io.curity.vc.services.JwtCredentialValidationHelper.validateCredentialClaims.<anonymous>' call
    var jti = payload.f2a_1;
    var exp = _this__u8e3s4.un('exp', payload.c2a_1, JwtCredentialValidationHelper$validateCredentialClaims$lambda_0(clock));
    var iat = _this__u8e3s4.un('iat', payload.e2a_1, JwtCredentialValidationHelper$validateCredentialClaims$lambda_1(clock));
    var tmp28_safe_receiver = payload.vl('vc');
    var tmp;
    if (tmp28_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.vc.services.JwtCredentialValidationHelper.validateCredentialClaims.<anonymous>' call
      var tmp_0 = JwtCredentialValidationHelper$validateCredentialClaims$lambda_2;
      var tmp29_safe_receiver = _this__u8e3s4.xn(tmp_0, tmp28_safe_receiver, JwtCredentialValidationHelper$validateCredentialClaims$lambda_3);
      var tmp_1;
      if (tmp29_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'io.curity.vc.services.JwtCredentialValidationHelper.validateCredentialClaims.<anonymous>.<anonymous>' call
        validateVcClaim(_this__u8e3s4, JwtCredentialValidationHelper_instance, tmp29_safe_receiver, iss, sub, jti, iat, exp, didSubjectIdentifier);
        tmp_1 = tmp29_safe_receiver;
      }
      tmp = tmp_1;
    }
    return tmp;
  };
  var JwtCredentialValidationHelper_instance;
  function JwtCredentialValidationHelper_getInstance() {
    return JwtCredentialValidationHelper_instance;
  }
  function InMemoryKeyAliasStore() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.i68_1 = LinkedHashMap_init_$Create$_0();
  }
  protoOf(InMemoryKeyAliasStore).j68 = function (alias, kid, $completion) {
    // Inline function 'kotlin.collections.set' call
    this.i68_1.m2(alias, kid);
    return Unit_instance;
  };
  protoOf(InMemoryKeyAliasStore).k68 = function (alias, $completion) {
    return this.i68_1.e2(alias);
  };
  function deserializeUserVerifiableCredentialOrNull($this, serializedCredential) {
    var tmp;
    try {
      // Inline function 'kotlinx.serialization.json.Json.decodeFromString' call
      var this_0 = Default_getInstance();
      // Inline function 'kotlinx.serialization.serializer' call
      var this_1 = this_0.dp();
      // Inline function 'kotlinx.serialization.internal.cast' call
      var this_2 = serializer(this_1, createKType(getKClass(UserVerifiableCredential), arrayOf([]), false));
      var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
      tmp = this_0.cp(tmp$ret$1, serializedCredential);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof SerializationException) {
        var ex = $p;
        tmp_0 = null;
      } else {
        if ($p instanceof IllegalArgumentException) {
          var ex_0 = $p;
          tmp_0 = null;
        } else {
          throw $p;
        }
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function Companion_3() {
    Companion_instance_12 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l68_1 = [new LinkedHashMapSerializer(StringSerializer_getInstance(), StringSerializer_getInstance())];
  }
  var Companion_instance_12;
  function Companion_getInstance_10() {
    if (Companion_instance_12 == null)
      new Companion_3();
    return Companion_instance_12;
  }
  function $serializer_0() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vc.services.InMemoryVerifiableCredentialStore', this, 1);
    tmp0_serialDesc.wy('map', true);
    this.m68_1 = tmp0_serialDesc;
  }
  protoOf($serializer_0).n68 = function (encoder, value) {
    var tmp0_desc = this.m68_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    var tmp2_cached = Companion_getInstance_10().l68_1;
    var tmp;
    if (tmp1_output.ht(tmp0_desc, 0)) {
      tmp = true;
    } else {
      // Inline function 'kotlin.collections.mutableMapOf' call
      var tmp$ret$0 = LinkedHashMap_init_$Create$_0();
      tmp = !equals(value.o68_1, tmp$ret$0);
    }
    if (tmp) {
      tmp1_output.bt(tmp0_desc, 0, tmp2_cached[0], value.o68_1);
    }
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_0).zn = function (encoder, value) {
    return this.n68(encoder, value instanceof InMemoryVerifiableCredentialStore ? value : THROW_CCE());
  };
  protoOf($serializer_0).ao = function (decoder) {
    var tmp0_desc = this.m68_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.lr(tmp0_desc);
    var tmp6_cached = Companion_getInstance_10().l68_1;
    if (tmp5_input.as()) {
      tmp4_local0 = tmp5_input.xr(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.xr(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.mr(tmp0_desc);
    return InMemoryVerifiableCredentialStore_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_0).yn = function () {
    return this.m68_1;
  };
  protoOf($serializer_0).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_10().l68_1[0]];
  };
  var $serializer_instance_0;
  function $serializer_getInstance_5() {
    if ($serializer_instance_0 == null)
      new $serializer_0();
    return $serializer_instance_0;
  }
  function InMemoryVerifiableCredentialStore_init_$Init$(seen0, map, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_5().m68_1);
    }
    if (0 === (seen0 & 1)) {
      var tmp = $this;
      // Inline function 'kotlin.collections.mutableMapOf' call
      tmp.o68_1 = LinkedHashMap_init_$Create$_0();
    } else
      $this.o68_1 = map;
    return $this;
  }
  function InMemoryVerifiableCredentialStore_init_$Create$(seen0, map, serializationConstructorMarker) {
    return InMemoryVerifiableCredentialStore_init_$Init$(seen0, map, serializationConstructorMarker, objectCreate(protoOf(InMemoryVerifiableCredentialStore)));
  }
  function InMemoryVerifiableCredentialStore(map) {
    Companion_getInstance_10();
    var tmp;
    if (map === VOID) {
      // Inline function 'kotlin.collections.mutableMapOf' call
      tmp = LinkedHashMap_init_$Create$_0();
    } else {
      tmp = map;
    }
    map = tmp;
    this.o68_1 = map;
  }
  protoOf(InMemoryVerifiableCredentialStore).p68 = function (credential) {
    if (this.o68_1.c2(credential.a33_1)) {
      throw Exception_init_$Create$('A Credential with this name already exists');
    }
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.o68_1;
    var key = credential.a33_1;
    // Inline function 'kotlinx.serialization.encodeToString' call
    var this_1 = Default_getInstance();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_2 = this_1.dp();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_3 = serializer(this_2, createKType(getKClass(UserVerifiableCredential), arrayOf([]), false));
    var tmp$ret$1 = isInterface(this_3, KSerializer) ? this_3 : THROW_CCE();
    var value = this_1.bp(tmp$ret$1, credential);
    this_0.m2(key, value);
  };
  protoOf(InMemoryVerifiableCredentialStore).q68 = function (localId) {
    this.o68_1.n2(localId);
  };
  protoOf(InMemoryVerifiableCredentialStore).r68 = function (localId) {
    var tmp37_safe_receiver = this.o68_1.e2(localId);
    var tmp;
    if (tmp37_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.vc.services.InMemoryVerifiableCredentialStore.getById.<anonymous>' call
      tmp = deserializeUserVerifiableCredentialOrNull(this, tmp37_safe_receiver);
    }
    return tmp;
  };
  protoOf(InMemoryVerifiableCredentialStore).s68 = function (namePrefix) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = this.o68_1.g2();
    var destination = ArrayList_init_$Create$_0();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this_0.j();
    while (tmp0_iterator.k()) {
      var element = tmp0_iterator.l();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'io.curity.vc.services.InMemoryVerifiableCredentialStore.getByName.<anonymous>' call
      var tmp0_safe_receiver = deserializeUserVerifiableCredentialOrNull(this, element);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.e(tmp0_safe_receiver);
      }
    }
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$_0();
    var tmp0_iterator_0 = destination.j();
    while (tmp0_iterator_0.k()) {
      var element_0 = tmp0_iterator_0.l();
      // Inline function 'io.curity.vc.services.InMemoryVerifiableCredentialStore.getByName.<anonymous>' call
      if (startsWith(element_0.a33_1, namePrefix)) {
        destination_0.e(element_0);
      }
    }
    return destination_0;
  };
  protoOf(InMemoryVerifiableCredentialStore).t68 = function (issuerId) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = this.o68_1.g2();
    var destination = ArrayList_init_$Create$_0();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this_0.j();
    while (tmp0_iterator.k()) {
      var element = tmp0_iterator.l();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'io.curity.vc.services.InMemoryVerifiableCredentialStore.getByIssuer.<anonymous>' call
      var tmp0_safe_receiver = deserializeUserVerifiableCredentialOrNull(this, element);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.e(tmp0_safe_receiver);
      }
    }
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$_0();
    var tmp0_iterator_0 = destination.j();
    while (tmp0_iterator_0.k()) {
      var element_0 = tmp0_iterator_0.l();
      // Inline function 'io.curity.vc.services.InMemoryVerifiableCredentialStore.getByIssuer.<anonymous>' call
      if (element_0.b33_1 === issuerId) {
        destination_0.e(element_0);
      }
    }
    return destination_0;
  };
  protoOf(InMemoryVerifiableCredentialStore).u68 = function () {
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = this.o68_1.g2();
    var destination = ArrayList_init_$Create$_0();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this_0.j();
    while (tmp0_iterator.k()) {
      var element = tmp0_iterator.l();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'io.curity.vc.services.InMemoryVerifiableCredentialStore.getAll.<anonymous>' call
      var tmp0_safe_receiver = deserializeUserVerifiableCredentialOrNull(this, element);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.e(tmp0_safe_receiver);
      }
    }
    return destination;
  };
  function withToken($this, request, force, $completion) {
    var tmp = new $withTokenCOROUTINE$10($this, request, force, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  }
  function withToken$default($this, request, force, $completion, $super) {
    force = force === VOID ? false : force;
    return withToken($this, request, force, $completion);
  }
  function $interceptCOROUTINE$9(_this__u8e3s4, sender, request, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.r69_1 = _this__u8e3s4;
    this.s69_1 = sender;
    this.t69_1 = request;
  }
  protoOf($interceptCOROUTINE$9).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 7;
            this.v8_1 = 1;
            suspendResult = withToken$default(this.r69_1, this.t69_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.u69_1 = suspendResult;
            this.v8_1 = 2;
            suspendResult = this.s69_1.v56(this.t69_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.v69_1 = suspendResult;
            var tmp_0;
            var containsArg = this.v69_1.j31().y4v().h4g_1;
            if (401 <= containsArg ? containsArg <= 403 : false) {
              tmp_0 = !this.u69_1;
            } else {
              tmp_0 = false;
            }

            if (tmp_0) {
              this.v8_1 = 4;
              suspendResult = withToken(this.r69_1, this.t69_1, true, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.v8_1 = 3;
              continue $sm;
            }

          case 3:
            return this.v69_1;
          case 4:
            if (suspendResult) {
              this.v8_1 = 5;
              suspendResult = this.s69_1.v56(this.t69_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_1 = this;
              tmp_1.w69_1 = this.v69_1;
              this.v8_1 = 6;
              continue $sm;
            }

          case 5:
            this.w69_1 = suspendResult;
            this.v8_1 = 6;
            continue $sm;
          case 6:
            return this.w69_1;
          case 7:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 7) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function $withTokenCOROUTINE$10(_this__u8e3s4, request, force, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.d69_1 = _this__u8e3s4;
    this.e69_1 = request;
    this.f69_1 = force;
  }
  protoOf($withTokenCOROUTINE$10).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 3;
            this.g69_1 = false;
            this.h69_1 = this.d69_1.y69_1.z5u();
            if (this.f69_1 && this.h69_1 == null) {
              return false;
            }

            if (this.f69_1 && !(this.h69_1 == null)) {
              this.g69_1 = true;
              this.v8_1 = 1;
              suspendResult = this.d69_1.x69_1.p5w(this.h69_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_0 = this;
              tmp_0.i69_1 = this.d69_1.y69_1;
              this.v8_1 = 2;
              continue $sm;
            }

          case 1:
            this.i69_1 = suspendResult;
            this.v8_1 = 2;
            continue $sm;
          case 2:
            var tokenResponse = this.i69_1;
            header(this.e69_1, 'Authorization', 'Bearer ' + tokenResponse.y5u());
            if (this.g69_1) {
              this.d69_1.y69_1 = tokenResponse;
            }

            return this.g69_1;
          case 3:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 3) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function OAuthTokenInterceptor(initialTokenResponse, refreshFlowClient) {
    this.x69_1 = refreshFlowClient;
    this.y69_1 = initialTokenResponse;
  }
  protoOf(OAuthTokenInterceptor).z69 = function (sender, request, $completion) {
    var tmp = new $interceptCOROUTINE$9(this, sender, request, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  function installOAuthSupport(_this__u8e3s4, initialTokenResponse, refreshFlowClient) {
    var oauthInterceptor = new OAuthTokenInterceptor(initialTokenResponse, refreshFlowClient);
    var tmp = plugin(_this__u8e3s4, Plugin_getInstance_0());
    tmp.e58(OAuthTokenInterceptor$intercept$ref_0(oauthInterceptor));
  }
  function OAuthTokenInterceptor$intercept$ref($boundThis) {
    this.a6a_1 = $boundThis;
  }
  protoOf(OAuthTokenInterceptor$intercept$ref).t56 = function (p0, p1, $completion) {
    return this.a6a_1.z69(p0, p1, $completion);
  };
  protoOf(OAuthTokenInterceptor$intercept$ref).hj = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, Sender) : false) ? p1 : THROW_CCE();
    return this.t56(tmp, p2 instanceof HttpRequestBuilder ? p2 : THROW_CCE(), $completion);
  };
  function OAuthTokenInterceptor$intercept$ref_0($boundThis) {
    var i = new OAuthTokenInterceptor$intercept$ref($boundThis);
    var l = function (p0, p1, $completion) {
      return i.t56(p0, p1, $completion);
    };
    l.callableName = 'intercept';
    l.$arity = 2;
    return l;
  }
  function $requestCredentialCOROUTINE$11(_this__u8e3s4, request, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.j6a_1 = _this__u8e3s4;
    this.k6a_1 = request;
  }
  protoOf($requestCredentialCOROUTINE$11).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 6;
            var tmp_0 = this;
            tmp_0.l6a_1 = this.j6a_1.t62_1;
            var tmp_1 = this;
            tmp_1.m6a_1 = this.j6a_1.u62_1.p33_1;
            var tmp_2 = this;
            tmp_2.n6a_1 = this.l6a_1;
            var tmp_3 = this;
            tmp_3.o6a_1 = this.n6a_1;
            var tmp_4 = this;
            var this_0 = new HttpRequestBuilder();
            url(this_0, this.m6a_1);
            contentType(this_0, Application_getInstance().x47_1);
            var body = this.k6a_1;
            if (body == null) {
              this_0.p4t_1 = NullBody_instance;
              var tmp_5 = JsType_instance;
              var tmp_6 = getKClass(JwtVcJsonVerifiableCredentialRequest);
              var tmp_7;
              try {
                tmp_7 = createKType(getKClass(JwtVcJsonVerifiableCredentialRequest), arrayOf([]), false);
              } catch ($p) {
                var tmp_8;
                if ($p instanceof Error) {
                  var cause = $p;
                  tmp_8 = null;
                } else {
                  throw $p;
                }
                tmp_7 = tmp_8;
              }
              this_0.k4z(typeInfoImpl(tmp_5, tmp_6, tmp_7));
            } else {
              if (body instanceof OutgoingContent) {
                this_0.p4t_1 = body;
                this_0.k4z(null);
              } else {
                this_0.p4t_1 = body;
                var tmp_9 = JsType_instance;
                var tmp_10 = getKClass(JwtVcJsonVerifiableCredentialRequest);
                var tmp_11;
                try {
                  tmp_11 = createKType(getKClass(JwtVcJsonVerifiableCredentialRequest), arrayOf([]), false);
                } catch ($p) {
                  var tmp_12;
                  if ($p instanceof Error) {
                    var cause_0 = $p;
                    tmp_12 = null;
                  } else {
                    throw $p;
                  }
                  tmp_11 = tmp_12;
                }
                this_0.k4z(typeInfoImpl(tmp_9, tmp_10, tmp_11));
              }
            }

            tmp_4.p6a_1 = this_0;
            this.p6a_1.n4t_1 = Companion_getInstance().o4d_1;
            var tmp_13 = this;
            tmp_13.q6a_1 = this.o6a_1;
            var tmp_14 = this;
            tmp_14.r6a_1 = this.p6a_1;
            this.v8_1 = 1;
            suspendResult = (new HttpStatement(this.r6a_1, this.q6a_1)).q5i(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.s6a_1 = suspendResult;
            if (this.s6a_1.y4v().h4g_1 >= 300) {
              var tmp_15 = this;
              tmp_15.t6a_1 = this.s6a_1;
              this.v8_1 = 5;
              var tmp_16 = this.t6a_1.t4w();
              var tmp_17 = JsType_instance;
              var tmp_18 = PrimitiveClasses_getInstance().gb();
              var tmp_19;
              try {
                tmp_19 = createKType(PrimitiveClasses_getInstance().gb(), arrayOf([]), false);
              } catch ($p) {
                var tmp_20;
                if ($p instanceof Error) {
                  var cause_1 = $p;
                  tmp_20 = null;
                } else {
                  throw $p;
                }
                tmp_19 = tmp_20;
              }
              suspendResult = tmp_16.x4v(typeInfoImpl(tmp_17, tmp_18, tmp_19), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.v8_1 = 2;
              continue $sm;
            }

          case 2:
            this.u6a_1 = this.j6a_1.v62_1;
            var tmp_21 = this;
            tmp_21.v6a_1 = this.s6a_1;
            this.v8_1 = 3;
            var tmp_22 = this.v6a_1.t4w();
            var tmp_23 = JsType_instance;
            var tmp_24 = getKClass(JwtVcJsonCredentialResponse);
            var tmp_25;
            try {
              tmp_25 = createKType(getKClass(JwtVcJsonCredentialResponse), arrayOf([]), false);
            } catch ($p) {
              var tmp_26;
              if ($p instanceof Error) {
                var cause_2 = $p;
                tmp_26 = null;
              } else {
                throw $p;
              }
              tmp_25 = tmp_26;
            }

            suspendResult = tmp_22.x4v(typeInfoImpl(tmp_23, tmp_24, tmp_25), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var tmp_27 = this;
            tmp_27.w6a_1 = (!(suspendResult == null) ? isInterface(suspendResult, JwtVcJsonCredentialResponse) : false) ? suspendResult : THROW_CCE();
            this.v8_1 = 4;
            suspendResult = this.u6a_1.p65(this.w6a_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            return suspendResult;
          case 5:
            var body_0 = (!(suspendResult == null) ? typeof suspendResult === 'string' : false) ? suspendResult : THROW_CCE();
            throw Exception_init_$Create$('Credential request with non-success response: ' + this.s6a_1.y4v().h4g_1 + ', ' + body_0);
          case 6:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 6) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function $requestCredentialCOROUTINE$12(_this__u8e3s4, request, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.f6b_1 = _this__u8e3s4;
    this.g6b_1 = request;
  }
  protoOf($requestCredentialCOROUTINE$12).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 6;
            var tmp_0 = this;
            tmp_0.h6b_1 = this.f6b_1.t62_1;
            var tmp_1 = this;
            tmp_1.i6b_1 = this.f6b_1.u62_1.p33_1;
            var tmp_2 = this;
            tmp_2.j6b_1 = this.h6b_1;
            var tmp_3 = this;
            tmp_3.k6b_1 = this.j6b_1;
            var tmp_4 = this;
            var this_0 = new HttpRequestBuilder();
            url(this_0, this.i6b_1);
            contentType(this_0, Application_getInstance().x47_1);
            var body = this.g6b_1;
            if (body == null) {
              this_0.p4t_1 = NullBody_instance;
              var tmp_5 = JsType_instance;
              var tmp_6 = getKClass(VcSdJwtVerifiableCredentialRequest);
              var tmp_7;
              try {
                tmp_7 = createKType(getKClass(VcSdJwtVerifiableCredentialRequest), arrayOf([]), false);
              } catch ($p) {
                var tmp_8;
                if ($p instanceof Error) {
                  var cause = $p;
                  tmp_8 = null;
                } else {
                  throw $p;
                }
                tmp_7 = tmp_8;
              }
              this_0.k4z(typeInfoImpl(tmp_5, tmp_6, tmp_7));
            } else {
              if (body instanceof OutgoingContent) {
                this_0.p4t_1 = body;
                this_0.k4z(null);
              } else {
                this_0.p4t_1 = body;
                var tmp_9 = JsType_instance;
                var tmp_10 = getKClass(VcSdJwtVerifiableCredentialRequest);
                var tmp_11;
                try {
                  tmp_11 = createKType(getKClass(VcSdJwtVerifiableCredentialRequest), arrayOf([]), false);
                } catch ($p) {
                  var tmp_12;
                  if ($p instanceof Error) {
                    var cause_0 = $p;
                    tmp_12 = null;
                  } else {
                    throw $p;
                  }
                  tmp_11 = tmp_12;
                }
                this_0.k4z(typeInfoImpl(tmp_9, tmp_10, tmp_11));
              }
            }

            tmp_4.l6b_1 = this_0;
            this.l6b_1.n4t_1 = Companion_getInstance().o4d_1;
            var tmp_13 = this;
            tmp_13.m6b_1 = this.k6b_1;
            var tmp_14 = this;
            tmp_14.n6b_1 = this.l6b_1;
            this.v8_1 = 1;
            suspendResult = (new HttpStatement(this.n6b_1, this.m6b_1)).q5i(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.o6b_1 = suspendResult;
            if (this.o6b_1.y4v().h4g_1 >= 400) {
              var tmp_15 = this;
              tmp_15.p6b_1 = this.o6b_1;
              this.v8_1 = 5;
              var tmp_16 = this.p6b_1.t4w();
              var tmp_17 = JsType_instance;
              var tmp_18 = PrimitiveClasses_getInstance().gb();
              var tmp_19;
              try {
                tmp_19 = createKType(PrimitiveClasses_getInstance().gb(), arrayOf([]), false);
              } catch ($p) {
                var tmp_20;
                if ($p instanceof Error) {
                  var cause_1 = $p;
                  tmp_20 = null;
                } else {
                  throw $p;
                }
                tmp_19 = tmp_20;
              }
              suspendResult = tmp_16.x4v(typeInfoImpl(tmp_17, tmp_18, tmp_19), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.v8_1 = 2;
              continue $sm;
            }

          case 2:
            this.q6b_1 = this.f6b_1.v62_1;
            var tmp_21 = this;
            tmp_21.r6b_1 = this.o6b_1;
            this.v8_1 = 3;
            var tmp_22 = this.r6b_1.t4w();
            var tmp_23 = JsType_instance;
            var tmp_24 = getKClass(VcSdJwtCredentialResponse);
            var tmp_25;
            try {
              tmp_25 = createKType(getKClass(VcSdJwtCredentialResponse), arrayOf([]), false);
            } catch ($p) {
              var tmp_26;
              if ($p instanceof Error) {
                var cause_2 = $p;
                tmp_26 = null;
              } else {
                throw $p;
              }
              tmp_25 = tmp_26;
            }

            suspendResult = tmp_22.x4v(typeInfoImpl(tmp_23, tmp_24, tmp_25), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var tmp_27 = this;
            tmp_27.s6b_1 = (!(suspendResult == null) ? isInterface(suspendResult, VcSdJwtCredentialResponse) : false) ? suspendResult : THROW_CCE();
            this.v8_1 = 4;
            suspendResult = this.q6b_1.y65(this.s6b_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            return suspendResult;
          case 5:
            var body_0 = (!(suspendResult == null) ? typeof suspendResult === 'string' : false) ? suspendResult : THROW_CCE();
            throw Exception_init_$Create$('Credential request with non-success response: ' + this.o6b_1.y4v().h4g_1 + ', ' + body_0);
          case 6:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 6) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function $requestCredentialCOROUTINE$13(_this__u8e3s4, request, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.b6c_1 = _this__u8e3s4;
    this.c6c_1 = request;
  }
  protoOf($requestCredentialCOROUTINE$13).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 6;
            var tmp_0 = this;
            tmp_0.d6c_1 = this.b6c_1.t62_1;
            var tmp_1 = this;
            tmp_1.e6c_1 = this.d6c_1;
            var tmp_2 = this;
            var this_0 = new HttpRequestBuilder();
            path(this_0.m4t_1, [this.b6c_1.u62_1.p33_1]);
            contentType(this_0, Application_getInstance().x47_1);
            var body = this.c6c_1;
            if (body == null) {
              this_0.p4t_1 = NullBody_instance;
              var tmp_3 = JsType_instance;
              var tmp_4 = getKClass(JwtVcJsonLdVerifiableCredentialRequest);
              var tmp_5;
              try {
                tmp_5 = createKType(getKClass(JwtVcJsonLdVerifiableCredentialRequest), arrayOf([]), false);
              } catch ($p) {
                var tmp_6;
                if ($p instanceof Error) {
                  var cause = $p;
                  tmp_6 = null;
                } else {
                  throw $p;
                }
                tmp_5 = tmp_6;
              }
              this_0.k4z(typeInfoImpl(tmp_3, tmp_4, tmp_5));
            } else {
              if (body instanceof OutgoingContent) {
                this_0.p4t_1 = body;
                this_0.k4z(null);
              } else {
                this_0.p4t_1 = body;
                var tmp_7 = JsType_instance;
                var tmp_8 = getKClass(JwtVcJsonLdVerifiableCredentialRequest);
                var tmp_9;
                try {
                  tmp_9 = createKType(getKClass(JwtVcJsonLdVerifiableCredentialRequest), arrayOf([]), false);
                } catch ($p) {
                  var tmp_10;
                  if ($p instanceof Error) {
                    var cause_0 = $p;
                    tmp_10 = null;
                  } else {
                    throw $p;
                  }
                  tmp_9 = tmp_10;
                }
                this_0.k4z(typeInfoImpl(tmp_7, tmp_8, tmp_9));
              }
            }

            tmp_2.f6c_1 = this_0;
            this.f6c_1.n4t_1 = Companion_getInstance().o4d_1;
            var tmp_11 = this;
            tmp_11.g6c_1 = this.e6c_1;
            var tmp_12 = this;
            tmp_12.h6c_1 = this.f6c_1;
            this.v8_1 = 1;
            suspendResult = (new HttpStatement(this.h6c_1, this.g6c_1)).q5i(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.i6c_1 = suspendResult;
            if (this.i6c_1.y4v().h4g_1 >= 400) {
              var tmp_13 = this;
              tmp_13.j6c_1 = this.i6c_1;
              this.v8_1 = 5;
              var tmp_14 = this.j6c_1.t4w();
              var tmp_15 = JsType_instance;
              var tmp_16 = PrimitiveClasses_getInstance().gb();
              var tmp_17;
              try {
                tmp_17 = createKType(PrimitiveClasses_getInstance().gb(), arrayOf([]), false);
              } catch ($p) {
                var tmp_18;
                if ($p instanceof Error) {
                  var cause_1 = $p;
                  tmp_18 = null;
                } else {
                  throw $p;
                }
                tmp_17 = tmp_18;
              }
              suspendResult = tmp_14.x4v(typeInfoImpl(tmp_15, tmp_16, tmp_17), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.v8_1 = 2;
              continue $sm;
            }

          case 2:
            this.k6c_1 = this.b6c_1.v62_1;
            var tmp_19 = this;
            tmp_19.l6c_1 = this.i6c_1;
            this.v8_1 = 3;
            var tmp_20 = this.l6c_1.t4w();
            var tmp_21 = JsType_instance;
            var tmp_22 = getKClass(JwtVcJsonLdCredentialResponse);
            var tmp_23;
            try {
              tmp_23 = createKType(getKClass(JwtVcJsonLdCredentialResponse), arrayOf([]), false);
            } catch ($p) {
              var tmp_24;
              if ($p instanceof Error) {
                var cause_2 = $p;
                tmp_24 = null;
              } else {
                throw $p;
              }
              tmp_23 = tmp_24;
            }

            suspendResult = tmp_20.x4v(typeInfoImpl(tmp_21, tmp_22, tmp_23), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var tmp_25 = this;
            tmp_25.m6c_1 = (!(suspendResult == null) ? isInterface(suspendResult, JwtVcJsonLdCredentialResponse) : false) ? suspendResult : THROW_CCE();
            this.v8_1 = 4;
            suspendResult = this.k6c_1.w65(this.m6c_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            return suspendResult;
          case 5:
            var body_0 = (!(suspendResult == null) ? typeof suspendResult === 'string' : false) ? suspendResult : THROW_CCE();
            throw Exception_init_$Create$('Credential request with non-success response: ' + this.i6c_1.y4v().h4g_1 + ', ' + body_0);
          case 6:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 6) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function $requestCredentialCOROUTINE$14(_this__u8e3s4, request, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.v6c_1 = _this__u8e3s4;
    this.w6c_1 = request;
  }
  protoOf($requestCredentialCOROUTINE$14).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 6;
            var tmp_0 = this;
            tmp_0.x6c_1 = this.v6c_1.t62_1;
            var tmp_1 = this;
            tmp_1.y6c_1 = this.x6c_1;
            var tmp_2 = this;
            var this_0 = new HttpRequestBuilder();
            path(this_0.m4t_1, [this.v6c_1.u62_1.p33_1]);
            contentType(this_0, Application_getInstance().x47_1);
            var body = this.w6c_1;
            if (body == null) {
              this_0.p4t_1 = NullBody_instance;
              var tmp_3 = JsType_instance;
              var tmp_4 = getKClass(LdpVerifiableCredentialRequest);
              var tmp_5;
              try {
                tmp_5 = createKType(getKClass(LdpVerifiableCredentialRequest), arrayOf([]), false);
              } catch ($p) {
                var tmp_6;
                if ($p instanceof Error) {
                  var cause = $p;
                  tmp_6 = null;
                } else {
                  throw $p;
                }
                tmp_5 = tmp_6;
              }
              this_0.k4z(typeInfoImpl(tmp_3, tmp_4, tmp_5));
            } else {
              if (body instanceof OutgoingContent) {
                this_0.p4t_1 = body;
                this_0.k4z(null);
              } else {
                this_0.p4t_1 = body;
                var tmp_7 = JsType_instance;
                var tmp_8 = getKClass(LdpVerifiableCredentialRequest);
                var tmp_9;
                try {
                  tmp_9 = createKType(getKClass(LdpVerifiableCredentialRequest), arrayOf([]), false);
                } catch ($p) {
                  var tmp_10;
                  if ($p instanceof Error) {
                    var cause_0 = $p;
                    tmp_10 = null;
                  } else {
                    throw $p;
                  }
                  tmp_9 = tmp_10;
                }
                this_0.k4z(typeInfoImpl(tmp_7, tmp_8, tmp_9));
              }
            }

            tmp_2.z6c_1 = this_0;
            this.z6c_1.n4t_1 = Companion_getInstance().o4d_1;
            var tmp_11 = this;
            tmp_11.a6d_1 = this.y6c_1;
            var tmp_12 = this;
            tmp_12.b6d_1 = this.z6c_1;
            this.v8_1 = 1;
            suspendResult = (new HttpStatement(this.b6d_1, this.a6d_1)).q5i(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.c6d_1 = suspendResult;
            if (this.c6d_1.y4v().h4g_1 >= 400) {
              var tmp_13 = this;
              tmp_13.d6d_1 = this.c6d_1;
              this.v8_1 = 5;
              var tmp_14 = this.d6d_1.t4w();
              var tmp_15 = JsType_instance;
              var tmp_16 = PrimitiveClasses_getInstance().gb();
              var tmp_17;
              try {
                tmp_17 = createKType(PrimitiveClasses_getInstance().gb(), arrayOf([]), false);
              } catch ($p) {
                var tmp_18;
                if ($p instanceof Error) {
                  var cause_1 = $p;
                  tmp_18 = null;
                } else {
                  throw $p;
                }
                tmp_17 = tmp_18;
              }
              suspendResult = tmp_14.x4v(typeInfoImpl(tmp_15, tmp_16, tmp_17), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.v8_1 = 2;
              continue $sm;
            }

          case 2:
            this.e6d_1 = this.v6c_1.v62_1;
            var tmp_19 = this;
            tmp_19.f6d_1 = this.c6d_1;
            this.v8_1 = 3;
            var tmp_20 = this.f6d_1.t4w();
            var tmp_21 = JsType_instance;
            var tmp_22 = getKClass(LdpVcCredentialResponse);
            var tmp_23;
            try {
              tmp_23 = createKType(getKClass(LdpVcCredentialResponse), arrayOf([]), false);
            } catch ($p) {
              var tmp_24;
              if ($p instanceof Error) {
                var cause_2 = $p;
                tmp_24 = null;
              } else {
                throw $p;
              }
              tmp_23 = tmp_24;
            }

            suspendResult = tmp_20.x4v(typeInfoImpl(tmp_21, tmp_22, tmp_23), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var tmp_25 = this;
            tmp_25.g6d_1 = (!(suspendResult == null) ? isInterface(suspendResult, LdpVcCredentialResponse) : false) ? suspendResult : THROW_CCE();
            this.v8_1 = 4;
            suspendResult = this.e6d_1.x65(this.g6d_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            return suspendResult;
          case 5:
            var body_0 = (!(suspendResult == null) ? typeof suspendResult === 'string' : false) ? suspendResult : THROW_CCE();
            throw Exception_init_$Create$('Credential request with non-success response: ' + this.c6d_1.y4v().h4g_1 + ', ' + body_0);
          case 6:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 6) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function VcClient(httpClient, vcServerMetadata, responseValidator) {
    this.t62_1 = httpClient;
    this.u62_1 = vcServerMetadata;
    this.v62_1 = responseValidator;
    this.w62_1 = this.t62_1;
  }
  protoOf(VcClient).y62 = function (request, $completion) {
    var tmp = new $requestCredentialCOROUTINE$11(this, request, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(VcClient).x62 = function (request, $completion) {
    var tmp = new $requestCredentialCOROUTINE$12(this, request, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(VcClient).h6d = function (request, $completion) {
    var tmp = new $requestCredentialCOROUTINE$13(this, request, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(VcClient).i6d = function (request, $completion) {
    var tmp = new $requestCredentialCOROUTINE$14(this, request, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  function VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda$slambda).o2z = function (it, $completion) {
    var tmp = this.p2z(it, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda$slambda).y9 = function (p1, $completion) {
    return this.o2z((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        if (tmp === 0) {
          this.w8_1 = 1;
          return JwsUtil_getInstance().r2a(this.r6d_1);
        } else if (tmp === 1) {
          throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda$slambda).p2z = function (it, completion) {
    var i = new VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda$slambda(completion);
    i.r6d_1 = it;
    return i;
  };
  function VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda$slambda_0(resultContinuation) {
    var i = new VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda$slambda(resultContinuation);
    var l = function (it, $completion) {
      return i.o2z(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda($response, this$0, resultContinuation) {
    this.a6e_1 = $response;
    this.b6e_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda).f6e = function ($this$suspendableValidationScope, $completion) {
    var tmp = this.x66($this$suspendableValidationScope, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda).y9 = function (p1, $completion) {
    return this.f6e(p1 instanceof ValidationScope ? p1 : THROW_CCE(), $completion);
  };
  protoOf(VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 3;
            var tmp_0 = this;
            var tmp38_subject = this.a6e_1;
            var tmp_1;
            if (tmp38_subject instanceof VcSdJwtVerifiableCredentialResponse) {
              tmp_1 = this.a6e_1.n38();
            } else {
              if (tmp38_subject instanceof Deferred_0) {
                var message = 'Cannot handle deferred response';
                throw IllegalStateException_init_$Create$(toString(message));
              } else {
                noWhenBranchMatchedException();
              }
            }

            tmp_0.d6e_1 = tmp_1;
            this.v8_1 = 1;
            var tmp_2 = Companion_instance_2;
            suspendResult = tmp_2.b2w(this.d6e_1.o2h_1, VOID, VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda$slambda_0(null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.e6e_1 = suspendResult;
            if (!(this.e6e_1.x2n_1 == null) || !(this.e6e_1.w2n_1 == null)) {
              this.c6e_1.vn('Issued credential must not have key-binding JWT');
            }

            this.v8_1 = 2;
            suspendResult = (new VcSdJwtIssuerJwtValidator(this.b6e_1.g6e_1, this.b6e_1.h6e_1)).v2y(this.c6e_1, this.e6e_1.t2n_1, this.e6e_1.s2n_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var validatedIssuerJwtResult = suspendResult;
            if (!(this.b6e_1.i6e_1.t32_1.u33_1 === (validatedIssuerJwtResult == null ? null : validatedIssuerJwtResult.z2w_1))) {
              this.c6e_1.vn('Issued credential issuer does not match metadata issuer');
            }

            if (!(this.b6e_1.j6e_1.n37_1 === (validatedIssuerJwtResult == null ? null : validatedIssuerJwtResult.a2x_1))) {
              this.c6e_1.vn("Issued credential 'vct' does not match metadata 'vct'");
            }

            if (!(validatedIssuerJwtResult == null)) {
              if (!validatedIssuerJwtResult.b2x_1.b29(this.b6e_1.k6e_1.v28_1.u2f())) {
                this.c6e_1.vn("Issued credential 'cnf' claims does not match signing key");
              }
            }

            if (this.c6e_1.rn_1) {
              return null;
            }

            var tmp41_safe_receiver = this.b6e_1.j6e_1.o37_1;
            var tmp42_safe_receiver = tmp41_safe_receiver == null ? null : tmp41_safe_receiver.v37_1;
            var tmp43_safe_receiver = tmp42_safe_receiver == null ? null : tmp42_safe_receiver.z();
            var tmp_3;
            if (tmp43_safe_receiver == null) {
              tmp_3 = null;
            } else {
              var destination = ArrayList_init_$Create$_0();
              var tmp0_iterator = tmp43_safe_receiver.j();
              while (tmp0_iterator.k()) {
                var element = tmp0_iterator.l();
                var key = element.a1();
                var value = element.b1();
                var valueDisplay = value.y37_1;
                var tmp_4;
                if (!(valueDisplay == null)) {
                  tmp_4 = to(key, valueDisplay);
                } else {
                  tmp_4 = null;
                }
                var tmp0_safe_receiver = tmp_4;
                if (tmp0_safe_receiver == null)
                  null;
                else {
                  destination.e(tmp0_safe_receiver);
                }
              }
              tmp_3 = destination;
            }

            var tmp44_safe_receiver = tmp_3;
            var tmp_5;
            if (tmp44_safe_receiver == null) {
              tmp_5 = null;
            } else {
              var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(tmp44_safe_receiver, 10)), 16);
              var destination_0 = LinkedHashMap_init_$Create$(capacity);
              var tmp0_iterator_0 = tmp44_safe_receiver.j();
              while (tmp0_iterator_0.k()) {
                var element_0 = tmp0_iterator_0.l();
                var key_0 = element_0.ba();
                var value_0 = element_0.ca();
                var pair = to(key_0, value_0);
                destination_0.m2(pair.z9_1, pair.aa_1);
              }
              tmp_5 = destination_0;
            }

            var tmp0_elvis_lhs = tmp_5;
            var subjectDisplayInformation = tmp0_elvis_lhs == null ? emptyMap() : tmp0_elvis_lhs;
            var tmp_6;
            if (!(validatedIssuerJwtResult == null)) {
              tmp_6 = new DefaultValidatedVcSdJwtCredentialResponse(this.a6e_1, subjectDisplayInformation, this.b6e_1.j6e_1.r37_1, this.d6e_1.o2h_1, validatedIssuerJwtResult.z2w_1, validatedIssuerJwtResult.a2x_1, this.e6e_1.u2n_1, this.b6e_1.k6e_1.w28_1);
            } else {
              tmp_6 = null;
            }

            return tmp_6;
          case 3:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 3) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  protoOf(VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda).x66 = function ($this$suspendableValidationScope, completion) {
    var i = new VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda(this.a6e_1, this.b6e_1, completion);
    i.c6e_1 = $this$suspendableValidationScope;
    return i;
  };
  function VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda_0($response, this$0, resultContinuation) {
    var i = new VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda($response, this$0, resultContinuation);
    var l = function ($this$suspendableValidationScope, $completion) {
      return i.f6e($this$suspendableValidationScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $validateVcSdJwtCOROUTINE$15(_this__u8e3s4, response, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.t6e_1 = _this__u8e3s4;
    this.u6e_1 = response;
  }
  protoOf($validateVcSdJwtCOROUTINE$15).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            this.v8_1 = 1;
            suspendResult = suspendableValidationScope(VcSdJwtVerifiableCredentialResponseValidator$validateVcSdJwt$slambda_0(this.u6e_1, this.t6e_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return ARGUMENT.xm();
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function VcSdJwtVerifiableCredentialResponseValidator(clock, issuerMetadataLoader, issuer, supportedCredential, signingKeyPair) {
    this.g6e_1 = clock;
    this.h6e_1 = issuerMetadataLoader;
    this.i6e_1 = issuer;
    this.j6e_1 = supportedCredential;
    this.k6e_1 = signingKeyPair;
  }
  protoOf(VcSdJwtVerifiableCredentialResponseValidator).y65 = function (response, $completion) {
    var tmp = new $validateVcSdJwtCOROUTINE$15(this, response, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(VcSdJwtVerifiableCredentialResponseValidator).p65 = function (response, $completion) {
    throw UnsupportedOperationException_init_$Create$("This validator can only handle the 'vc+sd-jwt' format");
  };
  protoOf(VcSdJwtVerifiableCredentialResponseValidator).w65 = function (response, $completion) {
    throw UnsupportedOperationException_init_$Create$("This validator can only handle the 'vc+sd-jwt' format");
  };
  protoOf(VcSdJwtVerifiableCredentialResponseValidator).x65 = function (response, $completion) {
    throw UnsupportedOperationException_init_$Create$("This validator can only handle the 'vc+sd-jwt' format");
  };
  function CredentialFinderResult(data) {
    this.v6e_1 = data;
  }
  protoOf(CredentialFinderResult).toString = function () {
    return 'CredentialFinderResult(data=' + toString(this.v6e_1) + ')';
  };
  protoOf(CredentialFinderResult).hashCode = function () {
    return hashCode(this.v6e_1);
  };
  protoOf(CredentialFinderResult).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CredentialFinderResult))
      return false;
    var tmp0_other_with_cast = other instanceof CredentialFinderResult ? other : THROW_CCE();
    if (!equals(this.v6e_1, tmp0_other_with_cast.v6e_1))
      return false;
    return true;
  };
  function InMemoryPreRegisteredClientStore() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.w6e_1 = LinkedHashMap_init_$Create$_0();
  }
  protoOf(InMemoryPreRegisteredClientStore).x6e = function (clientId, $completion) {
    return this.w6e_1.e2(clientId);
  };
  protoOf(InMemoryPreRegisteredClientStore).y6e = function (preRegistredClient, $completion) {
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.w6e_1;
    var key = preRegistredClient.z6e_1;
    this_0.m2(key, preRegistredClient);
    return Unit_instance;
  };
  protoOf(InMemoryPreRegisteredClientStore).d6f = function ($completion) {
    return toList(this.w6e_1.g2());
  };
  function Companion_4() {
    Companion_instance_13 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.e6f_1 = [new LinkedHashMapSerializer(StringSerializer_getInstance(), $serializer_getInstance_9())];
  }
  var Companion_instance_13;
  function Companion_getInstance_11() {
    if (Companion_instance_13 == null)
      new Companion_4();
    return Companion_instance_13;
  }
  function $serializer_1() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vp.services.InMemoryRequestJwtStore', this, 1);
    tmp0_serialDesc.wy('memory', true);
    this.f6f_1 = tmp0_serialDesc;
  }
  protoOf($serializer_1).g6f = function (encoder, value) {
    var tmp0_desc = this.f6f_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    var tmp2_cached = Companion_getInstance_11().e6f_1;
    var tmp;
    if (tmp1_output.ht(tmp0_desc, 0)) {
      tmp = true;
    } else {
      // Inline function 'kotlin.collections.mutableMapOf' call
      var tmp$ret$0 = LinkedHashMap_init_$Create$_0();
      tmp = !equals(value.h6f_1, tmp$ret$0);
    }
    if (tmp) {
      tmp1_output.bt(tmp0_desc, 0, tmp2_cached[0], value.h6f_1);
    }
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_1).zn = function (encoder, value) {
    return this.g6f(encoder, value instanceof InMemoryRequestJwtStore ? value : THROW_CCE());
  };
  protoOf($serializer_1).ao = function (decoder) {
    var tmp0_desc = this.f6f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.lr(tmp0_desc);
    var tmp6_cached = Companion_getInstance_11().e6f_1;
    if (tmp5_input.as()) {
      tmp4_local0 = tmp5_input.xr(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.xr(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.mr(tmp0_desc);
    return InMemoryRequestJwtStore_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_1).yn = function () {
    return this.f6f_1;
  };
  protoOf($serializer_1).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_11().e6f_1[0]];
  };
  var $serializer_instance_1;
  function $serializer_getInstance_6() {
    if ($serializer_instance_1 == null)
      new $serializer_1();
    return $serializer_instance_1;
  }
  function InMemoryRequestJwtStore_init_$Init$(seen0, memory, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_6().f6f_1);
    }
    if (0 === (seen0 & 1)) {
      var tmp = $this;
      // Inline function 'kotlin.collections.mutableMapOf' call
      tmp.h6f_1 = LinkedHashMap_init_$Create$_0();
    } else
      $this.h6f_1 = memory;
    return $this;
  }
  function InMemoryRequestJwtStore_init_$Create$(seen0, memory, serializationConstructorMarker) {
    return InMemoryRequestJwtStore_init_$Init$(seen0, memory, serializationConstructorMarker, objectCreate(protoOf(InMemoryRequestJwtStore)));
  }
  function InMemoryRequestJwtStore() {
    Companion_getInstance_11();
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.h6f_1 = LinkedHashMap_init_$Create$_0();
  }
  protoOf(InMemoryRequestJwtStore).i6f = function (id, requestJwt) {
    // Inline function 'kotlin.collections.set' call
    this.h6f_1.m2(id, requestJwt);
  };
  protoOf(InMemoryRequestJwtStore).q68 = function (id) {
    this.h6f_1.n2(id);
  };
  protoOf(InMemoryRequestJwtStore).r68 = function (id) {
    return this.h6f_1.e2(id);
  };
  protoOf(InMemoryRequestJwtStore).u68 = function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.h6f_1.z();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.j();
    while (tmp0_iterator.k()) {
      var item = tmp0_iterator.l();
      // Inline function 'io.curity.vp.services.InMemoryRequestJwtStore.getAll.<anonymous>' call
      var tmp$ret$0 = new Pair(item.a1(), item.b1());
      destination.e(tmp$ret$0);
    }
    return destination;
  };
  function Companion_5() {
  }
  protoOf(Companion_5).j6f = function (field) {
    var fieldFilter = field.e3e_1;
    var tmp;
    if (fieldFilter instanceof JsonArrayContainsFilter) {
      var tmp_0;
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var this_0 = field.d3e_1;
        var tmp_1;
        if (isInterface(this_0, Collection)) {
          tmp_1 = this_0.s();
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
        var tmp0_iterator = this_0.j();
        while (tmp0_iterator.k()) {
          var element = tmp0_iterator.l();
          // Inline function 'io.curity.vp.services.Companion.buildFrom.<anonymous>' call
          if (element === '$.vc.type') {
            tmp$ret$0 = true;
            break $l$block_0;
          }
        }
        tmp$ret$0 = false;
      }
      if (tmp$ret$0) {
        tmp_0 = new JwtVcJsonType(fieldFilter.j3e_1.n3e_1);
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    } else {
      if (fieldFilter instanceof JsonStringFilter) {
        var tmp_2;
        var tmp$ret$2;
        $l$block_2: {
          // Inline function 'kotlin.collections.any' call
          var this_1 = field.d3e_1;
          var tmp_3;
          if (isInterface(this_1, Collection)) {
            tmp_3 = this_1.s();
          } else {
            tmp_3 = false;
          }
          if (tmp_3) {
            tmp$ret$2 = false;
            break $l$block_2;
          }
          var tmp0_iterator_0 = this_1.j();
          while (tmp0_iterator_0.k()) {
            var element_0 = tmp0_iterator_0.l();
            // Inline function 'io.curity.vp.services.Companion.buildFrom.<anonymous>' call
            if (element_0 === '$.vc.issuer') {
              tmp$ret$2 = true;
              break $l$block_2;
            }
          }
          tmp$ret$2 = false;
        }
        if (tmp$ret$2) {
          tmp_2 = new JwtVcJsonIssuer(fieldFilter.r3e_1);
        } else {
          var tmp$ret$4;
          $l$block_4: {
            // Inline function 'kotlin.collections.any' call
            var this_2 = field.d3e_1;
            var tmp_4;
            if (isInterface(this_2, Collection)) {
              tmp_4 = this_2.s();
            } else {
              tmp_4 = false;
            }
            if (tmp_4) {
              tmp$ret$4 = false;
              break $l$block_4;
            }
            var tmp0_iterator_1 = this_2.j();
            while (tmp0_iterator_1.k()) {
              var element_1 = tmp0_iterator_1.l();
              // Inline function 'io.curity.vp.services.Companion.buildFrom.<anonymous>' call
              if (element_1 === '$.iss') {
                tmp$ret$4 = true;
                break $l$block_4;
              }
            }
            tmp$ret$4 = false;
          }
          if (tmp$ret$4) {
            tmp_2 = new VcSdJwtIssuer(fieldFilter.r3e_1);
          } else {
            var tmp$ret$6;
            $l$block_6: {
              // Inline function 'kotlin.collections.any' call
              var this_3 = field.d3e_1;
              var tmp_5;
              if (isInterface(this_3, Collection)) {
                tmp_5 = this_3.s();
              } else {
                tmp_5 = false;
              }
              if (tmp_5) {
                tmp$ret$6 = false;
                break $l$block_6;
              }
              var tmp0_iterator_2 = this_3.j();
              while (tmp0_iterator_2.k()) {
                var element_2 = tmp0_iterator_2.l();
                // Inline function 'io.curity.vp.services.Companion.buildFrom.<anonymous>' call
                if (element_2 === '$.vct') {
                  tmp$ret$6 = true;
                  break $l$block_6;
                }
              }
              tmp$ret$6 = false;
            }
            if (tmp$ret$6) {
              tmp_2 = new VcSdJwtType(fieldFilter.r3e_1);
            } else {
              tmp_2 = null;
            }
          }
        }
        tmp = tmp_2;
      } else {
        if (fieldFilter == null) {
          tmp = null;
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
    return tmp;
  };
  var Companion_instance_14;
  function Companion_getInstance_12() {
    return Companion_instance_14;
  }
  function JwtVcJsonIssuer(issuerPattern) {
    this.k6f_1 = issuerPattern;
  }
  protoOf(JwtVcJsonIssuer).l6f = function (credential) {
    var credentialResponse = credential.e33_1;
    var tmp;
    if (credentialResponse instanceof DidValidatedJwtVcJsonCredentialResponse) {
      var issuer = credentialResponse.g31_1.x3b_1;
      var tmp_0;
      if (issuer instanceof IssuerURI_0) {
        tmp_0 = Regex_init_$Create$(this.k6f_1).ic(issuer.m36_1);
      } else {
        if (issuer instanceof IssuerObject_0) {
          tmp_0 = Regex_init_$Create$(this.k6f_1).ic(issuer.k3c_1);
        } else {
          tmp_0 = false;
        }
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  function JwtVcJsonType(typePattern) {
    this.m6f_1 = Regex_init_$Create$(typePattern);
  }
  protoOf(JwtVcJsonType).l6f = function (credential) {
    var credentialResponse = credential.e33_1;
    var tmp;
    if (credentialResponse instanceof DidValidatedJwtVcJsonCredentialResponse) {
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var this_0 = credentialResponse.g31_1.v3b_1;
        var tmp_0;
        if (isInterface(this_0, Collection)) {
          tmp_0 = this_0.s();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
        var tmp0_iterator = this_0.j();
        while (tmp0_iterator.k()) {
          var element = tmp0_iterator.l();
          // Inline function 'io.curity.vp.services.JwtVcJsonType.matches.<anonymous>' call
          if (this.m6f_1.ic(element)) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
        }
        tmp$ret$0 = false;
      }
      tmp = tmp$ret$0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  function VcSdJwtIssuer(issuerPattern) {
    this.n6f_1 = issuerPattern;
    this.o6f_1 = Regex_init_$Create$(this.n6f_1);
  }
  protoOf(VcSdJwtIssuer).l6f = function (credential) {
    var credentialResponse = credential.e33_1;
    var tmp;
    if (credentialResponse instanceof DefaultValidatedVcSdJwtCredentialResponse) {
      tmp = this.o6f_1.ic(credentialResponse.x30_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function VcSdJwtType(typePattern) {
    this.p6f_1 = typePattern;
    this.q6f_1 = Regex_init_$Create$(this.p6f_1);
  }
  protoOf(VcSdJwtType).l6f = function (credential) {
    var credentialResponse = credential.e33_1;
    var tmp;
    if (credentialResponse instanceof DefaultValidatedVcSdJwtCredentialResponse) {
      tmp = this.q6f_1.ic(credentialResponse.y30_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function getRequestedConstraintsAsMatchers($this, constraintFields) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(constraintFields, 10));
    var tmp0_iterator = constraintFields.j();
    while (tmp0_iterator.k()) {
      var item = tmp0_iterator.l();
      // Inline function 'io.curity.vp.services.OpenIdWalletAuthenticatorCredentialFinder.getRequestedConstraintsAsMatchers.<anonymous>' call
      var tmp0_elvis_lhs = Companion_instance_14.j6f(item);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        var message = 'Unsupported field filter ' + item.toString();
        throw IllegalStateException_init_$Create$(toString(message));
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var tmp$ret$0 = tmp;
      destination.e(tmp$ret$0);
    }
    return destination;
  }
  function OpenIdWalletAuthenticatorCredentialFinder(credentialStore) {
    this.r6f_1 = credentialStore;
  }
  protoOf(OpenIdWalletAuthenticatorCredentialFinder).s6f = function (presentationDefinition, $completion) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = presentationDefinition.k3d_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.j();
    while (tmp0_iterator.k()) {
      var item = tmp0_iterator.l();
      // Inline function 'io.curity.vp.services.OpenIdWalletAuthenticatorCredentialFinder.find.<anonymous>' call
      var tmp0_elvis_lhs = item.q3d_1.v3d_1;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        var message = "Unsupported presentation_definition format (missing 'fields').";
        throw IllegalStateException_init_$Create$(toString(message));
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var constraintFields = tmp;
      var matchers = getRequestedConstraintsAsMatchers(this, constraintFields);
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_1 = this.r6f_1.u68();
      var destination_0 = ArrayList_init_$Create$_0();
      var tmp0_iterator_0 = this_1.j();
      while (tmp0_iterator_0.k()) {
        var element = tmp0_iterator_0.l();
        // Inline function 'io.curity.vp.services.OpenIdWalletAuthenticatorCredentialFinder.find.<anonymous>.<anonymous>' call
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.all' call
          var tmp_0;
          if (isInterface(matchers, Collection)) {
            tmp_0 = matchers.s();
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
          var tmp0_iterator_1 = matchers.j();
          while (tmp0_iterator_1.k()) {
            var element_0 = tmp0_iterator_1.l();
            // Inline function 'io.curity.vp.services.OpenIdWalletAuthenticatorCredentialFinder.find.<anonymous>.<anonymous>.<anonymous>' call
            if (!element_0.l6f(element)) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
          }
          tmp$ret$0 = true;
        }
        if (tmp$ret$0) {
          destination_0.e(element);
        }
      }
      var credentials = destination_0;
      var tmp$ret$5 = to(item, credentials);
      destination.e(tmp$ret$5);
    }
    var data = destination;
    return new CredentialFinderResult(data);
  };
  function Companion_6() {
    Companion_instance_15 = this;
    this.t6f_1 = listOf('https://www.w3.org/2018/credentials/v1');
    this.u6f_1 = listOf('VerifiablePresentation');
  }
  var Companion_instance_15;
  function Companion_getInstance_13() {
    if (Companion_instance_15 == null)
      new Companion_6();
    return Companion_instance_15;
  }
  function createVerifiablePresentation($this, validatedRequestJwt, inputDescriptor, credential, topLevelJsonPath, presentationDisclosures, $completion) {
    var tmp = new $createVerifiablePresentationCOROUTINE$20($this, validatedRequestJwt, inputDescriptor, credential, topLevelJsonPath, presentationDisclosures, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  }
  function createVpJwt($this, validatedRequestJwt, w3cPresentation, vc, $completion) {
    var tmp = new $createVpJwtCOROUTINE$21($this, validatedRequestJwt, w3cPresentation, vc, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  }
  function createVpSdJwt($this, validatedRequestJwt, vc, presentationDisclosures, kid, $completion) {
    var tmp = new $createVpSdJwtCOROUTINE$22($this, validatedRequestJwt, vc, presentationDisclosures, kid, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  }
  function getVerifiablePresentationIssuer($this, credential) {
    var parsedVc = JwsUtil_getInstance().r2a(credential);
    var tmp64_safe_receiver = parsedVc.k29_1.vl('vc');
    var tmp0_elvis_lhs = tmp64_safe_receiver == null ? null : get_jsonObject(tmp64_safe_receiver);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var message = 'missing vc claim';
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var vcClaim = tmp;
    var tmp65_safe_receiver = vcClaim.vl('credentialSubject');
    var tmp1_elvis_lhs = tmp65_safe_receiver == null ? null : get_jsonObject(tmp65_safe_receiver);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      var message_0 = 'missing credentialSubject claim';
      throw IllegalStateException_init_$Create$(toString(message_0));
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var credentialSubject = tmp_0;
    var tmp66_safe_receiver = credentialSubject.vl('id');
    var tmp67_safe_receiver = tmp66_safe_receiver == null ? null : get_jsonPrimitive(tmp66_safe_receiver);
    var tmp2_elvis_lhs = tmp67_safe_receiver == null ? null : tmp67_safe_receiver.e1b();
    var tmp_1;
    if (tmp2_elvis_lhs == null) {
      var message_1 = "Cannot create a presentation from credential which doesn't have credential subject.";
      throw IllegalStateException_init_$Create$(toString(message_1));
    } else {
      tmp_1 = tmp2_elvis_lhs;
    }
    var credSubjectString = tmp_1;
    var tmp3_elvis_lhs = Companion_getInstance_2().d2i(credSubjectString + '#0');
    var tmp_2;
    if (tmp3_elvis_lhs == null) {
      var message_2 = 'Cannot create a presentation because credential subject is not a DID.';
      throw IllegalStateException_init_$Create$(toString(message_2));
    } else {
      tmp_2 = tmp3_elvis_lhs;
    }
    var didUrl = tmp_2;
    return didUrl;
  }
  function createPresentationSubmission($this, validatedRequestJwt, descriptorMapObjects) {
    return new JsonPresentationSubmission(Companion_instance_3.t28(16), validatedRequestJwt.j6i_1.g3d_1, descriptorMapObjects);
  }
  function PresentationResponseCreator$createVpSdJwt$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(PresentationResponseCreator$createVpSdJwt$slambda).o2z = function (it, $completion) {
    var tmp = this.p2z(it, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(PresentationResponseCreator$createVpSdJwt$slambda).y9 = function (p1, $completion) {
    return this.o2z((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(PresentationResponseCreator$createVpSdJwt$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        if (tmp === 0) {
          this.w8_1 = 1;
          return JwsUtil_getInstance().r2a(this.u6i_1);
        } else if (tmp === 1) {
          throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(PresentationResponseCreator$createVpSdJwt$slambda).p2z = function (it, completion) {
    var i = new PresentationResponseCreator$createVpSdJwt$slambda(completion);
    i.u6i_1 = it;
    return i;
  };
  function PresentationResponseCreator$createVpSdJwt$slambda_0(resultContinuation) {
    var i = new PresentationResponseCreator$createVpSdJwt$slambda(resultContinuation);
    var l = function (it, $completion) {
      return i.o2z(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $createVerifiablePresentationResponseCOROUTINE$19(_this__u8e3s4, validatedRequestJwt, userSelectedCredentials, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.d6j_1 = _this__u8e3s4;
    this.e6j_1 = validatedRequestJwt;
    this.f6j_1 = userSelectedCredentials;
  }
  protoOf($createVerifiablePresentationResponseCOROUTINE$19).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 6;
            if (this.f6j_1.y6j_1.m() === 1) {
              this.h6j_1 = first(this.f6j_1.y6j_1);
              this.i6j_1 = this.h6j_1.z6j_1;
              this.j6j_1 = this.h6j_1.a6k_1;
              this.k6j_1 = this.h6j_1.b6k_1;
              this.l6j_1 = '$';
              this.v8_1 = 4;
              suspendResult = createVerifiablePresentation(this.d6j_1, this.e6j_1, this.i6j_1, this.j6j_1, this.l6j_1, this.k6j_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_0 = this;
              tmp_0.m6j_1 = this.f6j_1.y6j_1;
              var tmp_1 = this;
              tmp_1.n6j_1 = this.m6j_1;
              var tmp_2 = this;
              tmp_2.o6j_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this.m6j_1, 10));
              this.p6j_1 = 0;
              this.q6j_1 = this.n6j_1.j();
              this.v8_1 = 1;
              continue $sm;
            }

          case 1:
            if (!this.q6j_1.k()) {
              this.v8_1 = 3;
              continue $sm;
            }

            this.r6j_1 = this.q6j_1.l();
            var tmp_3 = this;
            var tmp1 = this.p6j_1;
            this.p6j_1 = tmp1 + 1 | 0;
            tmp_3.s6j_1 = checkIndexOverflow(tmp1);
            var tmp_4 = this;
            tmp_4.t6j_1 = this.r6j_1;
            this.u6j_1 = this.t6j_1.z6j_1;
            this.v6j_1 = this.t6j_1.a6k_1;
            this.w6j_1 = this.t6j_1.b6k_1;
            this.x6j_1 = '$[' + this.s6j_1 + ']';
            this.v8_1 = 2;
            suspendResult = createVerifiablePresentation(this.d6j_1, this.e6j_1, this.u6j_1, this.v6j_1, this.x6j_1, this.w6j_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            this.o6j_1.e(ARGUMENT);
            this.v8_1 = 1;
            continue $sm;
          case 3:
            this.g6j_1 = this.o6j_1;
            this.v8_1 = 5;
            continue $sm;
          case 4:
            var ARGUMENT_0 = suspendResult;
            this.g6j_1 = listOf(ARGUMENT_0);
            this.v8_1 = 5;
            continue $sm;
          case 5:
            var descriptorsAndPresentations = this.g6j_1;
            var destination = ArrayList_init_$Create$(collectionSizeOrDefault(descriptorsAndPresentations, 10));
            var tmp0_iterator = descriptorsAndPresentations.j();
            while (tmp0_iterator.k()) {
              var item = tmp0_iterator.l();
              destination.e(item.z9_1);
            }

            var descriptors = destination;
            var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(descriptorsAndPresentations, 10));
            var tmp0_iterator_0 = descriptorsAndPresentations.j();
            while (tmp0_iterator_0.k()) {
              var item_0 = tmp0_iterator_0.l();
              destination_0.e(item_0.aa_1);
            }

            var presentations = destination_0;
            return new VerifiablePresentationResponseParameters(DefaultJsonMultiValue_init_$Create$_0(presentations), createPresentationSubmission(this.d6j_1, this.e6j_1, descriptors), this.e6j_1.k6i_1);
          case 6:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 6) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function $createVerifiablePresentationCOROUTINE$20(_this__u8e3s4, validatedRequestJwt, inputDescriptor, credential, topLevelJsonPath, presentationDisclosures, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.d6g_1 = _this__u8e3s4;
    this.e6g_1 = validatedRequestJwt;
    this.f6g_1 = inputDescriptor;
    this.g6g_1 = credential;
    this.h6g_1 = topLevelJsonPath;
    this.i6g_1 = presentationDisclosures;
  }
  protoOf($createVerifiablePresentationCOROUTINE$20).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 4;
            this.j6g_1 = this.g6g_1.e33_1;
            var tmp_0 = this.j6g_1;
            if (tmp_0 instanceof DidValidatedJwtVcJsonCredentialResponse) {
              var tmp_1;
              if (!(this.i6g_1 == null)) {
                tmp_1 = !this.i6g_1.c6k_1.s();
              } else {
                tmp_1 = false;
              }
              if (tmp_1) {
                var message = "presentation disclosures cannot be used with the 'jwt_vc_json' format";
                throw IllegalStateException_init_$Create$(toString(message));
              }
              this.l6g_1 = new SerializableW3CVerifiablePresentation(VOID, Companion_getInstance_13().t6f_1, Companion_getInstance_13().u6f_1, VOID, VOID, DefaultJsonMultiValue_init_$Create$(new StringCredential(this.j6g_1.f31_1)));
              this.m6g_1 = this.f6g_1.r3d_1;
              if (!(this.m6g_1 == null) && (this.m6g_1.s3e_1 == null || this.m6g_1.t3e_1 == null)) {
                var message_0 = 'Unsupported presentation format requested: ' + toString_0(this.f6g_1.r3d_1);
                throw IllegalStateException_init_$Create$(toString(message_0));
              }
              this.n6g_1 = new JsonDescriptorMapObject(this.f6g_1.n3d_1, 'jwt_vp_json', this.h6g_1, new JsonPathNested('jwt_vc_json', '$.vp.verifiableCredential'));
              this.v8_1 = 2;
              suspendResult = createVpJwt(this.d6g_1, this.e6g_1, this.l6g_1, this.j6g_1.f31_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_2 = this.j6g_1;
              if (tmp_2 instanceof DefaultValidatedVcSdJwtCredentialResponse) {
                this.o6g_1 = new JsonDescriptorMapObject(this.f6g_1.n3d_1, 'vc+sd-jwt', this.h6g_1, null);
                this.v8_1 = 1;
                var tmp55_safe_receiver = this.i6g_1;
                var tmp0_elvis_lhs = tmp55_safe_receiver == null ? null : tmp55_safe_receiver.c6k_1;
                suspendResult = createVpSdJwt(this.d6g_1, this.e6g_1, this.j6g_1.w30_1, tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs, this.j6g_1.a31_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_3 = this;
                var message_1 = 'Unsupported credential type: ' + getKClassFromExpression(this.g6g_1.e33_1).fa();
                throw IllegalStateException_init_$Create$(toString(message_1));
              }
            }

          case 1:
            var ARGUMENT = suspendResult;
            var presentation = new JsonStringVerifiablePresentation(ARGUMENT);
            this.k6g_1 = to(this.o6g_1, presentation);
            this.v8_1 = 3;
            continue $sm;
          case 2:
            var ARGUMENT_0 = suspendResult;
            var presentation_0 = new JsonStringVerifiablePresentation(ARGUMENT_0);
            this.k6g_1 = to(this.n6g_1, presentation_0);
            this.v8_1 = 3;
            continue $sm;
          case 3:
            return this.k6g_1;
          case 4:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 4) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function $createVpJwtCOROUTINE$21(_this__u8e3s4, validatedRequestJwt, w3cPresentation, vc, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.x6g_1 = _this__u8e3s4;
    this.y6g_1 = validatedRequestJwt;
    this.z6g_1 = w3cPresentation;
    this.a6h_1 = vc;
  }
  protoOf($createVpJwtCOROUTINE$21).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 5;
            this.b6h_1 = getVerifiablePresentationIssuer(this.x6g_1, this.a6h_1);
            this.c6h_1 = new JsonJwsHeader('ES256', 'JWT', VOID, VOID, VOID, this.b6h_1.toString());
            this.d6h_1 = this.x6g_1.d6k_1.u1l();
            this.e6h_1 = this.b6h_1.e2i_1.l2i_1;
            var tmp_0 = this;
            var tmp56_jti = Companion_instance_3.t28(32);
            var tmp57_aud = DefaultJsonMultiValue_init_$Create$(this.y6g_1.h6i_1);
            var tmp58_nbf = this.d6h_1.f1m();
            var tmp59_exp = this.d6h_1.f1m().y2(toLong(3600));
            var tmp60_customClaims = mapOf(to('vp', this.z6g_1.a27()));
            tmp_0.f6h_1 = new JsonJwtClaimsSet(this.e6h_1, VOID, tmp57_aud, tmp59_exp, tmp58_nbf, VOID, tmp56_jti, VOID, tmp60_customClaims);
            this.v8_1 = 1;
            suspendResult = this.x6g_1.e6k_1.k68(this.b6h_1.toString(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.g6h_1 = suspendResult;
            if (this.g6h_1 == null) {
              this.h6h_1 = null;
              this.v8_1 = 3;
              continue $sm;
            } else {
              var tmp_1 = this;
              tmp_1.i6h_1 = this.g6h_1;
              var tmp_2 = this;
              tmp_2.j6h_1 = this.i6h_1;
              this.v8_1 = 2;
              suspendResult = this.x6g_1.f6k_1.g2b(this.j6h_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            this.k6h_1 = suspendResult;
            this.h6h_1 = this.k6h_1 == null ? null : this.k6h_1.u28_1;
            this.v8_1 = 3;
            continue $sm;
          case 3:
            this.l6h_1 = this.h6h_1;
            var tmp_3 = this;
            var tmp_4;
            if (this.l6h_1 == null) {
              var message = 'Cannot create a presentation. Missing private key for DID URL: ' + this.b6h_1.toString();
              throw IllegalStateException_init_$Create$(toString(message));
            } else {
              tmp_4 = this.l6h_1;
            }

            tmp_3.m6h_1 = tmp_4;
            this.v8_1 = 4;
            suspendResult = JwsUtil_getInstance().j2d(this.m6h_1, this.c6h_1, this.f6h_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            return suspendResult;
          case 5:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 5) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function $createVpSdJwtCOROUTINE$22(_this__u8e3s4, validatedRequestJwt, vc, presentationDisclosures, kid, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.v6h_1 = _this__u8e3s4;
    this.w6h_1 = validatedRequestJwt;
    this.x6h_1 = vc;
    this.y6h_1 = presentationDisclosures;
    this.z6h_1 = kid;
  }
  protoOf($createVpSdJwtCOROUTINE$22).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 4;
            this.v8_1 = 1;
            var tmp_0 = Companion_instance_2;
            suspendResult = tmp_0.b2w(this.x6h_1, VOID, PresentationResponseCreator$createVpSdJwt$slambda_0(null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.a6i_1 = suspendResult;
            if (!(this.a6i_1.x2n_1 == null) || !(this.a6i_1.w2n_1 == null)) {
              throw IllegalArgumentException_init_$Create$('Credential SD-JWT cannot have a KB-JWT');
            }

            this.v8_1 = 2;
            suspendResult = this.v6h_1.f6k_1.g2b(this.z6h_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.b6i_1 = suspendResult;
            this.c6i_1 = this.b6i_1 == null ? null : this.b6i_1.u28_1;
            var tmp_1 = this;
            var tmp_2;
            if (this.c6i_1 == null) {
              var message = 'Cannot create a presentation. Missing private key with id: ' + this.z6h_1;
              throw IllegalStateException_init_$Create$(toString(message));
            } else {
              tmp_2 = this.c6i_1;
            }

            tmp_1.d6i_1 = tmp_2;
            var tmp$ret$0;
            l$ret$1: do {
              var this_0 = this.y6h_1;
              var tmp_3;
              if (isInterface(this_0, Collection)) {
                tmp_3 = this_0.s();
              } else {
                tmp_3 = false;
              }
              if (tmp_3) {
                tmp$ret$0 = false;
                break l$ret$1;
              }
              var tmp0_iterator = this_0.j();
              while (tmp0_iterator.k()) {
                var element = tmp0_iterator.l();
                if (!this.a6i_1.v2n_1.a2(element)) {
                  tmp$ret$0 = true;
                  break l$ret$1;
                }
              }
              tmp$ret$0 = false;
            }
             while (false);
            if (tmp$ret$0) {
              var message_0 = 'A presentation disclosure is not in the originally issued SD-JWT';
              throw IllegalStateException_init_$Create$(toString(message_0));
            }

            this.e6i_1 = 'ES256';
            this.v8_1 = 3;
            suspendResult = SdJwtKeyBindingBuilder_instance.u2r(this.v6h_1.d6k_1.u1l(), this.w6h_1.h6i_1, this.w6h_1.i6i_1, this.a6i_1.t2n_1, this.a6i_1.s2n_1, this.y6h_1, this.d6i_1, this.e6i_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var kbJwtString = suspendResult;
            return Companion_instance_4.m2n(this.a6i_1.s2n_1, this.y6h_1, kbJwtString);
          case 4:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 4) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function PresentationResponseCreator(clock, keyAliasStore, keyStore) {
    Companion_getInstance_13();
    this.d6k_1 = clock;
    this.e6k_1 = keyAliasStore;
    this.f6k_1 = keyStore;
  }
  protoOf(PresentationResponseCreator).g6k = function (validatedRequestJwt, userSelectedCredentials, $completion) {
    var tmp = new $createVerifiablePresentationResponseCOROUTINE$19(this, validatedRequestJwt, userSelectedCredentials, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  function UserSelectedCredentials(data) {
    this.y6j_1 = data;
  }
  protoOf(UserSelectedCredentials).toString = function () {
    return 'UserSelectedCredentials(data=' + toString(this.y6j_1) + ')';
  };
  protoOf(UserSelectedCredentials).hashCode = function () {
    return hashCode(this.y6j_1);
  };
  protoOf(UserSelectedCredentials).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UserSelectedCredentials))
      return false;
    var tmp0_other_with_cast = other instanceof UserSelectedCredentials ? other : THROW_CCE();
    if (!equals(this.y6j_1, tmp0_other_with_cast.y6j_1))
      return false;
    return true;
  };
  function UserSelectedCredential(descriptor, credential, presentationDisclosure) {
    this.z6j_1 = descriptor;
    this.a6k_1 = credential;
    this.b6k_1 = presentationDisclosure;
  }
  protoOf(UserSelectedCredential).toString = function () {
    return 'UserSelectedCredential(descriptor=' + this.z6j_1.toString() + ', credential=' + this.a6k_1.toString() + ', presentationDisclosure=' + this.b6k_1.toString() + ')';
  };
  protoOf(UserSelectedCredential).hashCode = function () {
    var result = this.z6j_1.hashCode();
    result = imul(result, 31) + this.a6k_1.hashCode() | 0;
    result = imul(result, 31) + this.b6k_1.hashCode() | 0;
    return result;
  };
  protoOf(UserSelectedCredential).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UserSelectedCredential))
      return false;
    var tmp0_other_with_cast = other instanceof UserSelectedCredential ? other : THROW_CCE();
    if (!this.z6j_1.equals(tmp0_other_with_cast.z6j_1))
      return false;
    if (!this.a6k_1.equals(tmp0_other_with_cast.a6k_1))
      return false;
    if (!this.b6k_1.equals(tmp0_other_with_cast.b6k_1))
      return false;
    return true;
  };
  function PresentationDisclosure(disclosures) {
    this.c6k_1 = disclosures;
  }
  protoOf(PresentationDisclosure).toString = function () {
    return 'PresentationDisclosure(disclosures=' + toString(this.c6k_1) + ')';
  };
  protoOf(PresentationDisclosure).hashCode = function () {
    return hashCode(this.c6k_1);
  };
  protoOf(PresentationDisclosure).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PresentationDisclosure))
      return false;
    var tmp0_other_with_cast = other instanceof PresentationDisclosure ? other : THROW_CCE();
    if (!equals(this.c6k_1, tmp0_other_with_cast.c6k_1))
      return false;
    return true;
  };
  function $fetchRequestObjectJwtCOROUTINE$23(_this__u8e3s4, uri, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.p6k_1 = _this__u8e3s4;
    this.q6k_1 = uri;
  }
  protoOf($fetchRequestObjectJwtCOROUTINE$23).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 4;
            var tmp_0 = this;
            tmp_0.r6k_1 = this.p6k_1.c6l_1;
            var tmp_1 = this;
            tmp_1.s6k_1 = this.q6k_1;
            var tmp_2 = this;
            tmp_2.t6k_1 = this.r6k_1;
            var tmp_3 = this;
            tmp_3.u6k_1 = this.t6k_1;
            var tmp_4 = this;
            var this_0 = new HttpRequestBuilder();
            url(this_0, this.s6k_1);
            header(this_0, 'Accept', 'application/jwt');
            tmp_4.v6k_1 = this_0;
            this.v6k_1.n4t_1 = Companion_getInstance().n4d_1;
            var tmp_5 = this;
            tmp_5.w6k_1 = this.u6k_1;
            var tmp_6 = this;
            tmp_6.x6k_1 = this.v6k_1;
            this.v8_1 = 1;
            suspendResult = (new HttpStatement(this.x6k_1, this.w6k_1)).q5i(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.y6k_1 = suspendResult;
            if (!this.y6k_1.y4v().equals(Companion_getInstance_4().h4e_1)) {
              throw RuntimeException_init_$Create$('Unexpected response while fetching request object. Got status: ' + this.y6k_1.y4v().h4g_1);
            }

            this.z6k_1 = this.p6k_1.d6l_1;
            var tmp_7 = this;
            tmp_7.a6l_1 = this.y6k_1;
            this.v8_1 = 2;
            var tmp_8 = this.a6l_1.t4w();
            var tmp_9 = JsType_instance;
            var tmp_10 = PrimitiveClasses_getInstance().gb();
            var tmp_11;
            try {
              tmp_11 = createKType(PrimitiveClasses_getInstance().gb(), arrayOf([]), false);
            } catch ($p) {
              var tmp_12;
              if ($p instanceof Error) {
                var cause = $p;
                tmp_12 = null;
              } else {
                throw $p;
              }
              tmp_11 = tmp_12;
            }

            suspendResult = tmp_8.x4v(typeInfoImpl(tmp_9, tmp_10, tmp_11), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp_13 = this;
            tmp_13.b6l_1 = (!(suspendResult == null) ? typeof suspendResult === 'string' : false) ? suspendResult : THROW_CCE();
            this.v8_1 = 3;
            suspendResult = this.z6k_1.h6l(this.b6l_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            return suspendResult;
          case 4:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 4) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function $postDirectPostAuthorizationResponseCOROUTINE$24(_this__u8e3s4, uri, params, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.q6l_1 = _this__u8e3s4;
    this.r6l_1 = uri;
    this.s6l_1 = params;
  }
  protoOf($postDirectPostAuthorizationResponseCOROUTINE$24).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 4;
            var tmp_0 = this;
            var this_0 = Default_getInstance();
            var value = this.s6l_1.z6l_1;
            var this_1 = this_0.dp();
            var this_2 = serializer(this_1, createKType(getKClass(JsonPresentationSubmission), arrayOf([]), false));
            tmp_0.t6l_1 = this_0.bp(isInterface(this_2, KSerializer) ? this_2 : THROW_CCE(), value);
            var tmp_1 = this;
            var this_3 = Default_getInstance();
            var value_0 = this.s6l_1.y6l_1;
            var this_4 = this_3.dp();
            var this_5 = serializer(this_4, createKType(getKClass(DefaultJsonMultiValue), arrayOf([createInvariantKTypeProjection(createKType(getKClass(JsonVerifiablePresentation), arrayOf([]), false))]), false));
            tmp_1.u6l_1 = this_3.bp(isInterface(this_5, KSerializer) ? this_5 : THROW_CCE(), value_0);
            this.v8_1 = 1;
            Companion_getInstance_5();
            var this_6 = ParametersBuilder();
            this_6.w43('vp_token', this.u6l_1);
            this_6.w43('presentation_submission', this.t6l_1);
            if (!(this.s6l_1.a6m_1 == null)) {
              this_6.w43('state', this.s6l_1.a6m_1);
            }

            suspendResult = submitForm(this.q6l_1.c6l_1, this.r6l_1, this_6.c3r(), VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.v6l_1 = suspendResult;
            if (this.v6l_1.y4v().equals(Companion_getInstance_4().h4e_1)) {
              var tmp_2 = this;
              tmp_2.x6l_1 = this.v6l_1;
              this.v8_1 = 2;
              var tmp_3 = this.x6l_1.t4w();
              var tmp_4 = JsType_instance;
              var tmp_5 = getKClass(JsonVerifierDirectPostAuthorizationResponse);
              var tmp_6;
              try {
                tmp_6 = createKType(getKClass(JsonVerifierDirectPostAuthorizationResponse), arrayOf([]), false);
              } catch ($p) {
                var tmp_7;
                if ($p instanceof Error) {
                  var cause = $p;
                  tmp_7 = null;
                } else {
                  throw $p;
                }
                tmp_6 = tmp_7;
              }
              suspendResult = tmp_3.x4v(typeInfoImpl(tmp_4, tmp_5, tmp_6), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_8 = this;
              throw Exception_init_$Create$('Validating verifiable presentations failed: ' + this.v6l_1.y4v().toString());
            }

          case 2:
            var tmp_9 = this;
            tmp_9.w6l_1 = suspendResult instanceof JsonVerifierDirectPostAuthorizationResponse ? suspendResult : THROW_CCE();
            this.v8_1 = 3;
            continue $sm;
          case 3:
            return this.w6l_1;
          case 4:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 4) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function VerifierClient(httpClient, validator) {
    this.c6l_1 = httpClient;
    this.d6l_1 = validator;
  }
  protoOf(VerifierClient).b6m = function (uri, $completion) {
    var tmp = new $fetchRequestObjectJwtCOROUTINE$23(this, uri, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(VerifierClient).c6m = function (uri, params, $completion) {
    var tmp = new $postDirectPostAuthorizationResponseCOROUTINE$24(this, uri, params, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  function Companion_7() {
    Companion_instance_16 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.d6m_1 = [null, null, null, new ArrayListSerializer($serializer_getInstance_8())];
  }
  var Companion_instance_16;
  function Companion_getInstance_14() {
    if (Companion_instance_16 == null)
      new Companion_7();
    return Companion_instance_16;
  }
  function $serializer_2() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vp.services.PreRegisteredClient', this, 4);
    tmp0_serialDesc.wy('clientId', false);
    tmp0_serialDesc.wy('jwksUri', false);
    tmp0_serialDesc.wy('redirectUri', false);
    tmp0_serialDesc.wy('vpFormatsSupported', false);
    this.e6m_1 = tmp0_serialDesc;
  }
  protoOf($serializer_2).f6m = function (encoder, value) {
    var tmp0_desc = this.e6m_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    var tmp2_cached = Companion_getInstance_14().d6m_1;
    tmp1_output.zs(tmp0_desc, 0, value.z6e_1);
    tmp1_output.zs(tmp0_desc, 1, value.a6f_1);
    tmp1_output.zs(tmp0_desc, 2, value.b6f_1);
    tmp1_output.bt(tmp0_desc, 3, tmp2_cached[3], value.c6f_1);
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_2).zn = function (encoder, value) {
    return this.f6m(encoder, value instanceof PreRegisteredClient ? value : THROW_CCE());
  };
  protoOf($serializer_2).ao = function (decoder) {
    var tmp0_desc = this.e6m_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.lr(tmp0_desc);
    var tmp9_cached = Companion_getInstance_14().d6m_1;
    if (tmp8_input.as()) {
      tmp4_local0 = tmp8_input.vr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.vr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.vr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.xr(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.vr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.vr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.xr(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.mr(tmp0_desc);
    return PreRegisteredClient_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_2).yn = function () {
    return this.e6m_1;
  };
  protoOf($serializer_2).lz = function () {
    var tmp0_cached = Companion_getInstance_14().d6m_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[3]];
  };
  var $serializer_instance_2;
  function $serializer_getInstance_7() {
    if ($serializer_instance_2 == null)
      new $serializer_2();
    return $serializer_instance_2;
  }
  function PreRegisteredClient_init_$Init$(seen0, clientId, jwksUri, redirectUri, vpFormatsSupported, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_7().e6m_1);
    }
    $this.z6e_1 = clientId;
    $this.a6f_1 = jwksUri;
    $this.b6f_1 = redirectUri;
    $this.c6f_1 = vpFormatsSupported;
    return $this;
  }
  function PreRegisteredClient_init_$Create$(seen0, clientId, jwksUri, redirectUri, vpFormatsSupported, serializationConstructorMarker) {
    return PreRegisteredClient_init_$Init$(seen0, clientId, jwksUri, redirectUri, vpFormatsSupported, serializationConstructorMarker, objectCreate(protoOf(PreRegisteredClient)));
  }
  function PreRegisteredClient(clientId, jwksUri, redirectUri, vpFormatsSupported) {
    Companion_getInstance_14();
    this.z6e_1 = clientId;
    this.a6f_1 = jwksUri;
    this.b6f_1 = redirectUri;
    this.c6f_1 = vpFormatsSupported;
  }
  protoOf(PreRegisteredClient).toString = function () {
    return 'PreRegisteredClient(clientId=' + this.z6e_1 + ', jwksUri=' + this.a6f_1 + ', redirectUri=' + this.b6f_1 + ', vpFormatsSupported=' + toString(this.c6f_1) + ')';
  };
  protoOf(PreRegisteredClient).hashCode = function () {
    var result = getStringHashCode(this.z6e_1);
    result = imul(result, 31) + getStringHashCode(this.a6f_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b6f_1) | 0;
    result = imul(result, 31) + hashCode(this.c6f_1) | 0;
    return result;
  };
  protoOf(PreRegisteredClient).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PreRegisteredClient))
      return false;
    var tmp0_other_with_cast = other instanceof PreRegisteredClient ? other : THROW_CCE();
    if (!(this.z6e_1 === tmp0_other_with_cast.z6e_1))
      return false;
    if (!(this.a6f_1 === tmp0_other_with_cast.a6f_1))
      return false;
    if (!(this.b6f_1 === tmp0_other_with_cast.b6f_1))
      return false;
    if (!equals(this.c6f_1, tmp0_other_with_cast.c6f_1))
      return false;
    return true;
  };
  function Companion_8() {
    Companion_instance_17 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.g6m_1 = [null, new LinkedHashSetSerializer(StringSerializer_getInstance())];
  }
  var Companion_instance_17;
  function Companion_getInstance_15() {
    if (Companion_instance_17 == null)
      new Companion_8();
    return Companion_instance_17;
  }
  function $serializer_3() {
    $serializer_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vp.services.VpFormat', this, 2);
    tmp0_serialDesc.wy('format', false);
    tmp0_serialDesc.wy('algs', false);
    this.h6m_1 = tmp0_serialDesc;
  }
  protoOf($serializer_3).i6m = function (encoder, value) {
    var tmp0_desc = this.h6m_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    var tmp2_cached = Companion_getInstance_15().g6m_1;
    tmp1_output.zs(tmp0_desc, 0, value.j6m_1);
    tmp1_output.bt(tmp0_desc, 1, tmp2_cached[1], value.k6m_1);
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_3).zn = function (encoder, value) {
    return this.i6m(encoder, value instanceof VpFormat ? value : THROW_CCE());
  };
  protoOf($serializer_3).ao = function (decoder) {
    var tmp0_desc = this.h6m_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.lr(tmp0_desc);
    var tmp7_cached = Companion_getInstance_15().g6m_1;
    if (tmp6_input.as()) {
      tmp4_local0 = tmp6_input.vr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.xr(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.xr(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.mr(tmp0_desc);
    return VpFormat_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_3).yn = function () {
    return this.h6m_1;
  };
  protoOf($serializer_3).lz = function () {
    var tmp0_cached = Companion_getInstance_15().g6m_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), tmp0_cached[1]];
  };
  var $serializer_instance_3;
  function $serializer_getInstance_8() {
    if ($serializer_instance_3 == null)
      new $serializer_3();
    return $serializer_instance_3;
  }
  function VpFormat_init_$Init$(seen0, format, algs, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_8().h6m_1);
    }
    $this.j6m_1 = format;
    $this.k6m_1 = algs;
    return $this;
  }
  function VpFormat_init_$Create$(seen0, format, algs, serializationConstructorMarker) {
    return VpFormat_init_$Init$(seen0, format, algs, serializationConstructorMarker, objectCreate(protoOf(VpFormat)));
  }
  function VpFormat(format, algs) {
    Companion_getInstance_15();
    this.j6m_1 = format;
    this.k6m_1 = algs;
  }
  protoOf(VpFormat).toString = function () {
    return 'VpFormat(format=' + this.j6m_1 + ', algs=' + toString(this.k6m_1) + ')';
  };
  protoOf(VpFormat).hashCode = function () {
    var result = getStringHashCode(this.j6m_1);
    result = imul(result, 31) + hashCode(this.k6m_1) | 0;
    return result;
  };
  protoOf(VpFormat).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof VpFormat))
      return false;
    var tmp0_other_with_cast = other instanceof VpFormat ? other : THROW_CCE();
    if (!(this.j6m_1 === tmp0_other_with_cast.j6m_1))
      return false;
    if (!equals(this.k6m_1, tmp0_other_with_cast.k6m_1))
      return false;
    return true;
  };
  function WalletMetadata() {
    WalletMetadata_instance = this;
    this.l6m_1 = listOf(new VpFormat('jwt_vp_json', setOf(['EdDSA', 'ES256', 'ES384', 'ES512', 'RS256', 'RS384', 'RS512', 'PS256', 'PS384', 'PS512'])));
  }
  var WalletMetadata_instance;
  function WalletMetadata_getInstance() {
    if (WalletMetadata_instance == null)
      new WalletMetadata();
    return WalletMetadata_instance;
  }
  function Companion_9() {
    this.m6m_1 = 'vp_token';
    this.n6m_1 = 'presentation_submission';
    this.o6m_1 = 'state';
  }
  var Companion_instance_18;
  function Companion_getInstance_16() {
    return Companion_instance_18;
  }
  function VerifiablePresentationResponseParameters(vpToken, presentationSubmission, state) {
    this.y6l_1 = vpToken;
    this.z6l_1 = presentationSubmission;
    this.a6m_1 = state;
  }
  protoOf(VerifiablePresentationResponseParameters).toString = function () {
    return 'VerifiablePresentationResponseParameters(vpToken=' + this.y6l_1.toString() + ', presentationSubmission=' + this.z6l_1.toString() + ', state=' + this.a6m_1 + ')';
  };
  protoOf(VerifiablePresentationResponseParameters).hashCode = function () {
    var result = this.y6l_1.hashCode();
    result = imul(result, 31) + this.z6l_1.hashCode() | 0;
    result = imul(result, 31) + (this.a6m_1 == null ? 0 : getStringHashCode(this.a6m_1)) | 0;
    return result;
  };
  protoOf(VerifiablePresentationResponseParameters).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof VerifiablePresentationResponseParameters))
      return false;
    var tmp0_other_with_cast = other instanceof VerifiablePresentationResponseParameters ? other : THROW_CCE();
    if (!this.y6l_1.equals(tmp0_other_with_cast.y6l_1))
      return false;
    if (!this.z6l_1.equals(tmp0_other_with_cast.z6l_1))
      return false;
    if (!(this.a6m_1 == tmp0_other_with_cast.a6m_1))
      return false;
    return true;
  };
  function validatePresentationDefinition(_this__u8e3s4, $this, payload) {
    var tmp78_safe_receiver = payload.vl('presentation_definition');
    var tmp79_safe_receiver = tmp78_safe_receiver == null ? null : get_jsonPrimitive(tmp78_safe_receiver);
    var presentationDefinition = tmp79_safe_receiver == null ? null : tmp79_safe_receiver.e1b();
    if (presentationDefinition == null) {
      _this__u8e3s4.vn('Missing presentation_definition claim');
      return null;
    }
    // Inline function 'kotlinx.serialization.json.Json.decodeFromString' call
    var this_0 = Default_getInstance();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.dp();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(JsonPresentationDefinition), arrayOf([]), true));
    var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
    return this_0.cp(tmp$ret$1, presentationDefinition);
  }
  function validateBasicClaims(_this__u8e3s4, $this, claims) {
    var nowInEpochSeconds = $this.q6m_1.u1l().f1m();
    var exp = claims.c2a_1;
    if (exp == null) {
      _this__u8e3s4.vn('exp claim is missing');
    } else if (nowInEpochSeconds.j1(exp) > 0) {
      _this__u8e3s4.vn('Request Object expired');
    }
    var nbf = claims.d2a_1;
    if (nbf == null) {
      _this__u8e3s4.vn('nbf claim is missing');
    } else if (nowInEpochSeconds.j1(nbf) < 0) {
      _this__u8e3s4.vn("Request Object used before the 'nbf' claim");
    }
    var tmp80_safe_receiver = claims.vl('nonce');
    var tmp81_safe_receiver = tmp80_safe_receiver == null ? null : get_jsonPrimitive(tmp80_safe_receiver);
    if ((tmp81_safe_receiver == null ? null : tmp81_safe_receiver.e1b()) == null) {
      _this__u8e3s4.vn('Missing nonce claim');
    }
    var tmp82_safe_receiver = claims.vl('response_type');
    var tmp83_safe_receiver = tmp82_safe_receiver == null ? null : get_jsonPrimitive(tmp82_safe_receiver);
    var responseType = tmp83_safe_receiver == null ? null : tmp83_safe_receiver.e1b();
    if (!(responseType === 'vp_token') && !(responseType === 'vp_token id_token') && !(responseType === 'code')) {
      _this__u8e3s4.vn('Invalid value for the response_type claim: ' + responseType + '.');
    }
    var aud = claims.b2a_1;
    var iss = claims.z29_1;
    var tmp85_safe_receiver = aud == null ? null : aud.qm();
    var tmp;
    if (tmp85_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var tmp0_iterator = tmp85_safe_receiver.j();
        while (tmp0_iterator.k()) {
          var element = tmp0_iterator.l();
          // Inline function 'io.curity.vp.services.DefaultRequestObjectJwtValidator.validateBasicClaims.<anonymous>' call
          if (element === 'https://self-issued.me/v2' || element === iss) {
            tmp$ret$1 = element;
            break $l$block;
          }
        }
        tmp$ret$1 = null;
      }
      tmp = tmp$ret$1;
    }
    var isAudInvalid = tmp == null;
    if (isAudInvalid) {
      _this__u8e3s4.vn('Invalid value for the aud claim: ' + toString_0(claims.b2a_1) + '.');
    }
    var tmp86_safe_receiver = claims.vl('client_id');
    var tmp87_safe_receiver = tmp86_safe_receiver == null ? null : get_jsonPrimitive(tmp86_safe_receiver);
    var clientId = tmp87_safe_receiver == null ? null : tmp87_safe_receiver.e1b();
    if (!(iss == clientId)) {
      _this__u8e3s4.vn("iss claim value doesn't match client_id claim value.");
    }
  }
  function validateVpFormatForPreRegisteredClient(_this__u8e3s4, $this, preRegisteredClient) {
    var tmp$ret$4;
    $l$block_0: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = WalletMetadata_getInstance().l6m_1.j();
      while (tmp0_iterator.k()) {
        var element = tmp0_iterator.l();
        // Inline function 'io.curity.vp.services.DefaultRequestObjectJwtValidator.validateVpFormatForPreRegisteredClient.<anonymous>' call
        var tmp$ret$2;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var tmp0_iterator_0 = preRegisteredClient.c6f_1.j();
          while (tmp0_iterator_0.k()) {
            var element_0 = tmp0_iterator_0.l();
            // Inline function 'io.curity.vp.services.DefaultRequestObjectJwtValidator.validateVpFormatForPreRegisteredClient.<anonymous>.<anonymous>' call
            var tmp;
            if (element_0.j6m_1 === element.j6m_1) {
              // Inline function 'kotlin.collections.isNotEmpty' call
              tmp = !intersect(element_0.k6m_1, element.k6m_1).s();
            } else {
              tmp = false;
            }
            if (tmp) {
              tmp$ret$2 = element_0;
              break $l$block;
            }
          }
          tmp$ret$2 = null;
        }
        if (!(tmp$ret$2 == null)) {
          tmp$ret$4 = element;
          break $l$block_0;
        }
      }
      tmp$ret$4 = null;
    }
    var isFormatSupported = !(tmp$ret$4 == null);
    if (!isFormatSupported) {
      _this__u8e3s4.vn('Format not supported');
    }
  }
  function validateSignatureForPreRegisteredClient(_this__u8e3s4, $this, jws, preRegisteredClient, $completion) {
    var tmp = new $validateSignatureForPreRegisteredClientCOROUTINE$26($this, _this__u8e3s4, jws, preRegisteredClient, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  }
  function fetchJwks(_this__u8e3s4, $this, jwksUri, $completion) {
    var tmp = new $fetchJwksCOROUTINE$27($this, _this__u8e3s4, jwksUri, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  }
  function DefaultRequestObjectJwtValidator$validate$slambda($requestObjectJwt, this$0, resultContinuation) {
    this.k6o_1 = $requestObjectJwt;
    this.l6o_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DefaultRequestObjectJwtValidator$validate$slambda).u6o = function ($this$suspendableValidationScope, $completion) {
    var tmp = this.x66($this$suspendableValidationScope, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(DefaultRequestObjectJwtValidator$validate$slambda).y9 = function (p1, $completion) {
    return this.u6o(p1 instanceof ValidationScope ? p1 : THROW_CCE(), $completion);
  };
  protoOf(DefaultRequestObjectJwtValidator$validate$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 6;
            this.n6o_1 = JwsUtil_getInstance().r2a(this.k6o_1);
            var tmp_0 = this;
            var tmp68_safe_receiver = this.n6o_1.k29_1.vl('client_id_scheme');
            var tmp69_safe_receiver = tmp68_safe_receiver == null ? null : get_jsonPrimitive(tmp68_safe_receiver);
            tmp_0.o6o_1 = tmp69_safe_receiver == null ? null : tmp69_safe_receiver.e1b();
            if (this.o6o_1 == null) {
              this.m6o_1.vn('Missing client_id_scheme claim');
              return null;
            }

            validateBasicClaims(this.m6o_1, this.l6o_1, this.n6o_1.k29_1);
            var tmp_1 = this;
            var tmp0_elvis_lhs = validatePresentationDefinition(this.m6o_1, this.l6o_1, this.n6o_1.k29_1);
            var tmp_2;
            if (tmp0_elvis_lhs == null) {
              return null;
            } else {
              tmp_2 = tmp0_elvis_lhs;
            }

            tmp_1.p6o_1 = tmp_2;
            this.q6o_1 = Companion_instance_5.r2h(this.o6o_1);
            this.r6o_1 = this.q6o_1.q2_1;
            if (this.r6o_1 === 0) {
              var tmp_3 = this;
              var tmp70_safe_receiver = this.n6o_1.k29_1.vl('client_id');
              var tmp71_safe_receiver = tmp70_safe_receiver == null ? null : get_jsonPrimitive(tmp70_safe_receiver);
              tmp_3.s6o_1 = tmp71_safe_receiver == null ? null : tmp71_safe_receiver.e1b();
              if (!(this.s6o_1 == null)) {
                this.v8_1 = 1;
                suspendResult = this.l6o_1.p6m_1.x6e(this.s6o_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.m6o_1.vn('Missing client_id claim');
                this.v8_1 = 4;
                continue $sm;
              }
            } else {
              this.m6o_1.vn('Unsupported client_id_scheme value: ' + this.q6o_1.toString());
              this.v8_1 = 5;
              continue $sm;
            }

          case 1:
            this.t6o_1 = suspendResult;
            if (this.t6o_1 == null) {
              this.m6o_1.vn('Unknown client ' + this.s6o_1);
              this.v8_1 = 3;
              continue $sm;
            } else {
              validateVpFormatForPreRegisteredClient(this.m6o_1, this.l6o_1, this.t6o_1);
              this.v8_1 = 2;
              suspendResult = validateSignatureForPreRegisteredClient(this.m6o_1, this.l6o_1, this.k6o_1, this.t6o_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 2:
            this.v8_1 = 3;
            continue $sm;
          case 3:
            this.v8_1 = 4;
            continue $sm;
          case 4:
            this.v8_1 = 5;
            continue $sm;
          case 5:
            var tmp_4;
            if (this.m6o_1.qn_1) {
              var tmp72_safe_receiver = this.n6o_1.k29_1.h2a_1.e2('state');
              var tmp73_safe_receiver = tmp72_safe_receiver == null ? null : get_jsonPrimitive(tmp72_safe_receiver);
              var state = tmp73_safe_receiver == null ? null : tmp73_safe_receiver.e1b();
              var tmp74_safe_receiver = this.n6o_1.k29_1.vl('response_uri');
              var tmp75_safe_receiver = tmp74_safe_receiver == null ? null : get_jsonPrimitive(tmp74_safe_receiver);
              var responseUri = ensureNotNull(tmp75_safe_receiver == null ? null : tmp75_safe_receiver.e1b());
              var tmp76_safe_receiver = this.n6o_1.k29_1.vl('nonce');
              var tmp77_safe_receiver = tmp76_safe_receiver == null ? null : get_jsonPrimitive(tmp76_safe_receiver);
              var nonce = ensureNotNull(tmp77_safe_receiver == null ? null : tmp77_safe_receiver.e1b());
              var iss = ensureNotNull(this.n6o_1.k29_1.z29_1);
              var exp = ensureNotNull(this.n6o_1.k29_1.c2a_1);
              tmp_4 = new ValidatedRequestJwt(this.n6o_1, responseUri, iss, nonce, this.p6o_1, state, exp);
            } else {
              tmp_4 = null;
            }

            return tmp_4;
          case 6:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 6) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  protoOf(DefaultRequestObjectJwtValidator$validate$slambda).x66 = function ($this$suspendableValidationScope, completion) {
    var i = new DefaultRequestObjectJwtValidator$validate$slambda(this.k6o_1, this.l6o_1, completion);
    i.m6o_1 = $this$suspendableValidationScope;
    return i;
  };
  function DefaultRequestObjectJwtValidator$validate$slambda_0($requestObjectJwt, this$0, resultContinuation) {
    var i = new DefaultRequestObjectJwtValidator$validate$slambda($requestObjectJwt, this$0, resultContinuation);
    var l = function ($this$suspendableValidationScope, $completion) {
      return i.u6o($this$suspendableValidationScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $validateCOROUTINE$25(_this__u8e3s4, requestObjectJwt, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.d6p_1 = _this__u8e3s4;
    this.e6p_1 = requestObjectJwt;
  }
  protoOf($validateCOROUTINE$25).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            this.v8_1 = 1;
            suspendResult = suspendableValidationScope(DefaultRequestObjectJwtValidator$validate$slambda_0(this.e6p_1, this.d6p_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return ARGUMENT.xm();
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function $validateSignatureForPreRegisteredClientCOROUTINE$26(_this__u8e3s4, _this__u8e3s4_0, jws, preRegisteredClient, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.a6n_1 = _this__u8e3s4;
    this.b6n_1 = _this__u8e3s4_0;
    this.c6n_1 = jws;
    this.d6n_1 = preRegisteredClient;
  }
  protoOf($validateSignatureForPreRegisteredClientCOROUTINE$26).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 4;
            this.w8_1 = 3;
            this.v8_1 = 1;
            suspendResult = fetchJwks(this.b6n_1, this.a6n_1, this.d6n_1.a6f_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.f6n_1 = suspendResult;
            this.v8_1 = 2;
            suspendResult = JwsUtil_getInstance().l2h(this.f6n_1, this.c6n_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.e6n_1 = suspendResult;
            this.w8_1 = 4;
            this.v8_1 = 5;
            continue $sm;
          case 3:
            this.w8_1 = 4;
            var tmp_0 = this.y8_1;
            if (tmp_0 instanceof CryptoException) {
              var ex = this.y8_1;
              var tmp_1 = this;
              this.b6n_1.vn('Invalid signature.');
              tmp_1.e6n_1 = Unit_instance;
              this.v8_1 = 5;
              continue $sm;
            } else {
              throw this.y8_1;
            }

          case 4:
            throw this.y8_1;
          case 5:
            this.w8_1 = 4;
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 4) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function $fetchJwksCOROUTINE$27(_this__u8e3s4, _this__u8e3s4_0, jwksUri, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.o6n_1 = _this__u8e3s4;
    this.p6n_1 = _this__u8e3s4_0;
    this.q6n_1 = jwksUri;
  }
  protoOf($fetchJwksCOROUTINE$27).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 4;
            var tmp_0 = this;
            tmp_0.r6n_1 = this.o6n_1.r6m_1;
            var tmp_1 = this;
            tmp_1.s6n_1 = this.q6n_1;
            var tmp_2 = this;
            tmp_2.t6n_1 = this.r6n_1;
            var tmp_3 = this;
            tmp_3.u6n_1 = this.t6n_1;
            var tmp_4 = this;
            var this_0 = new HttpRequestBuilder();
            url(this_0, this.s6n_1);
            tmp_4.v6n_1 = this_0;
            this.v6n_1.n4t_1 = Companion_getInstance().n4d_1;
            var tmp_5 = this;
            tmp_5.w6n_1 = this.u6n_1;
            var tmp_6 = this;
            tmp_6.x6n_1 = this.v6n_1;
            this.v8_1 = 1;
            suspendResult = (new HttpStatement(this.x6n_1, this.w6n_1)).q5i(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.y6n_1 = suspendResult;
            if (!(this.y6n_1.y4v().h4g_1 === 200)) {
              this.p6n_1.vn('Cannot fetch JWKS from: ' + this.q6n_1 + '. Status: ' + this.y6n_1.y4v().h4g_1);
            }

            this.z6n_1 = Companion_instance_6;
            var tmp_7 = this;
            tmp_7.a6o_1 = this.y6n_1;
            this.v8_1 = 2;
            var tmp_8 = this.a6o_1.t4w();
            var tmp_9 = JsType_instance;
            var tmp_10 = PrimitiveClasses_getInstance().gb();
            var tmp_11;
            try {
              tmp_11 = createKType(PrimitiveClasses_getInstance().gb(), arrayOf([]), false);
            } catch ($p) {
              var tmp_12;
              if ($p instanceof Error) {
                var cause = $p;
                tmp_12 = null;
              } else {
                throw $p;
              }
              tmp_11 = tmp_12;
            }

            suspendResult = tmp_8.x4v(typeInfoImpl(tmp_9, tmp_10, tmp_11), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp_13 = this;
            tmp_13.b6o_1 = (!(suspendResult == null) ? typeof suspendResult === 'string' : false) ? suspendResult : THROW_CCE();
            this.v8_1 = 3;
            suspendResult = this.z6n_1.f2g(this.b6o_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            return suspendResult;
          case 4:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 4) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function DefaultRequestObjectJwtValidator(preRegisteredClientStore, clock, httpClient) {
    this.p6m_1 = preRegisteredClientStore;
    this.q6m_1 = clock;
    this.r6m_1 = httpClient;
  }
  protoOf(DefaultRequestObjectJwtValidator).h6l = function (requestObjectJwt, $completion) {
    var tmp = new $validateCOROUTINE$25(this, requestObjectJwt, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  function HaipRequestObjectJwtValidator$validate$slambda(this$0, $requestObjectJwt, resultContinuation) {
    this.n6p_1 = this$0;
    this.o6p_1 = $requestObjectJwt;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HaipRequestObjectJwtValidator$validate$slambda).u6o = function ($this$suspendableValidationScope, $completion) {
    var tmp = this.x66($this$suspendableValidationScope, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(HaipRequestObjectJwtValidator$validate$slambda).y9 = function (p1, $completion) {
    return this.u6o(p1 instanceof ValidationScope ? p1 : THROW_CCE(), $completion);
  };
  protoOf(HaipRequestObjectJwtValidator$validate$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            this.v8_1 = 1;
            suspendResult = protoOf(DefaultRequestObjectJwtValidator).h6l.call(this.n6p_1, this.o6p_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var validatedRequestJwt = suspendResult;
            var tmp88_safe_receiver = validatedRequestJwt.f6i_1.k29_1.vl('response_mode');
            var tmp89_safe_receiver = tmp88_safe_receiver == null ? null : get_jsonPrimitive(tmp88_safe_receiver);
            var responseMode = tmp89_safe_receiver == null ? null : tmp89_safe_receiver.e1b();
            if (!(responseMode === 'direct_post')) {
              this.p6p_1.vn("Invalid response_mode. Only 'direct_post' is accepted.");
            }

            var tmp90_safe_receiver = validatedRequestJwt.f6i_1.k29_1.vl('response_type');
            var tmp91_safe_receiver = tmp90_safe_receiver == null ? null : get_jsonPrimitive(tmp90_safe_receiver);
            var responseType = tmp91_safe_receiver == null ? null : tmp91_safe_receiver.e1b();
            if (!(responseType === 'vp_token')) {
              this.p6p_1.vn("Invalid response_type. Only 'vp_token' is accepted.");
            }

            var tmp92_safe_receiver = validatedRequestJwt.f6i_1.k29_1.vl('response_uri');
            var tmp93_safe_receiver = tmp92_safe_receiver == null ? null : get_jsonPrimitive(tmp92_safe_receiver);
            var responseUri = tmp93_safe_receiver == null ? null : tmp93_safe_receiver.e1b();
            if (responseUri == null || !startsWith(responseUri, 'https://')) {
              this.p6p_1.vn('Invalid value for the response_uri claim: ' + responseUri + ". 'https' is required.");
            }

            var tmp_0;
            if (this.p6p_1.qn_1) {
              tmp_0 = validatedRequestJwt;
            } else {
              tmp_0 = null;
            }

            return tmp_0;
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  protoOf(HaipRequestObjectJwtValidator$validate$slambda).x66 = function ($this$suspendableValidationScope, completion) {
    var i = new HaipRequestObjectJwtValidator$validate$slambda(this.n6p_1, this.o6p_1, completion);
    i.p6p_1 = $this$suspendableValidationScope;
    return i;
  };
  function HaipRequestObjectJwtValidator$validate$slambda_0(this$0, $requestObjectJwt, resultContinuation) {
    var i = new HaipRequestObjectJwtValidator$validate$slambda(this$0, $requestObjectJwt, resultContinuation);
    var l = function ($this$suspendableValidationScope, $completion) {
      return i.u6o($this$suspendableValidationScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $validateCOROUTINE$28(_this__u8e3s4, requestObjectJwt, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.y6p_1 = _this__u8e3s4;
    this.z6p_1 = requestObjectJwt;
  }
  protoOf($validateCOROUTINE$28).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            this.v8_1 = 1;
            suspendResult = suspendableValidationScope(HaipRequestObjectJwtValidator$validate$slambda_0(this.y6p_1, this.z6p_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return ARGUMENT.xm();
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function HaipRequestObjectJwtValidator(preRegisteredClientStore, clock, httpClient) {
    DefaultRequestObjectJwtValidator.call(this, preRegisteredClientStore, clock, httpClient);
  }
  protoOf(HaipRequestObjectJwtValidator).h6l = function (requestObjectJwt, $completion) {
    var tmp = new $validateCOROUTINE$28(this, requestObjectJwt, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  function Companion_10() {
  }
  var Companion_instance_19;
  function Companion_getInstance_17() {
    return Companion_instance_19;
  }
  function $serializer_4() {
    $serializer_instance_4 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vp.services.ValidatedRequestJwt', this, 7);
    tmp0_serialDesc.wy('jws', false);
    tmp0_serialDesc.wy('responseUri', false);
    tmp0_serialDesc.wy('iss', false);
    tmp0_serialDesc.wy('nonce', false);
    tmp0_serialDesc.wy('presentationDefinition', false);
    tmp0_serialDesc.wy('state', false);
    tmp0_serialDesc.wy('expAt', false);
    this.a6q_1 = tmp0_serialDesc;
  }
  protoOf($serializer_4).b6q = function (encoder, value) {
    var tmp0_desc = this.a6q_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    tmp1_output.bt(tmp0_desc, 0, $serializer_getInstance_2(), value.f6i_1);
    tmp1_output.zs(tmp0_desc, 1, value.g6i_1);
    tmp1_output.zs(tmp0_desc, 2, value.h6i_1);
    tmp1_output.zs(tmp0_desc, 3, value.i6i_1);
    tmp1_output.bt(tmp0_desc, 4, $serializer_getInstance_3(), value.j6i_1);
    tmp1_output.dt(tmp0_desc, 5, StringSerializer_getInstance(), value.k6i_1);
    tmp1_output.vs(tmp0_desc, 6, value.l6i_1);
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_4).zn = function (encoder, value) {
    return this.b6q(encoder, value instanceof ValidatedRequestJwt ? value : THROW_CCE());
  };
  protoOf($serializer_4).ao = function (decoder) {
    var tmp0_desc = this.a6q_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = new Long(0, 0);
    var tmp11_input = decoder.lr(tmp0_desc);
    if (tmp11_input.as()) {
      tmp4_local0 = tmp11_input.xr(tmp0_desc, 0, $serializer_getInstance_2(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.vr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.vr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.vr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.xr(tmp0_desc, 4, $serializer_getInstance_3(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.zr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.rr(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.xr(tmp0_desc, 0, $serializer_getInstance_2(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.vr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.vr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.vr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.xr(tmp0_desc, 4, $serializer_getInstance_3(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.zr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.rr(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp11_input.mr(tmp0_desc);
    return ValidatedRequestJwt_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  };
  protoOf($serializer_4).yn = function () {
    return this.a6q_1;
  };
  protoOf($serializer_4).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_2(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_3(), get_nullable(StringSerializer_getInstance()), LongSerializer_getInstance()];
  };
  var $serializer_instance_4;
  function $serializer_getInstance_9() {
    if ($serializer_instance_4 == null)
      new $serializer_4();
    return $serializer_instance_4;
  }
  function ValidatedRequestJwt_init_$Init$(seen0, jws, responseUri, iss, nonce, presentationDefinition, state, expAt, serializationConstructorMarker, $this) {
    if (!(127 === (127 & seen0))) {
      throwMissingFieldException(seen0, 127, $serializer_getInstance_9().a6q_1);
    }
    $this.f6i_1 = jws;
    $this.g6i_1 = responseUri;
    $this.h6i_1 = iss;
    $this.i6i_1 = nonce;
    $this.j6i_1 = presentationDefinition;
    $this.k6i_1 = state;
    $this.l6i_1 = expAt;
    return $this;
  }
  function ValidatedRequestJwt_init_$Create$(seen0, jws, responseUri, iss, nonce, presentationDefinition, state, expAt, serializationConstructorMarker) {
    return ValidatedRequestJwt_init_$Init$(seen0, jws, responseUri, iss, nonce, presentationDefinition, state, expAt, serializationConstructorMarker, objectCreate(protoOf(ValidatedRequestJwt)));
  }
  function ValidatedRequestJwt(jws, responseUri, iss, nonce, presentationDefinition, state, expAt) {
    this.f6i_1 = jws;
    this.g6i_1 = responseUri;
    this.h6i_1 = iss;
    this.i6i_1 = nonce;
    this.j6i_1 = presentationDefinition;
    this.k6i_1 = state;
    this.l6i_1 = expAt;
  }
  protoOf(ValidatedRequestJwt).toString = function () {
    return 'ValidatedRequestJwt(jws=' + this.f6i_1.toString() + ', responseUri=' + this.g6i_1 + ', iss=' + this.h6i_1 + ', nonce=' + this.i6i_1 + ', presentationDefinition=' + this.j6i_1.toString() + ', state=' + this.k6i_1 + ', expAt=' + this.l6i_1.toString() + ')';
  };
  protoOf(ValidatedRequestJwt).hashCode = function () {
    var result = this.f6i_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.g6i_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h6i_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.i6i_1) | 0;
    result = imul(result, 31) + this.j6i_1.hashCode() | 0;
    result = imul(result, 31) + (this.k6i_1 == null ? 0 : getStringHashCode(this.k6i_1)) | 0;
    result = imul(result, 31) + this.l6i_1.hashCode() | 0;
    return result;
  };
  protoOf(ValidatedRequestJwt).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ValidatedRequestJwt))
      return false;
    var tmp0_other_with_cast = other instanceof ValidatedRequestJwt ? other : THROW_CCE();
    if (!this.f6i_1.equals(tmp0_other_with_cast.f6i_1))
      return false;
    if (!(this.g6i_1 === tmp0_other_with_cast.g6i_1))
      return false;
    if (!(this.h6i_1 === tmp0_other_with_cast.h6i_1))
      return false;
    if (!(this.i6i_1 === tmp0_other_with_cast.i6i_1))
      return false;
    if (!this.j6i_1.equals(tmp0_other_with_cast.j6i_1))
      return false;
    if (!(this.k6i_1 == tmp0_other_with_cast.k6i_1))
      return false;
    if (!this.l6i_1.equals(tmp0_other_with_cast.l6i_1))
      return false;
    return true;
  };
  function JsHttpProxy(scheme, host, port) {
    this.scheme = scheme;
    this.host = host;
    this.port = port;
  }
  protoOf(JsHttpProxy).c6q = function () {
    return this.scheme;
  };
  protoOf(JsHttpProxy).d6q = function () {
    return this.host;
  };
  protoOf(JsHttpProxy).f4i = function () {
    return this.port;
  };
  protoOf(JsHttpProxy).ba = function () {
    return this.scheme;
  };
  protoOf(JsHttpProxy).ca = function () {
    return this.host;
  };
  protoOf(JsHttpProxy).qj = function () {
    return this.port;
  };
  protoOf(JsHttpProxy).e6q = function (scheme, host, port) {
    return new JsHttpProxy(scheme, host, port);
  };
  protoOf(JsHttpProxy).copy = function (scheme, host, port, $super) {
    scheme = scheme === VOID ? this.scheme : scheme;
    host = host === VOID ? this.host : host;
    port = port === VOID ? this.port : port;
    return this.e6q(scheme, host, port);
  };
  protoOf(JsHttpProxy).toString = function () {
    return 'JsHttpProxy(scheme=' + this.scheme + ', host=' + this.host + ', port=' + this.port + ')';
  };
  protoOf(JsHttpProxy).hashCode = function () {
    var result = getStringHashCode(this.scheme);
    result = imul(result, 31) + getStringHashCode(this.host) | 0;
    result = imul(result, 31) + this.port | 0;
    return result;
  };
  protoOf(JsHttpProxy).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsHttpProxy))
      return false;
    var tmp0_other_with_cast = other instanceof JsHttpProxy ? other : THROW_CCE();
    if (!(this.scheme === tmp0_other_with_cast.scheme))
      return false;
    if (!(this.host === tmp0_other_with_cast.host))
      return false;
    if (!(this.port === tmp0_other_with_cast.port))
      return false;
    return true;
  };
  function createCredentialIssuerLoader(proxyConfig) {
    proxyConfig = proxyConfig === VOID ? null : proxyConfig;
    var tmp;
    if (!(proxyConfig == null)) {
      tmp = createEngine(proxyConfig);
    } else {
      tmp = Js_instance.y4z();
    }
    var engine = tmp;
    var tmp_0 = System_instance;
    return new JsCredentialIssuerLoader(new DefaultCredentialIssuerLoader(tmp_0, HttpClient(engine, createCredentialIssuerLoader$lambda)));
  }
  function createCredentialIssuerStore() {
    return new JsCredentialIssuerStore(new LocalStorageCredentialIssuerStore());
  }
  function createVerifiableCredentialStore() {
    return new JsVerifiableCredentialStore(new LocalStorageVerifiableCredentialStore());
  }
  function createOAuthClient(id, redirectUri, secret) {
    return new OAuthClient(id, redirectUri, secret);
  }
  function createCredentialIssuanceCoordinator(oAuthClient, httpProxy, credentialIssuerLoader) {
    var tmp = System_instance;
    var tmp_0 = new CompositeDidResolver(listOf(new JwkDidResolver()));
    var tmp_1 = new BrowserWindowOAuthAuthorizer();
    var tmp_2 = createEngine(httpProxy);
    return new JsCredentialIssuanceCoordinator(new CredentialIssuanceCoordinator(tmp, oAuthClient, tmp_0, tmp_1, tmp_2, credentialIssuerLoader.inner, new DefaultVcSdJwtIssuerMetadataLoader(HttpClient_0(createCredentialIssuanceCoordinator$lambda))));
  }
  function createPreRegisteredClientStore() {
    return new JsPreRegisteredClientStore(new InMemoryPreRegisteredClientStore());
  }
  function createVerifierClient(httpProxy, preRegisteredClientStore) {
    return new JsVerifierClient(httpProxy, preRegisteredClientStore);
  }
  function createCredentialFinder(jsCredentialStore) {
    return new JsOpenIdWalletAuthenticatorCredentialFinder(jsCredentialStore);
  }
  function createPresentationResponseCreator(keyAliasStore, keyStore) {
    var tmp = System_instance;
    return new JsPresentationResponseCreator(new PresentationResponseCreator(tmp, keyAliasStore.f6q_1, (keyStore instanceof JsDefaultKeyStore ? keyStore : THROW_CCE()).f2b_1));
  }
  function newUserCancellationException() {
    return new UserCancellationException();
  }
  function createRequestJwtStore(cleanupPeriod) {
    return new JsRequestJwtStore(new LocalStorageRequestJwtStore(VOID, cleanupPeriod));
  }
  function createKeyStore() {
    return new JsDefaultKeyStore();
  }
  function createInMemoryKeyAliasStore() {
    return new JsKeyAliasStore(new InMemoryKeyAliasStore());
  }
  function createEngine(config) {
    var tmp = Js_instance.y4z();
    // Inline function 'kotlin.apply' call
    var this_0 = new ProxyPluginConfig();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'createEngine.<anonymous>' call
    var tmp_0 = this_0;
    var tmp_1;
    switch (config.scheme) {
      case 'http':
        tmp_1 = Companion_getInstance_1().q4h_1;
        break;
      case 'https':
        tmp_1 = Companion_getInstance_1().r4h_1;
        break;
      default:
        var reason = 'unsupported protocol';
        throw new NotImplementedError('An operation is not implemented: ' + reason);
    }
    tmp_0.g6q_1 = tmp_1;
    this_0.h6q_1 = config.host;
    this_0.i6q_1 = config.port;
    return new ProxyEngine(tmp, this_0);
  }
  function createCredentialIssuerLoader$lambda($this$HttpClient) {
    var tmp = Plugin_getInstance();
    $this$HttpClient.t4u(tmp, createCredentialIssuerLoader$lambda$lambda);
    return Unit_instance;
  }
  function createCredentialIssuerLoader$lambda$lambda($this$install) {
    json($this$install, Json(VOID, createCredentialIssuerLoader$lambda$lambda$lambda));
    return Unit_instance;
  }
  function createCredentialIssuerLoader$lambda$lambda$lambda($this$Json) {
    $this$Json.u19_1 = true;
    return Unit_instance;
  }
  function createCredentialIssuanceCoordinator$lambda($this$HttpClient) {
    var tmp = Plugin_getInstance();
    $this$HttpClient.t4u(tmp, createCredentialIssuanceCoordinator$lambda$lambda);
    return Unit_instance;
  }
  function createCredentialIssuanceCoordinator$lambda$lambda($this$install) {
    json($this$install);
    return Unit_instance;
  }
  function get_ProxyPlugin() {
    _init_properties_ProxyPlugin_kt__by34kx();
    return ProxyPlugin;
  }
  var ProxyPlugin;
  function ProxyPluginConfig() {
    this.g6q_1 = Companion_getInstance_1().q4h_1;
    this.h6q_1 = 'localhost';
    this.i6q_1 = 1234;
    this.j6q_1 = 'ProxyTo';
    this.k6q_1 = 'proxy';
  }
  function ProxyEngine(inner, proxyConfig) {
    this.l6q_1 = inner;
    this.m6q_1 = proxyConfig;
  }
  protoOf(ProxyEngine).a4u = function () {
    return this.l6q_1.a4u();
  };
  protoOf(ProxyEngine).v1m = function () {
    return this.l6q_1.v1m();
  };
  protoOf(ProxyEngine).v3w = function () {
    this.l6q_1.v3w();
  };
  protoOf(ProxyEngine).x4z = function (data, $completion) {
    // Inline function 'kotlin.apply' call
    var this_0 = new HttpRequestBuilder();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'vc_js.ProxyEngine.execute.<anonymous>' call
    this_0.n4t_1 = data.l4y_1;
    this_0.m4t_1.n4g_1 = this.m6q_1.g6q_1;
    this_0.m4t_1.o4g_1 = this.m6q_1.h6q_1;
    this_0.m4t_1.p4g_1 = this.m6q_1.i6q_1;
    path(this_0.m4t_1, [this.m6q_1.k6q_1 + joinToString(data.k4y_1.c4h_1, '/')]);
    this_0.o4t_1.x43(data.m4y_1);
    var header = data.k4y_1.z4g_1.x4g_1 + '://' + get_authority(data.k4y_1);
    this_0.o4t_1.w43(this.m6q_1.j6q_1, header);
    putAll(this_0.r4t_1, data.p4y_1);
    this_0.p4t_1 = data.n4y_1;
    var newReq = this_0.c3r();
    return this.l6q_1.x4z(newReq, $completion);
  };
  function ProxyPluginConfig$_init_$ref_4o7kf2() {
    var l = function () {
      return new ProxyPluginConfig();
    };
    l.callableName = '<init>';
    return l;
  }
  function ProxyPlugin$lambda($this$createClientPlugin) {
    _init_properties_ProxyPlugin_kt__by34kx();
    var config = $this$createClientPlugin.l5f_1;
    $this$createClientPlugin.o5f(ProxyPlugin$lambda$slambda_0(config, null));
    return Unit_instance;
  }
  function ProxyPlugin$lambda$slambda($config, resultContinuation) {
    this.v6q_1 = $config;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ProxyPlugin$lambda$slambda).z6q = function ($this$onRequest, req, _unused_var__etf5q3, $completion) {
    var tmp = this.a6r($this$onRequest, req, _unused_var__etf5q3, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(ProxyPlugin$lambda$slambda).b6r = function (p1, p2, p3, $completion) {
    var tmp = p1 instanceof OnRequestContext ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof HttpRequestBuilder ? p2 : THROW_CCE();
    return this.z6q(tmp, tmp_0, !(p3 == null) ? p3 : THROW_CCE(), $completion);
  };
  protoOf(ProxyPlugin$lambda$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        if (tmp === 0) {
          this.w8_1 = 1;
          var header = this.x6q_1.m4t_1.n4g_1.x4g_1 + '://' + get_authority_0(this.x6q_1.m4t_1);
          this.x6q_1.o4t_1.u43(this.v6q_1.j6q_1, header);
          this.x6q_1.m4t_1.n4g_1 = this.v6q_1.g6q_1;
          this.x6q_1.m4t_1.o4g_1 = this.v6q_1.h6q_1;
          set_port(this.x6q_1, this.v6q_1.i6q_1);
          path(this.x6q_1.m4t_1, [this.v6q_1.k6q_1 + joinToString(this.x6q_1.m4t_1.b4i(), '/')]);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(ProxyPlugin$lambda$slambda).a6r = function ($this$onRequest, req, _unused_var__etf5q3, completion) {
    var i = new ProxyPlugin$lambda$slambda(this.v6q_1, completion);
    i.w6q_1 = $this$onRequest;
    i.x6q_1 = req;
    i.y6q_1 = _unused_var__etf5q3;
    return i;
  };
  function ProxyPlugin$lambda$slambda_0($config, resultContinuation) {
    var i = new ProxyPlugin$lambda$slambda($config, resultContinuation);
    var l = function ($this$onRequest, req, _unused_var__etf5q3, $completion) {
      return i.z6q($this$onRequest, req, _unused_var__etf5q3, $completion);
    };
    l.$arity = 3;
    return l;
  }
  var properties_initialized_ProxyPlugin_kt_gl075b;
  function _init_properties_ProxyPlugin_kt__by34kx() {
    if (!properties_initialized_ProxyPlugin_kt_gl075b) {
      properties_initialized_ProxyPlugin_kt_gl075b = true;
      var tmp = ProxyPluginConfig$_init_$ref_4o7kf2();
      ProxyPlugin = createClientPlugin('ProxyPlugin', tmp, ProxyPlugin$lambda);
    }
  }
  function JsVcClient$requestJwtVcJsonCredential$slambda(this$0, $request, resultContinuation) {
    this.k6r_1 = this$0;
    this.l6r_1 = $request;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(JsVcClient$requestJwtVcJsonCredential$slambda).m6r = function ($completion) {
    var tmp = this.n6r($completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(JsVcClient$requestJwtVcJsonCredential$slambda).o6r = function ($completion) {
    return this.m6r($completion);
  };
  protoOf(JsVcClient$requestJwtVcJsonCredential$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            this.v8_1 = 1;
            suspendResult = this.k6r_1.q6r_1.y62(convertJwtVcJsonRequest(this.l6r_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var validatedResponse = suspendResult;
            return convertJwtVcJsonResponse(validatedResponse.j31());
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  protoOf(JsVcClient$requestJwtVcJsonCredential$slambda).n6r = function (completion) {
    return new JsVcClient$requestJwtVcJsonCredential$slambda(this.k6r_1, this.l6r_1, completion);
  };
  function JsVcClient$requestJwtVcJsonCredential$slambda_0(this$0, $request, resultContinuation) {
    var i = new JsVcClient$requestJwtVcJsonCredential$slambda(this$0, $request, resultContinuation);
    var l = function ($completion) {
      return i.m6r($completion);
    };
    l.$arity = 0;
    return l;
  }
  function JsVcClient$requestJwtVcJsonLdCredential$slambda(this$0, $request, resultContinuation) {
    this.z6r_1 = this$0;
    this.a6s_1 = $request;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(JsVcClient$requestJwtVcJsonLdCredential$slambda).b6s = function ($completion) {
    var tmp = this.n6r($completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(JsVcClient$requestJwtVcJsonLdCredential$slambda).o6r = function ($completion) {
    return this.b6s($completion);
  };
  protoOf(JsVcClient$requestJwtVcJsonLdCredential$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            this.v8_1 = 1;
            suspendResult = this.z6r_1.q6r_1.h6d(convertJwtVcJsonLdRequest(this.a6s_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var validatedResponse = suspendResult;
            return convertJwtVcJsonLdResponse(validatedResponse.j31());
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  protoOf(JsVcClient$requestJwtVcJsonLdCredential$slambda).n6r = function (completion) {
    return new JsVcClient$requestJwtVcJsonLdCredential$slambda(this.z6r_1, this.a6s_1, completion);
  };
  function JsVcClient$requestJwtVcJsonLdCredential$slambda_0(this$0, $request, resultContinuation) {
    var i = new JsVcClient$requestJwtVcJsonLdCredential$slambda(this$0, $request, resultContinuation);
    var l = function ($completion) {
      return i.b6s($completion);
    };
    l.$arity = 0;
    return l;
  }
  function JsVcClient$requestLdpVcJsonCredential$slambda(this$0, $request, resultContinuation) {
    this.k6s_1 = this$0;
    this.l6s_1 = $request;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(JsVcClient$requestLdpVcJsonCredential$slambda).m6s = function ($completion) {
    var tmp = this.n6r($completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(JsVcClient$requestLdpVcJsonCredential$slambda).o6r = function ($completion) {
    return this.m6s($completion);
  };
  protoOf(JsVcClient$requestLdpVcJsonCredential$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            this.v8_1 = 1;
            suspendResult = this.k6s_1.q6r_1.i6d(convertLdpVcJsonRequest(this.l6s_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var validatedResponse = suspendResult;
            return convertLdpVcJsonResponse(validatedResponse.j31());
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  protoOf(JsVcClient$requestLdpVcJsonCredential$slambda).n6r = function (completion) {
    return new JsVcClient$requestLdpVcJsonCredential$slambda(this.k6s_1, this.l6s_1, completion);
  };
  function JsVcClient$requestLdpVcJsonCredential$slambda_0(this$0, $request, resultContinuation) {
    var i = new JsVcClient$requestLdpVcJsonCredential$slambda(this$0, $request, resultContinuation);
    var l = function ($completion) {
      return i.m6s($completion);
    };
    l.$arity = 0;
    return l;
  }
  function JsVcClient(vcServerMetadata, oauthSupport, proxy) {
    this.p6r_1 = createJsClient(oauthSupport, proxy);
    var tmp = this;
    var tmp_0 = inner(vcServerMetadata);
    throw new NotImplementedError();
  }
  protoOf(JsVcClient).requestJwtVcJsonCredential = function (request) {
    return safePromise(this.q6r_1.w62_1, VOID, JsVcClient$requestJwtVcJsonCredential$slambda_0(this, request, null));
  };
  protoOf(JsVcClient).requestJwtVcJsonLdCredential = function (request) {
    return safePromise(this.q6r_1.w62_1, VOID, JsVcClient$requestJwtVcJsonLdCredential$slambda_0(this, request, null));
  };
  protoOf(JsVcClient).requestLdpVcJsonCredential = function (request) {
    return safePromise(this.q6r_1.w62_1, VOID, JsVcClient$requestLdpVcJsonCredential$slambda_0(this, request, null));
  };
  function UserCancellationException() {
    CancellationException_init_$Init$(this);
    captureStack(this, UserCancellationException);
  }
  function safePromise(_this__u8e3s4, description, action) {
    description = description === VOID ? '' : description;
    return promise(_this__u8e3s4, VOID, VOID, safePromise$slambda_0(action, description, null));
  }
  function safePromise$slambda($action, $description, resultContinuation) {
    this.v6s_1 = $action;
    this.w6s_1 = $description;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(safePromise$slambda).z6s = function ($this$promise, $completion) {
    var tmp = this.e2b($this$promise, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(safePromise$slambda).y9 = function (p1, $completion) {
    return this.z6s((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(safePromise$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 3;
            this.w8_1 = 2;
            this.v8_1 = 1;
            suspendResult = this.v6s_1(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.y6s_1 = suspendResult;
            this.w8_1 = 3;
            this.v8_1 = 4;
            continue $sm;
          case 2:
            this.w8_1 = 3;
            var tmp_0 = this.y8_1;
            if (tmp_0 instanceof Error) {
              var e = this.y8_1;
              var tmp_1 = this;
              if (!(e instanceof UserCancellationException)) {
                printStackTrace(e);
              }
              var this_0 = this.w6s_1;
              var tmp_2;
              if (isBlank(this_0)) {
                tmp_2 = 'unknown location';
              } else {
                tmp_2 = this_0;
              }
              var location = tmp_2;
              throw Exception_init_$Create$("Error at '" + location + "': " + getRootCause(e).toString());
            } else {
              throw this.y8_1;
            }

          case 3:
            throw this.y8_1;
          case 4:
            this.w8_1 = 3;
            return this.y6s_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.w8_1 === 3) {
          throw e_0;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(safePromise$slambda).e2b = function ($this$promise, completion) {
    var i = new safePromise$slambda(this.v6s_1, this.w6s_1, completion);
    i.x6s_1 = $this$promise;
    return i;
  };
  function safePromise$slambda_0($action, $description, resultContinuation) {
    var i = new safePromise$slambda($action, $description, resultContinuation);
    var l = function ($this$promise, $completion) {
      return i.z6s($this$promise, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function JsProxy(scheme, host, port) {
    this.scheme = scheme;
    this.host = host;
    this.port = port;
  }
  protoOf(JsProxy).c6q = function () {
    return this.scheme;
  };
  protoOf(JsProxy).d6q = function () {
    return this.host;
  };
  protoOf(JsProxy).f4i = function () {
    return this.port;
  };
  protoOf(JsProxy).ba = function () {
    return this.scheme;
  };
  protoOf(JsProxy).ca = function () {
    return this.host;
  };
  protoOf(JsProxy).qj = function () {
    return this.port;
  };
  protoOf(JsProxy).e6q = function (scheme, host, port) {
    return new JsProxy(scheme, host, port);
  };
  protoOf(JsProxy).copy = function (scheme, host, port, $super) {
    scheme = scheme === VOID ? this.scheme : scheme;
    host = host === VOID ? this.host : host;
    port = port === VOID ? this.port : port;
    return this.e6q(scheme, host, port);
  };
  protoOf(JsProxy).toString = function () {
    return 'JsProxy(scheme=' + this.scheme + ', host=' + this.host + ', port=' + this.port + ')';
  };
  protoOf(JsProxy).hashCode = function () {
    var result = getStringHashCode(this.scheme);
    result = imul(result, 31) + getStringHashCode(this.host) | 0;
    result = imul(result, 31) + this.port | 0;
    return result;
  };
  protoOf(JsProxy).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsProxy))
      return false;
    var tmp0_other_with_cast = other instanceof JsProxy ? other : THROW_CCE();
    if (!(this.scheme === tmp0_other_with_cast.scheme))
      return false;
    if (!(this.host === tmp0_other_with_cast.host))
      return false;
    if (!(this.port === tmp0_other_with_cast.port))
      return false;
    return true;
  };
  function createJsClient(oauthSupport, proxyConfig) {
    // Inline function 'kotlin.apply' call
    var tmp = Js_instance.y4z();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'createJsClient.<anonymous>' call
    return HttpClient(tmp, createJsClient$lambda(proxyConfig));
  }
  function createJsClient$lambda$lambda($this$install) {
    json($this$install);
    return Unit_instance;
  }
  function createJsClient$lambda$lambda_0($proxyConfig) {
    return function ($this$install) {
      var tmp = $this$install;
      var tmp_0;
      switch ($proxyConfig.scheme) {
        case 'http':
          tmp_0 = Companion_getInstance_1().q4h_1;
          break;
        case 'https':
          tmp_0 = Companion_getInstance_1().r4h_1;
          break;
        default:
          var reason = 'unsupported protocol';
          throw new NotImplementedError('An operation is not implemented: ' + reason);
      }
      tmp.g6q_1 = tmp_0;
      $this$install.h6q_1 = $proxyConfig.host;
      $this$install.i6q_1 = $proxyConfig.port;
      return Unit_instance;
    };
  }
  function createJsClient$lambda($proxyConfig) {
    return function ($this$HttpClient) {
      var tmp = Plugin_getInstance();
      $this$HttpClient.t4u(tmp, createJsClient$lambda$lambda);
      var tmp_0 = get_ProxyPlugin();
      $this$HttpClient.t4u(tmp_0, createJsClient$lambda$lambda_0($proxyConfig));
      return Unit_instance;
    };
  }
  function addEventListener($this, continuation, externalWindow, expectedState, abortSignal) {
    var tmp = window;
    var tmp_0 = EventListener(BrowserWindowOAuthAuthorizer$addEventListener$lambda(externalWindow, expectedState, continuation));
    // Inline function 'js.core.jso' call
    // Inline function 'kotlin.apply' call
    // Inline function 'js.core.jso' call
    var this_0 = {};
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'vc_js.services.BrowserWindowOAuthAuthorizer.addEventListener.<anonymous>' call
    this_0.signal = abortSignal;
    tmp.addEventListener('message', tmp_0, this_0);
  }
  function BrowserWindowOAuthAuthorizer$authorize$lambda($authorizationRequest) {
    return function ($this$parameters) {
      appendParameters($this$parameters, $authorizationRequest);
      return Unit_instance;
    };
  }
  function BrowserWindowOAuthAuthorizer$addEventListener$lambda($externalWindow, $expectedState, $continuation) {
    return function (event) {
      if (!(event instanceof MessageEvent))
        THROW_CCE();
      var data = event.data;
      var tmp;
      try {
        tmp = new URLSearchParams(data);
      } catch ($p) {
        var tmp_0;
        if ($p instanceof Exception) {
          var ex = $p;
          tmp_0 = null;
        } else {
          throw $p;
        }
        tmp = tmp_0;
      }
      var receivedParams = tmp;
      var tmp_1;
      if ((equals(event.source, $externalWindow) || $externalWindow == null) && !(receivedParams == null) && $expectedState == receivedParams.get('state')) {
        var tmp3_safe_receiver = $externalWindow;
        if (tmp3_safe_receiver == null)
          null;
        else {
          tmp3_safe_receiver.close();
        }
        // Inline function 'kotlin.coroutines.resume' call
        var this_0 = $continuation;
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$0 = _Result___init__impl__xyqfz8(receivedParams);
        this_0.g9(tmp$ret$0);
        tmp_1 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function $authorizeCOROUTINE$29(_this__u8e3s4, authorizationEndpoint, authorizationRequest, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.i6t_1 = _this__u8e3s4;
    this.j6t_1 = authorizationEndpoint;
    this.k6t_1 = authorizationRequest;
  }
  protoOf($authorizeCOROUTINE$29).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 7;
            var tmp_0 = this;
            tmp_0.l6t_1 = formUrlEncode(parameters(BrowserWindowOAuthAuthorizer$authorize$lambda(this.k6t_1)));
            this.m6t_1 = window.open(this.j6t_1 + '?' + this.l6t_1);
            this.n6t_1 = new AbortController();
            this.v8_1 = 1;
            continue $sm;
          case 1:
            this.v8_1 = 2;
            continue $sm;
          case 2:
            this.w8_1 = 6;
            this.v8_1 = 3;
            var cancellable = new CancellableContinuationImpl(intercepted(this), 1);
            cancellable.l1r();
            addEventListener(this.i6t_1, cancellable, this.m6t_1, this.k6t_1.state, this.n6t_1.signal);
            suspendResult = returnIfSuspended(cancellable.s1r(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var authorizationResponseParams = suspendResult;
            var tmp_1 = this;
            var tmp0_elvis_lhs = authorizationResponseParams.get('state');
            var tmp_2;
            if (tmp0_elvis_lhs == null) {
              throw Exception_init_$Create$('missing state');
            } else {
              tmp_2 = tmp0_elvis_lhs;
            }

            var tmp_3 = tmp_2;
            var tmp1_elvis_lhs = authorizationResponseParams.get('code');
            var tmp_4;
            if (tmp1_elvis_lhs == null) {
              throw Exception_init_$Create$('missing code');
            } else {
              tmp_4 = tmp1_elvis_lhs;
            }

            tmp_1.o6t_1 = new OAuthAuthorizationResponse(tmp_3, tmp_4);
            this.w8_1 = 7;
            this.v8_1 = 4;
            var tmp_5 = this;
            continue $sm;
          case 4:
            var tmp_6 = this.o6t_1;
            this.w8_1 = 7;
            var tmp2_safe_receiver = this.m6t_1;
            if (tmp2_safe_receiver == null)
              null;
            else {
              tmp2_safe_receiver.close();
            }

            this.n6t_1.abort();
            return tmp_6;
          case 5:
            this.w8_1 = 7;
            var tmp2_safe_receiver_0 = this.m6t_1;
            if (tmp2_safe_receiver_0 == null)
              null;
            else {
              tmp2_safe_receiver_0.close();
            }

            this.n6t_1.abort();
            return Unit_instance;
          case 6:
            this.w8_1 = 7;
            var t = this.y8_1;
            var tmp2_safe_receiver_1 = this.m6t_1;
            if (tmp2_safe_receiver_1 == null)
              null;
            else {
              tmp2_safe_receiver_1.close();
            }

            this.n6t_1.abort();
            throw t;
          case 7:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 7) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function BrowserWindowOAuthAuthorizer() {
  }
  protoOf(BrowserWindowOAuthAuthorizer).s62 = function (authorizationEndpoint, authorizationRequest, $completion) {
    var tmp = new $authorizeCOROUTINE$29(this, authorizationEndpoint, authorizationRequest, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  function createBrowserWindowOAuthSupport(authorizationRequest, oauthClient, authorizationEndpoint, tokenEndpoint, onAuthorizationDone) {
    var tmp;
    if (onAuthorizationDone === VOID) {
      tmp = createBrowserWindowOAuthSupport$lambda;
    } else {
      tmp = onAuthorizationDone;
    }
    onAuthorizationDone = tmp;
    return new JsOAuthSupport(new BrowserWindowOAuthSupport(authorizationRequest, oauthClient, authorizationEndpoint, tokenEndpoint));
  }
  function JsOAuthSupport(delegate) {
    this.p6t_1 = delegate;
  }
  protoOf(JsOAuthSupport).q6t = function () {
    return this.p6t_1;
  };
  function BrowserWindowOAuthSupport(authorizationRequest, oauthClient, authorizationEndpoint, tokenEndpoint) {
    this.r6t_1 = authorizationRequest;
    this.s6t_1 = oauthClient;
    this.t6t_1 = authorizationEndpoint;
    this.u6t_1 = tokenEndpoint;
  }
  function createBrowserWindowOAuthSupport$lambda() {
    return Unit_instance;
  }
  function JsKeyAliasStore$add$slambda(this$0, $alias, $kid, resultContinuation) {
    this.d6u_1 = this$0;
    this.e6u_1 = $alias;
    this.f6u_1 = $kid;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(JsKeyAliasStore$add$slambda).h6u = function ($this$promise, $completion) {
    var tmp = this.e2b($this$promise, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(JsKeyAliasStore$add$slambda).y9 = function (p1, $completion) {
    return this.h6u((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(JsKeyAliasStore$add$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            this.v8_1 = 1;
            suspendResult = this.d6u_1.f6q_1.j68(this.e6u_1, this.f6u_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return true;
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  protoOf(JsKeyAliasStore$add$slambda).e2b = function ($this$promise, completion) {
    var i = new JsKeyAliasStore$add$slambda(this.d6u_1, this.e6u_1, this.f6u_1, completion);
    i.g6u_1 = $this$promise;
    return i;
  };
  function JsKeyAliasStore$add$slambda_0(this$0, $alias, $kid, resultContinuation) {
    var i = new JsKeyAliasStore$add$slambda(this$0, $alias, $kid, resultContinuation);
    var l = function ($this$promise, $completion) {
      return i.h6u($this$promise, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function JsKeyAliasStore$get$slambda(this$0, $alias, resultContinuation) {
    this.q6u_1 = this$0;
    this.r6u_1 = $alias;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(JsKeyAliasStore$get$slambda).t6u = function ($this$promise, $completion) {
    var tmp = this.e2b($this$promise, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(JsKeyAliasStore$get$slambda).y9 = function (p1, $completion) {
    return this.t6u((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(JsKeyAliasStore$get$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            this.v8_1 = 1;
            suspendResult = this.q6u_1.f6q_1.k68(this.r6u_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  protoOf(JsKeyAliasStore$get$slambda).e2b = function ($this$promise, completion) {
    var i = new JsKeyAliasStore$get$slambda(this.q6u_1, this.r6u_1, completion);
    i.s6u_1 = $this$promise;
    return i;
  };
  function JsKeyAliasStore$get$slambda_0(this$0, $alias, resultContinuation) {
    var i = new JsKeyAliasStore$get$slambda(this$0, $alias, resultContinuation);
    var l = function ($this$promise, $completion) {
      return i.t6u($this$promise, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function JsKeyAliasStore(inner) {
    this.f6q_1 = inner;
  }
  protoOf(JsKeyAliasStore).u6u = function () {
    return this.f6q_1;
  };
  protoOf(JsKeyAliasStore).add = function (alias, kid) {
    var tmp = GlobalScope_instance;
    return promise(tmp, VOID, VOID, JsKeyAliasStore$add$slambda_0(this, alias, kid, null));
  };
  protoOf(JsKeyAliasStore).get = function (alias) {
    var tmp = GlobalScope_instance;
    return promise(tmp, VOID, VOID, JsKeyAliasStore$get$slambda_0(this, alias, null));
  };
  function JsCredentialIssuerLoader$load$slambda(this$0, $issuerId, resultContinuation) {
    this.d6v_1 = this$0;
    this.e6v_1 = $issuerId;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(JsCredentialIssuerLoader$load$slambda).g6v = function ($this$promise, $completion) {
    var tmp = this.e2b($this$promise, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(JsCredentialIssuerLoader$load$slambda).y9 = function (p1, $completion) {
    return this.g6v((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(JsCredentialIssuerLoader$load$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            this.v8_1 = 1;
            suspendResult = this.d6v_1.inner.g61(this.e6v_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return createJsCredentialIssuer(ARGUMENT);
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  protoOf(JsCredentialIssuerLoader$load$slambda).e2b = function ($this$promise, completion) {
    var i = new JsCredentialIssuerLoader$load$slambda(this.d6v_1, this.e6v_1, completion);
    i.f6v_1 = $this$promise;
    return i;
  };
  function JsCredentialIssuerLoader$load$slambda_0(this$0, $issuerId, resultContinuation) {
    var i = new JsCredentialIssuerLoader$load$slambda(this$0, $issuerId, resultContinuation);
    var l = function ($this$promise, $completion) {
      return i.g6v($this$promise, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function JsCredentialIssuerLoader(inner) {
    this.inner = inner;
  }
  protoOf(JsCredentialIssuerLoader).o3h = function () {
    return this.inner;
  };
  protoOf(JsCredentialIssuerLoader).load = function (issuerId) {
    var tmp = GlobalScope_instance;
    return promise(tmp, VOID, VOID, JsCredentialIssuerLoader$load$slambda_0(this, issuerId, null));
  };
  function JsCredentialIssuerStore$upsert$slambda($credentialIssuer, this$0, resultContinuation) {
    this.p6v_1 = $credentialIssuer;
    this.q6v_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(JsCredentialIssuerStore$upsert$slambda).h6u = function ($this$promise, $completion) {
    var tmp = this.e2b($this$promise, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(JsCredentialIssuerStore$upsert$slambda).y9 = function (p1, $completion) {
    return this.h6u((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(JsCredentialIssuerStore$upsert$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            var tmp_0 = this;
            var tmp_1 = this.p6v_1;
            var tmp0_elvis_lhs = tmp_1 instanceof JsCredentialIssuer ? tmp_1 : null;
            var tmp_2;
            if (tmp0_elvis_lhs == null) {
              throw new NotImplementedError('An operation is not implemented: ' + '');
            } else {
              tmp_2 = tmp0_elvis_lhs;
            }

            tmp_0.s6v_1 = tmp_2;
            this.v8_1 = 1;
            suspendResult = this.q6v_1.t6v_1.u6v(this.s6v_1.credentialIssuer, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return true;
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  protoOf(JsCredentialIssuerStore$upsert$slambda).e2b = function ($this$promise, completion) {
    var i = new JsCredentialIssuerStore$upsert$slambda(this.p6v_1, this.q6v_1, completion);
    i.r6v_1 = $this$promise;
    return i;
  };
  function JsCredentialIssuerStore$upsert$slambda_0($credentialIssuer, this$0, resultContinuation) {
    var i = new JsCredentialIssuerStore$upsert$slambda($credentialIssuer, this$0, resultContinuation);
    var l = function ($this$promise, $completion) {
      return i.h6u($this$promise, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function JsCredentialIssuerStore$getAll$slambda(this$0, resultContinuation) {
    this.d6w_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(JsCredentialIssuerStore$getAll$slambda).f6w = function ($this$promise, $completion) {
    var tmp = this.e2b($this$promise, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(JsCredentialIssuerStore$getAll$slambda).y9 = function (p1, $completion) {
    return this.f6w((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(JsCredentialIssuerStore$getAll$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            this.v8_1 = 1;
            suspendResult = this.d6w_1.t6v_1.g6w(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_0 = suspendResult;
            var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
            var tmp0_iterator = this_0.j();
            while (tmp0_iterator.k()) {
              var item = tmp0_iterator.l();
              destination.e(createJsCredentialIssuer(item));
            }

            return copyToArray(destination);
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  protoOf(JsCredentialIssuerStore$getAll$slambda).e2b = function ($this$promise, completion) {
    var i = new JsCredentialIssuerStore$getAll$slambda(this.d6w_1, completion);
    i.e6w_1 = $this$promise;
    return i;
  };
  function JsCredentialIssuerStore$getAll$slambda_0(this$0, resultContinuation) {
    var i = new JsCredentialIssuerStore$getAll$slambda(this$0, resultContinuation);
    var l = function ($this$promise, $completion) {
      return i.f6w($this$promise, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function JsCredentialIssuerStore$getById$slambda(this$0, $id, resultContinuation) {
    this.p6w_1 = this$0;
    this.q6w_1 = $id;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(JsCredentialIssuerStore$getById$slambda).s6w = function ($this$promise, $completion) {
    var tmp = this.e2b($this$promise, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(JsCredentialIssuerStore$getById$slambda).y9 = function (p1, $completion) {
    return this.s6w((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(JsCredentialIssuerStore$getById$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            this.v8_1 = 1;
            suspendResult = this.p6w_1.t6v_1.t6w(this.q6w_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp4_safe_receiver = suspendResult;
            var tmp_0;
            if (tmp4_safe_receiver == null) {
              tmp_0 = null;
            } else {
              tmp_0 = createJsCredentialIssuer(tmp4_safe_receiver);
            }

            return tmp_0;
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  protoOf(JsCredentialIssuerStore$getById$slambda).e2b = function ($this$promise, completion) {
    var i = new JsCredentialIssuerStore$getById$slambda(this.p6w_1, this.q6w_1, completion);
    i.r6w_1 = $this$promise;
    return i;
  };
  function JsCredentialIssuerStore$getById$slambda_0(this$0, $id, resultContinuation) {
    var i = new JsCredentialIssuerStore$getById$slambda(this$0, $id, resultContinuation);
    var l = function ($this$promise, $completion) {
      return i.s6w($this$promise, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function JsCredentialIssuerStore$removeById$slambda(this$0, $id, resultContinuation) {
    this.c6x_1 = this$0;
    this.d6x_1 = $id;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(JsCredentialIssuerStore$removeById$slambda).h6u = function ($this$promise, $completion) {
    var tmp = this.e2b($this$promise, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(JsCredentialIssuerStore$removeById$slambda).y9 = function (p1, $completion) {
    return this.h6u((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(JsCredentialIssuerStore$removeById$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            this.v8_1 = 1;
            suspendResult = this.c6x_1.t6v_1.f6x(this.d6x_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return true;
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  protoOf(JsCredentialIssuerStore$removeById$slambda).e2b = function ($this$promise, completion) {
    var i = new JsCredentialIssuerStore$removeById$slambda(this.c6x_1, this.d6x_1, completion);
    i.e6x_1 = $this$promise;
    return i;
  };
  function JsCredentialIssuerStore$removeById$slambda_0(this$0, $id, resultContinuation) {
    var i = new JsCredentialIssuerStore$removeById$slambda(this$0, $id, resultContinuation);
    var l = function ($this$promise, $completion) {
      return i.h6u($this$promise, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function JsCredentialIssuerStore(store) {
    this.t6v_1 = store;
  }
  protoOf(JsCredentialIssuerStore).upsert = function (credentialIssuer) {
    var tmp = GlobalScope_instance;
    return promise(tmp, VOID, VOID, JsCredentialIssuerStore$upsert$slambda_0(credentialIssuer, this, null));
  };
  protoOf(JsCredentialIssuerStore).getAll = function () {
    var tmp = GlobalScope_instance;
    return promise(tmp, VOID, VOID, JsCredentialIssuerStore$getAll$slambda_0(this, null));
  };
  protoOf(JsCredentialIssuerStore).getById = function (id) {
    var tmp = GlobalScope_instance;
    return promise(tmp, VOID, VOID, JsCredentialIssuerStore$getById$slambda_0(this, id, null));
  };
  protoOf(JsCredentialIssuerStore).removeById = function (id) {
    var tmp = GlobalScope_instance;
    return promise(tmp, VOID, VOID, JsCredentialIssuerStore$removeById$slambda_0(this, id, null));
  };
  function JsVerifiableCredentialStore(inner) {
    this.inner = inner;
  }
  protoOf(JsVerifiableCredentialStore).o3h = function () {
    return this.inner;
  };
  protoOf(JsVerifiableCredentialStore).insert = function (credential) {
    this.inner.p68(inner_0(credential));
  };
  protoOf(JsVerifiableCredentialStore).delete = function (credentialId) {
    this.inner.q68(credentialId);
  };
  protoOf(JsVerifiableCredentialStore).getById = function (credentialId) {
    var tmp5_safe_receiver = this.inner.r68(credentialId);
    var tmp;
    if (tmp5_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'JsVerifiableCredentialStore.getById.<anonymous>' call
      tmp = createJsUserVerifiableCredential(tmp5_safe_receiver);
    }
    return tmp;
  };
  protoOf(JsVerifiableCredentialStore).getByName = function (namePrefix) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.inner.s68(namePrefix);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.j();
    while (tmp0_iterator.k()) {
      var item = tmp0_iterator.l();
      // Inline function 'JsVerifiableCredentialStore.getByName.<anonymous>' call
      var tmp$ret$0 = createJsUserVerifiableCredential(item);
      destination.e(tmp$ret$0);
    }
    return copyToArray(destination);
  };
  protoOf(JsVerifiableCredentialStore).getByIssuer = function (issuerId) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.inner.t68(issuerId);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.j();
    while (tmp0_iterator.k()) {
      var item = tmp0_iterator.l();
      // Inline function 'JsVerifiableCredentialStore.getByIssuer.<anonymous>' call
      var tmp$ret$0 = createJsUserVerifiableCredential(item);
      destination.e(tmp$ret$0);
    }
    return copyToArray(destination);
  };
  protoOf(JsVerifiableCredentialStore).getAll = function () {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.inner.u68();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.j();
    while (tmp0_iterator.k()) {
      var item = tmp0_iterator.l();
      // Inline function 'JsVerifiableCredentialStore.getAll.<anonymous>' call
      var tmp$ret$0 = createJsUserVerifiableCredential(item);
      destination.e(tmp$ret$0);
    }
    return copyToArray(destination);
  };
  function JsResolvedOffer$issuer$delegate$lambda(this$0) {
    return function () {
      return createJsCredentialIssuer(this$0.g6x_1.f5y_1);
    };
  }
  function JsResolvedOffer$credentialsSupported$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.map' call
      var this_0 = this$0.g6x_1.g5y_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.j();
      while (tmp0_iterator.k()) {
        var item = tmp0_iterator.l();
        // Inline function 'JsResolvedOffer.credentialsSupported$delegate.<anonymous>.<anonymous>' call
        var tmp$ret$0 = createJsCredentialIssuerSupportedCredential(item);
        destination.e(tmp$ret$0);
      }
      return copyToArray(destination);
    };
  }
  function JsResolvedOffer$txCode$delegate$lambda(this$0) {
    return function () {
      var tmp6_safe_receiver = this$0.g6x_1.h5y_1;
      var tmp;
      if (tmp6_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'JsResolvedOffer.txCode$delegate.<anonymous>.<anonymous>' call
        tmp = new JsTxCode(tmp6_safe_receiver.r31_1, tmp6_safe_receiver.s31_1, tmp6_safe_receiver.t31_1);
      }
      return tmp;
    };
  }
  function JsResolvedOffer(inner) {
    this.g6x_1 = inner;
    var tmp = this;
    tmp.h6x_1 = lazy(JsResolvedOffer$issuer$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.i6x_1 = lazy(JsResolvedOffer$credentialsSupported$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.j6x_1 = lazy(JsResolvedOffer$txCode$delegate$lambda(this));
  }
  protoOf(JsResolvedOffer).u6u = function () {
    return this.g6x_1;
  };
  protoOf(JsResolvedOffer).e3c = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.h6x_1;
    issuer$factory();
    return this_0.b1();
  };
  protoOf(JsResolvedOffer).i3h = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.i6x_1;
    credentialsSupported$factory();
    return this_0.b1();
  };
  protoOf(JsResolvedOffer).k6x = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.j6x_1;
    txCode$factory();
    return this_0.b1();
  };
  function JsTxCode(inputMode, length, description) {
    this.inputMode = inputMode;
    this.length = length;
    this.description = description;
  }
  protoOf(JsTxCode).l6x = function () {
    return this.inputMode;
  };
  protoOf(JsTxCode).a = function () {
    return this.length;
  };
  protoOf(JsTxCode).t3h = function () {
    return this.description;
  };
  function JsOfferResult$issuedCredentials$delegate$lambda(this$0) {
    return function () {
      var tmp = this$0.m6x_1;
      var tmp7_safe_receiver = tmp instanceof IssuedCredentials ? tmp : null;
      var tmp8_safe_receiver = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.b63_1;
      var tmp_0;
      if (tmp8_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(tmp8_safe_receiver, 10));
        var tmp0_iterator = tmp8_safe_receiver.j();
        while (tmp0_iterator.k()) {
          var item = tmp0_iterator.l();
          // Inline function 'JsOfferResult.issuedCredentials$delegate.<anonymous>.<anonymous>' call
          var tmp$ret$0 = createJsUserVerifiableCredential(item);
          destination.e(tmp$ret$0);
        }
        tmp_0 = destination;
      }
      var tmp9_safe_receiver = tmp_0;
      var tmp_1;
      if (tmp9_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.collections.toTypedArray' call
        tmp_1 = copyToArray(tmp9_safe_receiver);
      }
      return tmp_1;
    };
  }
  function JsOfferResult(inner) {
    this.m6x_1 = inner;
    var tmp = this;
    tmp.n6x_1 = lazy(JsOfferResult$issuedCredentials$delegate$lambda(this));
    var tmp_0 = this;
    var tmp_1 = this.m6x_1;
    tmp_0.invalidOfferOrUserCode = tmp_1 instanceof InvalidOfferOrUserCode;
  }
  protoOf(JsOfferResult).o6x = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.n6x_1;
    issuedCredentials$factory();
    return this_0.b1();
  };
  protoOf(JsOfferResult).p6x = function () {
    return this.invalidOfferOrUserCode;
  };
  function JsCredentialIssuanceCoordinator$startHandleOffer$slambda$slambda$lambda($this_coroutineScope) {
    return function (it) {
      cancel($this_coroutineScope);
      return Unit_instance;
    };
  }
  function JsCredentialIssuanceCoordinator$startHandleOffer$slambda$slambda($abortSignal, this$0, $offerString, resultContinuation) {
    this.y6x_1 = $abortSignal;
    this.z6x_1 = this$0;
    this.a6y_1 = $offerString;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(JsCredentialIssuanceCoordinator$startHandleOffer$slambda$slambda).c6y = function ($this$coroutineScope, $completion) {
    var tmp = this.e2b($this$coroutineScope, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(JsCredentialIssuanceCoordinator$startHandleOffer$slambda$slambda).y9 = function (p1, $completion) {
    return this.c6y((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(JsCredentialIssuanceCoordinator$startHandleOffer$slambda$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            this.y6x_1.onabort = JsCredentialIssuanceCoordinator$startHandleOffer$slambda$slambda$lambda(this.b6y_1);
            this.v8_1 = 1;
            suspendResult = this.z6x_1.d6y_1.z62(this.a6y_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var resolvedOffer = suspendResult;
            return new JsResolvedOffer(resolvedOffer);
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  protoOf(JsCredentialIssuanceCoordinator$startHandleOffer$slambda$slambda).e2b = function ($this$coroutineScope, completion) {
    var i = new JsCredentialIssuanceCoordinator$startHandleOffer$slambda$slambda(this.y6x_1, this.z6x_1, this.a6y_1, completion);
    i.b6y_1 = $this$coroutineScope;
    return i;
  };
  function JsCredentialIssuanceCoordinator$startHandleOffer$slambda$slambda_0($abortSignal, this$0, $offerString, resultContinuation) {
    var i = new JsCredentialIssuanceCoordinator$startHandleOffer$slambda$slambda($abortSignal, this$0, $offerString, resultContinuation);
    var l = function ($this$coroutineScope, $completion) {
      return i.c6y($this$coroutineScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function JsCredentialIssuanceCoordinator$continueHandleOffer$slambda$slambda$lambda($this_coroutineScope) {
    return function (it) {
      cancel($this_coroutineScope);
      return Unit_instance;
    };
  }
  function JsCredentialIssuanceCoordinator$continueHandleOffer$slambda$slambda($abortSignal, this$0, $resolvedOffer, $credentialsSupported, $userCode, $signingKeyPair, resultContinuation) {
    this.m6y_1 = $abortSignal;
    this.n6y_1 = this$0;
    this.o6y_1 = $resolvedOffer;
    this.p6y_1 = $credentialsSupported;
    this.q6y_1 = $userCode;
    this.r6y_1 = $signingKeyPair;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(JsCredentialIssuanceCoordinator$continueHandleOffer$slambda$slambda).t6y = function ($this$coroutineScope, $completion) {
    var tmp = this.e2b($this$coroutineScope, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(JsCredentialIssuanceCoordinator$continueHandleOffer$slambda$slambda).y9 = function (p1, $completion) {
    return this.t6y((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(JsCredentialIssuanceCoordinator$continueHandleOffer$slambda$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            this.m6y_1.onabort = JsCredentialIssuanceCoordinator$continueHandleOffer$slambda$slambda$lambda(this.s6y_1);
            this.v8_1 = 1;
            var this_0 = this.p6y_1;
            var destination = ArrayList_init_$Create$(this_0.length);
            var inductionVariable = 0;
            var last = this_0.length;
            while (inductionVariable < last) {
              var item = this_0[inductionVariable];
              inductionVariable = inductionVariable + 1 | 0;
              destination.e(inner_1(item));
            }

            var tmp_0 = toList(destination);
            var tmp_1 = this.r6y_1.signingKey;
            var tmp_2 = tmp_1 instanceof NativeSigningKey ? tmp_1 : THROW_CCE();
            var tmp_3 = this.r6y_1.verificationKey;
            suspendResult = this.n6y_1.d6y_1.a63(this.o6y_1.g6x_1, tmp_0, this.q6y_1, new SigningKeyPair(tmp_2, tmp_3 instanceof NativeVerificationKey ? tmp_3 : THROW_CCE(), this.r6y_1.id), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return new JsOfferResult(ARGUMENT);
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  protoOf(JsCredentialIssuanceCoordinator$continueHandleOffer$slambda$slambda).e2b = function ($this$coroutineScope, completion) {
    var i = new JsCredentialIssuanceCoordinator$continueHandleOffer$slambda$slambda(this.m6y_1, this.n6y_1, this.o6y_1, this.p6y_1, this.q6y_1, this.r6y_1, completion);
    i.s6y_1 = $this$coroutineScope;
    return i;
  };
  function JsCredentialIssuanceCoordinator$continueHandleOffer$slambda$slambda_0($abortSignal, this$0, $resolvedOffer, $credentialsSupported, $userCode, $signingKeyPair, resultContinuation) {
    var i = new JsCredentialIssuanceCoordinator$continueHandleOffer$slambda$slambda($abortSignal, this$0, $resolvedOffer, $credentialsSupported, $userCode, $signingKeyPair, resultContinuation);
    var l = function ($this$coroutineScope, $completion) {
      return i.t6y($this$coroutineScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function JsCredentialIssuanceCoordinator$requestCredentials$slambda$slambda$lambda($abortSignal, $this_coroutineScope) {
    return function (it) {
      var tmp = $abortSignal.reason;
      var cause = tmp instanceof CancellationException ? tmp : null;
      cancel($this_coroutineScope, cause);
      return Unit_instance;
    };
  }
  function JsCredentialIssuanceCoordinator$requestCredentials$slambda$slambda($abortSignal, this$0, $issuer, $credentialSupported, $signingKeyPair, resultContinuation) {
    this.c6z_1 = $abortSignal;
    this.d6z_1 = this$0;
    this.e6z_1 = $issuer;
    this.f6z_1 = $credentialSupported;
    this.g6z_1 = $signingKeyPair;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(JsCredentialIssuanceCoordinator$requestCredentials$slambda$slambda).i6z = function ($this$coroutineScope, $completion) {
    var tmp = this.e2b($this$coroutineScope, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(JsCredentialIssuanceCoordinator$requestCredentials$slambda$slambda).y9 = function (p1, $completion) {
    return this.i6z((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(JsCredentialIssuanceCoordinator$requestCredentials$slambda$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            this.c6z_1.onabort = JsCredentialIssuanceCoordinator$requestCredentials$slambda$slambda$lambda(this.c6z_1, this.h6z_1);
            this.v8_1 = 1;
            var tmp_0 = inner_1(this.f6z_1);
            var tmp_1 = this.g6z_1.signingKey;
            var tmp_2 = tmp_1 instanceof NativeSigningKey ? tmp_1 : THROW_CCE();
            var tmp_3 = this.g6z_1.verificationKey;
            suspendResult = this.d6z_1.d6y_1.y61(this.e6z_1.credentialIssuer, tmp_0, new SigningKeyPair(tmp_2, tmp_3 instanceof NativeVerificationKey ? tmp_3 : THROW_CCE(), this.g6z_1.id), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_0 = suspendResult;
            var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
            var tmp0_iterator = this_0.j();
            while (tmp0_iterator.k()) {
              var item = tmp0_iterator.l();
              destination.e(createJsUserVerifiableCredential(item));
            }

            return copyToArray(destination);
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  protoOf(JsCredentialIssuanceCoordinator$requestCredentials$slambda$slambda).e2b = function ($this$coroutineScope, completion) {
    var i = new JsCredentialIssuanceCoordinator$requestCredentials$slambda$slambda(this.c6z_1, this.d6z_1, this.e6z_1, this.f6z_1, this.g6z_1, completion);
    i.h6z_1 = $this$coroutineScope;
    return i;
  };
  function JsCredentialIssuanceCoordinator$requestCredentials$slambda$slambda_0($abortSignal, this$0, $issuer, $credentialSupported, $signingKeyPair, resultContinuation) {
    var i = new JsCredentialIssuanceCoordinator$requestCredentials$slambda$slambda($abortSignal, this$0, $issuer, $credentialSupported, $signingKeyPair, resultContinuation);
    var l = function ($this$coroutineScope, $completion) {
      return i.i6z($this$coroutineScope, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function JsCredentialIssuanceCoordinator$startHandleOffer$slambda($abortSignal, this$0, $offerString, resultContinuation) {
    this.r6z_1 = $abortSignal;
    this.s6z_1 = this$0;
    this.t6z_1 = $offerString;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(JsCredentialIssuanceCoordinator$startHandleOffer$slambda).u6z = function ($completion) {
    var tmp = this.n6r($completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(JsCredentialIssuanceCoordinator$startHandleOffer$slambda).o6r = function ($completion) {
    return this.u6z($completion);
  };
  protoOf(JsCredentialIssuanceCoordinator$startHandleOffer$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            this.v8_1 = 1;
            suspendResult = coroutineScope(JsCredentialIssuanceCoordinator$startHandleOffer$slambda$slambda_0(this.r6z_1, this.s6z_1, this.t6z_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  protoOf(JsCredentialIssuanceCoordinator$startHandleOffer$slambda).n6r = function (completion) {
    return new JsCredentialIssuanceCoordinator$startHandleOffer$slambda(this.r6z_1, this.s6z_1, this.t6z_1, completion);
  };
  function JsCredentialIssuanceCoordinator$startHandleOffer$slambda_0($abortSignal, this$0, $offerString, resultContinuation) {
    var i = new JsCredentialIssuanceCoordinator$startHandleOffer$slambda($abortSignal, this$0, $offerString, resultContinuation);
    var l = function ($completion) {
      return i.u6z($completion);
    };
    l.$arity = 0;
    return l;
  }
  function JsCredentialIssuanceCoordinator$continueHandleOffer$slambda($abortSignal, this$0, $resolvedOffer, $credentialsSupported, $userCode, $signingKeyPair, resultContinuation) {
    this.d70_1 = $abortSignal;
    this.e70_1 = this$0;
    this.f70_1 = $resolvedOffer;
    this.g70_1 = $credentialsSupported;
    this.h70_1 = $userCode;
    this.i70_1 = $signingKeyPair;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(JsCredentialIssuanceCoordinator$continueHandleOffer$slambda).j70 = function ($completion) {
    var tmp = this.n6r($completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(JsCredentialIssuanceCoordinator$continueHandleOffer$slambda).o6r = function ($completion) {
    return this.j70($completion);
  };
  protoOf(JsCredentialIssuanceCoordinator$continueHandleOffer$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            this.v8_1 = 1;
            suspendResult = coroutineScope(JsCredentialIssuanceCoordinator$continueHandleOffer$slambda$slambda_0(this.d70_1, this.e70_1, this.f70_1, this.g70_1, this.h70_1, this.i70_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  protoOf(JsCredentialIssuanceCoordinator$continueHandleOffer$slambda).n6r = function (completion) {
    return new JsCredentialIssuanceCoordinator$continueHandleOffer$slambda(this.d70_1, this.e70_1, this.f70_1, this.g70_1, this.h70_1, this.i70_1, completion);
  };
  function JsCredentialIssuanceCoordinator$continueHandleOffer$slambda_0($abortSignal, this$0, $resolvedOffer, $credentialsSupported, $userCode, $signingKeyPair, resultContinuation) {
    var i = new JsCredentialIssuanceCoordinator$continueHandleOffer$slambda($abortSignal, this$0, $resolvedOffer, $credentialsSupported, $userCode, $signingKeyPair, resultContinuation);
    var l = function ($completion) {
      return i.j70($completion);
    };
    l.$arity = 0;
    return l;
  }
  function JsCredentialIssuanceCoordinator$requestCredentials$slambda($abortSignal, this$0, $issuer, $credentialSupported, $signingKeyPair, resultContinuation) {
    this.s70_1 = $abortSignal;
    this.t70_1 = this$0;
    this.u70_1 = $issuer;
    this.v70_1 = $credentialSupported;
    this.w70_1 = $signingKeyPair;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(JsCredentialIssuanceCoordinator$requestCredentials$slambda).x70 = function ($completion) {
    var tmp = this.n6r($completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(JsCredentialIssuanceCoordinator$requestCredentials$slambda).o6r = function ($completion) {
    return this.x70($completion);
  };
  protoOf(JsCredentialIssuanceCoordinator$requestCredentials$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            this.v8_1 = 1;
            suspendResult = coroutineScope(JsCredentialIssuanceCoordinator$requestCredentials$slambda$slambda_0(this.s70_1, this.t70_1, this.u70_1, this.v70_1, this.w70_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  protoOf(JsCredentialIssuanceCoordinator$requestCredentials$slambda).n6r = function (completion) {
    return new JsCredentialIssuanceCoordinator$requestCredentials$slambda(this.s70_1, this.t70_1, this.u70_1, this.v70_1, this.w70_1, completion);
  };
  function JsCredentialIssuanceCoordinator$requestCredentials$slambda_0($abortSignal, this$0, $issuer, $credentialSupported, $signingKeyPair, resultContinuation) {
    var i = new JsCredentialIssuanceCoordinator$requestCredentials$slambda($abortSignal, this$0, $issuer, $credentialSupported, $signingKeyPair, resultContinuation);
    var l = function ($completion) {
      return i.x70($completion);
    };
    l.$arity = 0;
    return l;
  }
  function JsCredentialIssuanceCoordinator(inner) {
    this.d6y_1 = inner;
  }
  protoOf(JsCredentialIssuanceCoordinator).startHandleOffer = function (offerString, abortSignal) {
    var tmp = GlobalScope_instance;
    return safePromise(tmp, VOID, JsCredentialIssuanceCoordinator$startHandleOffer$slambda_0(abortSignal, this, offerString, null));
  };
  protoOf(JsCredentialIssuanceCoordinator).continueHandleOffer = function (resolvedOffer, credentialsSupported, userCode, signingKeyPair, abortSignal) {
    var tmp = GlobalScope_instance;
    return safePromise(tmp, VOID, JsCredentialIssuanceCoordinator$continueHandleOffer$slambda_0(abortSignal, this, resolvedOffer, credentialsSupported, userCode, signingKeyPair, null));
  };
  protoOf(JsCredentialIssuanceCoordinator).requestCredentials = function (issuer, credentialSupported, signingKeyPair, abortSignal) {
    var tmp = GlobalScope_instance;
    return safePromise(tmp, VOID, JsCredentialIssuanceCoordinator$requestCredentials$slambda_0(abortSignal, this, issuer, credentialSupported, signingKeyPair, null));
  };
  function issuer$factory() {
    return getPropertyCallableRef('issuer', 1, KProperty1, function (receiver) {
      return receiver.issuer;
    }, null);
  }
  function credentialsSupported$factory() {
    return getPropertyCallableRef('credentialsSupported', 1, KProperty1, function (receiver) {
      return receiver.credentialsSupported;
    }, null);
  }
  function txCode$factory() {
    return getPropertyCallableRef('txCode', 1, KProperty1, function (receiver) {
      return receiver.txCode;
    }, null);
  }
  function issuedCredentials$factory() {
    return getPropertyCallableRef('issuedCredentials', 1, KProperty1, function (receiver) {
      return receiver.issuedCredentials;
    }, null);
  }
  function LocalStorageCredentialIssuerStore$Companion$json$lambda($this$Json) {
    $this$Json.u19_1 = true;
    return Unit_instance;
  }
  function loadFromLocalStorage($this) {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'vc_js.decodeFromLocalStorageOrNull' call
      var this_0 = Companion_getInstance_18().z70_1;
      var key = 'issuer-store';
      // Inline function 'org.w3c.dom.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp0_elvis_lhs = localStorage[key];
      var tmp;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$2 = null;
        break $l$block;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var storedValue = tmp;
      var tmp_0;
      try {
        // Inline function 'kotlinx.serialization.json.Json.decodeFromString' call
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.dp();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer(this_1, createKType(getKClass(KtMutableMap), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().gb(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(JsonCredentialIssuer), arrayOf([]), false))]), true));
        var tmp$ret$4 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
        tmp_0 = this_0.cp(tmp$ret$4, storedValue);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Exception) {
          var ex = $p;
          console.log("Ignoring localStorage key '" + key + "'");
          tmp_1 = null;
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      tmp$ret$2 = tmp_0;
    }
    var tmp0_elvis_lhs_0 = tmp$ret$2;
    var tmp_2;
    if (tmp0_elvis_lhs_0 == null) {
      // Inline function 'kotlin.collections.mutableMapOf' call
      tmp_2 = LinkedHashMap_init_$Create$_0();
    } else {
      tmp_2 = tmp0_elvis_lhs_0;
    }
    return tmp_2;
  }
  function saveIntoLocalStorage($this) {
    var tmp = localStorage;
    // Inline function 'kotlinx.serialization.encodeToString' call
    var this_0 = Companion_getInstance_18().z70_1;
    var value = $this.a71_1;
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.dp();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(KtMutableMap), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().gb(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(JsonCredentialIssuer), arrayOf([]), false))]), false));
    var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
    var tmp$ret$2 = this_0.bp(tmp$ret$1, value);
    tmp.setItem('issuer-store', tmp$ret$2);
  }
  function Companion_11() {
    Companion_instance_20 = this;
    this.y70_1 = 'issuer-store';
    var tmp = this;
    tmp.z70_1 = Json(VOID, LocalStorageCredentialIssuerStore$Companion$json$lambda);
  }
  var Companion_instance_20;
  function Companion_getInstance_18() {
    if (Companion_instance_20 == null)
      new Companion_11();
    return Companion_instance_20;
  }
  function LocalStorageCredentialIssuerStore() {
    Companion_getInstance_18();
    this.a71_1 = loadFromLocalStorage(this);
  }
  protoOf(LocalStorageCredentialIssuerStore).u6v = function (credentialIssuer, $completion) {
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.a71_1;
    var key = credentialIssuer.t32_1.u33_1;
    this_0.m2(key, credentialIssuer);
    saveIntoLocalStorage(this);
    return Unit_instance;
  };
  protoOf(LocalStorageCredentialIssuerStore).f6x = function (id, $completion) {
    this.a71_1.n2(id);
    saveIntoLocalStorage(this);
    return Unit_instance;
  };
  protoOf(LocalStorageCredentialIssuerStore).g6w = function ($completion) {
    return toList(this.a71_1.g2());
  };
  protoOf(LocalStorageCredentialIssuerStore).t6w = function (id, $completion) {
    return this.a71_1.e2(id);
  };
  function loadFromLocalStorage_0($this) {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'vc_js.decodeFromLocalStorageOrNull' call
      var this_0 = Default_getInstance();
      var key = 'credential-store';
      // Inline function 'org.w3c.dom.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp0_elvis_lhs = localStorage[key];
      var tmp;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$2 = null;
        break $l$block;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var storedValue = tmp;
      var tmp_0;
      try {
        // Inline function 'kotlinx.serialization.json.Json.decodeFromString' call
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.dp();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer(this_1, createKType(getKClass(InMemoryVerifiableCredentialStore), arrayOf([]), true));
        var tmp$ret$4 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
        tmp_0 = this_0.cp(tmp$ret$4, storedValue);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Exception) {
          var ex = $p;
          console.log("Ignoring localStorage key '" + key + "'");
          tmp_1 = null;
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      tmp$ret$2 = tmp_0;
    }
    var tmp0_elvis_lhs_0 = tmp$ret$2;
    return tmp0_elvis_lhs_0 == null ? new InMemoryVerifiableCredentialStore() : tmp0_elvis_lhs_0;
  }
  function Companion_12() {
    this.b71_1 = 'credential-store';
  }
  var Companion_instance_21;
  function Companion_getInstance_19() {
    return Companion_instance_21;
  }
  function saveIntoLocalStorage_0($this) {
    var tmp = localStorage;
    // Inline function 'kotlinx.serialization.encodeToString' call
    var this_0 = Default_getInstance();
    var value = $this.c71_1;
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.dp();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(InMemoryVerifiableCredentialStore), arrayOf([]), false));
    var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
    var tmp$ret$2 = this_0.bp(tmp$ret$1, value);
    tmp.setItem('credential-store', tmp$ret$2);
  }
  function LocalStorageVerifiableCredentialStore(delegate) {
    delegate = delegate === VOID ? loadFromLocalStorage_0(Companion_instance_21) : delegate;
    this.c71_1 = delegate;
  }
  protoOf(LocalStorageVerifiableCredentialStore).r68 = function (localId) {
    return this.c71_1.r68(localId);
  };
  protoOf(LocalStorageVerifiableCredentialStore).s68 = function (namePrefix) {
    return this.c71_1.s68(namePrefix);
  };
  protoOf(LocalStorageVerifiableCredentialStore).t68 = function (issuerId) {
    return this.c71_1.t68(issuerId);
  };
  protoOf(LocalStorageVerifiableCredentialStore).u68 = function () {
    return this.c71_1.u68();
  };
  protoOf(LocalStorageVerifiableCredentialStore).p68 = function (credential) {
    this.c71_1.p68(credential);
    saveIntoLocalStorage_0(this);
  };
  protoOf(LocalStorageVerifiableCredentialStore).q68 = function (localId) {
    this.c71_1.q68(localId);
    saveIntoLocalStorage_0(this);
  };
  function JsValidatedRequestJwt(inner) {
    this.inner = inner;
    this.jws = new JsJwsHeaderAndPayload(this.inner.f6i_1);
    this.responseUri = this.inner.g6i_1;
    this.iss = this.inner.h6i_1;
    this.presentationDefinition = new JsPresentationDefinition(this.inner.j6i_1);
    this.state = this.inner.k6i_1;
    this.expAt = this.inner.l6i_1;
  }
  protoOf(JsValidatedRequestJwt).o3h = function () {
    return this.inner;
  };
  protoOf(JsValidatedRequestJwt).d71 = function () {
    return this.jws;
  };
  protoOf(JsValidatedRequestJwt).e71 = function () {
    return this.responseUri;
  };
  protoOf(JsValidatedRequestJwt).f71 = function () {
    return this.iss;
  };
  protoOf(JsValidatedRequestJwt).g71 = function () {
    return this.presentationDefinition;
  };
  protoOf(JsValidatedRequestJwt).n5v = function () {
    return this.state;
  };
  protoOf(JsValidatedRequestJwt).h71 = function () {
    return this.expAt;
  };
  function JsPresentationDefinition$format$delegate$lambda(this$0) {
    return function () {
      var innerFormat = this$0.inner.j3d_1;
      var tmp;
      if (!(innerFormat == null)) {
        tmp = new JsFormat(innerFormat);
      } else {
        tmp = null;
      }
      return tmp;
    };
  }
  function JsPresentationDefinition$inputDescriptors$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.map' call
      var this_0 = this$0.inner.k3d_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.j();
      while (tmp0_iterator.k()) {
        var item = tmp0_iterator.l();
        // Inline function 'JsPresentationDefinition.inputDescriptors$delegate.<anonymous>.<anonymous>' call
        var tmp$ret$0 = new JsInputDescriptor(item);
        destination.e(tmp$ret$0);
      }
      return copyToArray(destination);
    };
  }
  function JsPresentationDefinition(inner) {
    this.inner = inner;
    this.id = this.inner.g3d_1;
    this.name = this.inner.h3d_1;
    this.purpose = this.inner.i3d_1;
    var tmp = this;
    tmp.i71_1 = lazy(JsPresentationDefinition$format$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.j71_1 = lazy(JsPresentationDefinition$inputDescriptors$delegate$lambda(this));
  }
  protoOf(JsPresentationDefinition).o3h = function () {
    return this.inner;
  };
  protoOf(JsPresentationDefinition).k2a = function () {
    return this.id;
  };
  protoOf(JsPresentationDefinition).r2 = function () {
    return this.name;
  };
  protoOf(JsPresentationDefinition).k71 = function () {
    return this.purpose;
  };
  protoOf(JsPresentationDefinition).z33 = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.i71_1;
    format$factory();
    return this_0.b1();
  };
  protoOf(JsPresentationDefinition).l71 = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.j71_1;
    inputDescriptors$factory();
    return this_0.b1();
  };
  function JsFormat$jwtVcJson$delegate$lambda($inner) {
    return function () {
      var innerJwtVcJson = $inner.s3e_1;
      var tmp;
      if (!(innerJwtVcJson == null)) {
        tmp = new JsAlgFormat(innerJwtVcJson);
      } else {
        tmp = null;
      }
      return tmp;
    };
  }
  function JsFormat$jwtVpJson$delegate$lambda($inner) {
    return function () {
      var innerJwtVpJson = $inner.t3e_1;
      var tmp;
      if (!(innerJwtVpJson == null)) {
        tmp = new JsAlgFormat(innerJwtVpJson);
      } else {
        tmp = null;
      }
      return tmp;
    };
  }
  function JsFormat$ldpVc$delegate$lambda($inner) {
    return function () {
      var innerLdpVc = $inner.v3e_1;
      var tmp;
      if (!(innerLdpVc == null)) {
        tmp = new JsProofTypeFormat(innerLdpVc);
      } else {
        tmp = null;
      }
      return tmp;
    };
  }
  function JsFormat$ldpVp$delegate$lambda($inner) {
    return function () {
      var innerLdpVc = $inner.v3e_1;
      var tmp;
      if (!(innerLdpVc == null)) {
        tmp = new JsProofTypeFormat(innerLdpVc);
      } else {
        tmp = null;
      }
      return tmp;
    };
  }
  function JsFormat$customFormats$delegate$lambda($inner) {
    return function () {
      return createJSObject($inner.x3e_1);
    };
  }
  function JsFormat(inner) {
    var tmp = this;
    tmp.m71_1 = lazy(JsFormat$jwtVcJson$delegate$lambda(inner));
    var tmp_0 = this;
    tmp_0.n71_1 = lazy(JsFormat$jwtVpJson$delegate$lambda(inner));
    var tmp_1 = this;
    tmp_1.o71_1 = lazy(JsFormat$ldpVc$delegate$lambda(inner));
    var tmp_2 = this;
    tmp_2.p71_1 = lazy(JsFormat$ldpVp$delegate$lambda(inner));
    var tmp_3 = this;
    tmp_3.q71_1 = lazy(JsFormat$customFormats$delegate$lambda(inner));
  }
  protoOf(JsFormat).a3j = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.m71_1;
    jwtVcJson$factory();
    return this_0.b1();
  };
  protoOf(JsFormat).r71 = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.n71_1;
    jwtVpJson$factory();
    return this_0.b1();
  };
  protoOf(JsFormat).s71 = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.o71_1;
    ldpVc$factory();
    return this_0.b1();
  };
  protoOf(JsFormat).t71 = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.p71_1;
    ldpVp$factory();
    return this_0.b1();
  };
  protoOf(JsFormat).u71 = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.q71_1;
    customFormats$factory();
    return this_0.b1();
  };
  function JsAlgFormat(inner) {
    var tmp = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = inner.b3f_1;
    tmp.alg = copyToArray(this_0);
  }
  protoOf(JsAlgFormat).v71 = function () {
    return this.alg;
  };
  function JsProofTypeFormat(inner) {
    var tmp = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = inner.c3f_1;
    tmp.proofType = copyToArray(this_0);
  }
  protoOf(JsProofTypeFormat).w71 = function () {
    return this.proofType;
  };
  function JsInputDescriptor$format$delegate$lambda(this$0) {
    return function () {
      var innerFormat = this$0.inner.r3d_1;
      var tmp;
      if (!(innerFormat == null)) {
        tmp = new JsFormat(innerFormat);
      } else {
        tmp = null;
      }
      return tmp;
    };
  }
  function JsInputDescriptor(inner) {
    this.inner = inner;
    this.id = this.inner.n3d_1;
    this.name = this.inner.o3d_1;
    this.purpose = this.inner.p3d_1;
    this.constraints = new JsConstraint(this.inner.q3d_1);
    var tmp = this;
    tmp.x71_1 = lazy(JsInputDescriptor$format$delegate$lambda(this));
  }
  protoOf(JsInputDescriptor).o3h = function () {
    return this.inner;
  };
  protoOf(JsInputDescriptor).k2a = function () {
    return this.id;
  };
  protoOf(JsInputDescriptor).r2 = function () {
    return this.name;
  };
  protoOf(JsInputDescriptor).k71 = function () {
    return this.purpose;
  };
  protoOf(JsInputDescriptor).y71 = function () {
    return this.constraints;
  };
  protoOf(JsInputDescriptor).z33 = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.x71_1;
    format$factory_0();
    return this_0.b1();
  };
  function JsConstraint$fields$delegate$lambda($inner) {
    return function () {
      var innerFields = $inner.v3d_1;
      var tmp;
      if (innerFields == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(innerFields, 10));
        var tmp0_iterator = innerFields.j();
        while (tmp0_iterator.k()) {
          var item = tmp0_iterator.l();
          // Inline function 'JsConstraint.fields$delegate.<anonymous>.<anonymous>' call
          var tmp$ret$0 = new JsField(item);
          destination.e(tmp$ret$0);
        }
        tmp = destination;
      }
      var tmp11_safe_receiver = tmp;
      var tmp_0;
      if (tmp11_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.collections.toTypedArray' call
        tmp_0 = copyToArray(tmp11_safe_receiver);
      }
      return tmp_0;
    };
  }
  function JsConstraint(inner) {
    var tmp = this;
    tmp.z71_1 = lazy(JsConstraint$fields$delegate$lambda(inner));
    this.limitDisclosure = inner.w3d_1;
  }
  protoOf(JsConstraint).a72 = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.z71_1;
    fields$factory();
    return this_0.b1();
  };
  protoOf(JsConstraint).b72 = function () {
    return this.limitDisclosure;
  };
  function JsField$filter$delegate$lambda($inner) {
    return function () {
      var innerFilter = $inner.e3e_1;
      var tmp;
      if (!(innerFilter == null)) {
        tmp = Companion_instance_22.c72(innerFilter);
      } else {
        tmp = null;
      }
      return tmp;
    };
  }
  function JsField(inner) {
    this.id = inner.a3e_1;
    this.name = inner.b3e_1;
    this.purpose = inner.c3e_1;
    var tmp = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = inner.d3e_1;
    tmp.path = copyToArray(this_0);
    var tmp_0 = this;
    tmp_0.d72_1 = lazy(JsField$filter$delegate$lambda(inner));
    this.optional = inner.f3e_1;
  }
  protoOf(JsField).k2a = function () {
    return this.id;
  };
  protoOf(JsField).r2 = function () {
    return this.name;
  };
  protoOf(JsField).k71 = function () {
    return this.purpose;
  };
  protoOf(JsField).e72 = function () {
    return this.path;
  };
  protoOf(JsField).f72 = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.d72_1;
    filter$factory();
    return this_0.b1();
  };
  protoOf(JsField).g72 = function () {
    return this.optional;
  };
  function Companion_13() {
  }
  protoOf(Companion_13).c72 = function (jsonFilter) {
    var tmp;
    if (jsonFilter instanceof JsonStringFilter) {
      tmp = new JsStringFilter(jsonFilter);
    } else {
      if (jsonFilter instanceof JsonArrayContainsFilter) {
        tmp = new JsArrayContainsFilter(jsonFilter);
      } else {
        noWhenBranchMatchedException();
      }
    }
    return tmp;
  };
  var Companion_instance_22;
  function Companion_getInstance_20() {
    return Companion_instance_22;
  }
  function AbstractJsfilter() {
  }
  function JsStringFilter(inner) {
    AbstractJsfilter.call(this);
    this.h72_1 = inner.q3e_1;
    this.pattern = inner.r3e_1;
  }
  protoOf(JsStringFilter).g36 = function () {
    return this.h72_1;
  };
  protoOf(JsStringFilter).i72 = function () {
    return this.pattern;
  };
  function JsArrayContainsFilter(inner) {
    AbstractJsfilter.call(this);
    this.j72_1 = inner.i3e_1;
    this.contains = new JsContains(inner.j3e_1);
  }
  protoOf(JsArrayContainsFilter).g36 = function () {
    return this.j72_1;
  };
  protoOf(JsArrayContainsFilter).k72 = function () {
    return this.contains;
  };
  function JsContains(inner) {
    this.type = inner.m3e_1;
    this.pattern = inner.n3e_1;
  }
  protoOf(JsContains).g36 = function () {
    return this.type;
  };
  protoOf(JsContains).i72 = function () {
    return this.pattern;
  };
  function JsVerifiablePresentationResponseParameters(inner) {
    this.inner = inner;
  }
  protoOf(JsVerifiablePresentationResponseParameters).o3h = function () {
    return this.inner;
  };
  function JsPresentationSubmission$descriptorMap$delegate$lambda($inner) {
    return function () {
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.map' call
      var this_0 = $inner.w3c_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.j();
      while (tmp0_iterator.k()) {
        var item = tmp0_iterator.l();
        // Inline function 'JsPresentationSubmission.descriptorMap$delegate.<anonymous>.<anonymous>' call
        var tmp$ret$0 = new JsDescriptorMapObject(item);
        destination.e(tmp$ret$0);
      }
      return copyToArray(destination);
    };
  }
  function JsPresentationSubmission(inner) {
    this.id = inner.u3c_1;
    this.definitionId = inner.v3c_1;
    var tmp = this;
    tmp.l72_1 = lazy(JsPresentationSubmission$descriptorMap$delegate$lambda(inner));
  }
  protoOf(JsPresentationSubmission).k2a = function () {
    return this.id;
  };
  protoOf(JsPresentationSubmission).m72 = function () {
    return this.definitionId;
  };
  protoOf(JsPresentationSubmission).n72 = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.l72_1;
    descriptorMap$factory();
    return this_0.b1();
  };
  function JsDescriptorMapObject(inner) {
    this.id = inner.z3c_1;
    this.format = inner.a3d_1;
    this.path = inner.b3d_1;
    var tmp = this;
    var tmp13_safe_receiver = inner.c3d_1;
    var tmp_0;
    if (tmp13_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'JsDescriptorMapObject.pathNested.<anonymous>' call
      tmp_0 = new JsPathNested(tmp13_safe_receiver);
    }
    tmp.pathNested = tmp_0;
  }
  protoOf(JsDescriptorMapObject).k2a = function () {
    return this.id;
  };
  protoOf(JsDescriptorMapObject).z33 = function () {
    return this.format;
  };
  protoOf(JsDescriptorMapObject).e72 = function () {
    return this.path;
  };
  protoOf(JsDescriptorMapObject).o72 = function () {
    return this.pathNested;
  };
  function JsPathNested(inner) {
    this.format = inner.h3f_1;
    this.path = inner.i3f_1;
  }
  protoOf(JsPathNested).z33 = function () {
    return this.format;
  };
  protoOf(JsPathNested).e72 = function () {
    return this.path;
  };
  function JsVerifierDirectPostAuthorizationResponse(inner) {
    this.redirectUri = inner.u3f();
  }
  protoOf(JsVerifierDirectPostAuthorizationResponse).u3f = function () {
    return this.redirectUri;
  };
  function JsUserSelectedCredentials(data) {
    this.data = data;
  }
  protoOf(JsUserSelectedCredentials).p72 = function () {
    return this.data;
  };
  function JsUserSelectedCredential(descriptor, credential, presentationDisclosures) {
    this.descriptor = descriptor;
    this.credential = credential;
    this.presentationDisclosures = presentationDisclosures;
  }
  protoOf(JsUserSelectedCredential).yn = function () {
    return this.descriptor;
  };
  protoOf(JsUserSelectedCredential).n38 = function () {
    return this.credential;
  };
  protoOf(JsUserSelectedCredential).q72 = function () {
    return this.presentationDisclosures;
  };
  function JsPresentationDisclosure(disclosures) {
    this.disclosures = disclosures;
  }
  protoOf(JsPresentationDisclosure).a2z = function () {
    return this.disclosures;
  };
  function format$factory() {
    return getPropertyCallableRef('format', 1, KProperty1, function (receiver) {
      return receiver.format;
    }, null);
  }
  function inputDescriptors$factory() {
    return getPropertyCallableRef('inputDescriptors', 1, KProperty1, function (receiver) {
      return receiver.inputDescriptors;
    }, null);
  }
  function jwtVcJson$factory() {
    return getPropertyCallableRef('jwtVcJson', 1, KProperty1, function (receiver) {
      return receiver.jwtVcJson;
    }, null);
  }
  function jwtVpJson$factory() {
    return getPropertyCallableRef('jwtVpJson', 1, KProperty1, function (receiver) {
      return receiver.jwtVpJson;
    }, null);
  }
  function ldpVc$factory() {
    return getPropertyCallableRef('ldpVc', 1, KProperty1, function (receiver) {
      return receiver.ldpVc;
    }, null);
  }
  function ldpVp$factory() {
    return getPropertyCallableRef('ldpVp', 1, KProperty1, function (receiver) {
      return receiver.ldpVp;
    }, null);
  }
  function customFormats$factory() {
    return getPropertyCallableRef('customFormats', 1, KProperty1, function (receiver) {
      return receiver.customFormats;
    }, null);
  }
  function format$factory_0() {
    return getPropertyCallableRef('format', 1, KProperty1, function (receiver) {
      return receiver.format;
    }, null);
  }
  function fields$factory() {
    return getPropertyCallableRef('fields', 1, KProperty1, function (receiver) {
      return receiver.fields;
    }, null);
  }
  function filter$factory() {
    return getPropertyCallableRef('filter', 1, KProperty1, function (receiver) {
      return receiver.filter;
    }, null);
  }
  function descriptorMap$factory() {
    return getPropertyCallableRef('descriptorMap', 1, KProperty1, function (receiver) {
      return receiver.descriptorMap;
    }, null);
  }
  function convertToUserSelectCredentials($this, userSelectedCredentials) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = userSelectedCredentials.data;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'Companion.convertToUserSelectCredentials.<anonymous>' call
      var tmp$ret$0 = new UserSelectedCredential(item.descriptor.inner, inner_0(item.credential), new PresentationDisclosure(toList_0(item.presentationDisclosures.disclosures)));
      destination.e(tmp$ret$0);
    }
    return new UserSelectedCredentials(destination);
  }
  function Companion_14() {
  }
  var Companion_instance_23;
  function Companion_getInstance_21() {
    return Companion_instance_23;
  }
  function JsPresentationResponseCreator$createVerifiablePresentationResponse$slambda(this$0, $validatedRequestJwt, $userSelectedCredentials, resultContinuation) {
    this.z72_1 = this$0;
    this.a73_1 = $validatedRequestJwt;
    this.b73_1 = $userSelectedCredentials;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(JsPresentationResponseCreator$createVerifiablePresentationResponse$slambda).c73 = function ($completion) {
    var tmp = this.n6r($completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(JsPresentationResponseCreator$createVerifiablePresentationResponse$slambda).o6r = function ($completion) {
    return this.c73($completion);
  };
  protoOf(JsPresentationResponseCreator$createVerifiablePresentationResponse$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            this.v8_1 = 1;
            suspendResult = this.z72_1.d73_1.g6k(this.a73_1.inner, convertToUserSelectCredentials(Companion_instance_23, this.b73_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var params = suspendResult;
            return new JsVerifiablePresentationResponseParameters(params);
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  protoOf(JsPresentationResponseCreator$createVerifiablePresentationResponse$slambda).n6r = function (completion) {
    return new JsPresentationResponseCreator$createVerifiablePresentationResponse$slambda(this.z72_1, this.a73_1, this.b73_1, completion);
  };
  function JsPresentationResponseCreator$createVerifiablePresentationResponse$slambda_0(this$0, $validatedRequestJwt, $userSelectedCredentials, resultContinuation) {
    var i = new JsPresentationResponseCreator$createVerifiablePresentationResponse$slambda(this$0, $validatedRequestJwt, $userSelectedCredentials, resultContinuation);
    var l = function ($completion) {
      return i.c73($completion);
    };
    l.$arity = 0;
    return l;
  }
  function JsPresentationResponseCreator(inner) {
    this.d73_1 = inner;
  }
  protoOf(JsPresentationResponseCreator).createVerifiablePresentationResponse = function (validatedRequestJwt, userSelectedCredentials) {
    var tmp = GlobalScope_instance;
    return safePromise(tmp, VOID, JsPresentationResponseCreator$createVerifiablePresentationResponse$slambda_0(this, validatedRequestJwt, userSelectedCredentials, null));
  };
  function JsRequestJwtStore(inner) {
    this.inner = inner;
  }
  protoOf(JsRequestJwtStore).o3h = function () {
    return this.inner;
  };
  protoOf(JsRequestJwtStore).insert = function (id, requestJwt) {
    this.inner.i6f(id, requestJwt.inner);
  };
  protoOf(JsRequestJwtStore).delete = function (id) {
    this.inner.q68(id);
  };
  protoOf(JsRequestJwtStore).getById = function (id) {
    var tmp14_safe_receiver = this.inner.r68(id);
    var tmp;
    if (tmp14_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'JsRequestJwtStore.getById.<anonymous>' call
      tmp = new JsValidatedRequestJwt(tmp14_safe_receiver);
    }
    return tmp;
  };
  protoOf(JsRequestJwtStore).getAll = function () {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.inner.u68();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.j();
    while (tmp0_iterator.k()) {
      var item = tmp0_iterator.l();
      // Inline function 'JsRequestJwtStore.getAll.<anonymous>' call
      var tmp$ret$0 = new JsPair(item.z9_1, new JsValidatedRequestJwt(item.aa_1));
      destination.e(tmp$ret$0);
    }
    return copyToArray(destination);
  };
  protoOf(JsRequestJwtStore).cleanupIfAfterPeriod = function () {
    this.inner.g73();
  };
  function JsVerifierClient$fetchRequestObjectJwt$slambda(this$0, $uri, resultContinuation) {
    this.p73_1 = this$0;
    this.q73_1 = $uri;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(JsVerifierClient$fetchRequestObjectJwt$slambda).r73 = function ($completion) {
    var tmp = this.n6r($completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(JsVerifierClient$fetchRequestObjectJwt$slambda).o6r = function ($completion) {
    return this.r73($completion);
  };
  protoOf(JsVerifierClient$fetchRequestObjectJwt$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            this.v8_1 = 1;
            suspendResult = this.p73_1.t73_1.b6m(this.q73_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var validatedResponse = suspendResult;
            return new JsValidatedRequestJwt(validatedResponse);
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  protoOf(JsVerifierClient$fetchRequestObjectJwt$slambda).n6r = function (completion) {
    return new JsVerifierClient$fetchRequestObjectJwt$slambda(this.p73_1, this.q73_1, completion);
  };
  function JsVerifierClient$fetchRequestObjectJwt$slambda_0(this$0, $uri, resultContinuation) {
    var i = new JsVerifierClient$fetchRequestObjectJwt$slambda(this$0, $uri, resultContinuation);
    var l = function ($completion) {
      return i.r73($completion);
    };
    l.$arity = 0;
    return l;
  }
  function JsVerifierClient$postDirectPostAuthorizationResponse$slambda(this$0, $uri, $params, resultContinuation) {
    this.c74_1 = this$0;
    this.d74_1 = $uri;
    this.e74_1 = $params;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(JsVerifierClient$postDirectPostAuthorizationResponse$slambda).f74 = function ($completion) {
    var tmp = this.n6r($completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(JsVerifierClient$postDirectPostAuthorizationResponse$slambda).o6r = function ($completion) {
    return this.f74($completion);
  };
  protoOf(JsVerifierClient$postDirectPostAuthorizationResponse$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            this.v8_1 = 1;
            suspendResult = this.c74_1.t73_1.c6m(this.d74_1, this.e74_1.inner, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var response = suspendResult;
            return new JsVerifierDirectPostAuthorizationResponse(response);
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  protoOf(JsVerifierClient$postDirectPostAuthorizationResponse$slambda).n6r = function (completion) {
    return new JsVerifierClient$postDirectPostAuthorizationResponse$slambda(this.c74_1, this.d74_1, this.e74_1, completion);
  };
  function JsVerifierClient$postDirectPostAuthorizationResponse$slambda_0(this$0, $uri, $params, resultContinuation) {
    var i = new JsVerifierClient$postDirectPostAuthorizationResponse$slambda(this$0, $uri, $params, resultContinuation);
    var l = function ($completion) {
      return i.f74($completion);
    };
    l.$arity = 0;
    return l;
  }
  function JsVerifierClient(proxy, clientStore) {
    this.s73_1 = createJsClient(null, proxy);
    this.t73_1 = new VerifierClient(this.s73_1, new HaipRequestObjectJwtValidator(clientStore.inner, System_instance, this.s73_1));
  }
  protoOf(JsVerifierClient).fetchRequestObjectJwt = function (uri) {
    var tmp = GlobalScope_instance;
    return safePromise(tmp, VOID, JsVerifierClient$fetchRequestObjectJwt$slambda_0(this, uri, null));
  };
  protoOf(JsVerifierClient).postDirectPostAuthorizationResponse = function (uri, params) {
    var tmp = GlobalScope_instance;
    return safePromise(tmp, VOID, JsVerifierClient$postDirectPostAuthorizationResponse$slambda_0(this, uri, params, null));
  };
  function loadFromLocalStorage_1($this) {
    var tmp15_safe_receiver = localStorage.getItem('request-jwt-store');
    var tmp;
    if (tmp15_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'Companion.loadFromLocalStorage.<anonymous>' call
      var tmp_0;
      try {
        // Inline function 'kotlinx.serialization.json.Json.decodeFromString' call
        var this_0 = Default_getInstance();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.dp();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer(this_1, createKType(getKClass(InMemoryRequestJwtStore), arrayOf([]), true));
        var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
        tmp_0 = this_0.cp(tmp$ret$1, tmp15_safe_receiver);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof SerializationException) {
          var e = $p;
          tmp_1 = new InMemoryRequestJwtStore();
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    }
    var tmp0_elvis_lhs = tmp;
    return tmp0_elvis_lhs == null ? new InMemoryRequestJwtStore() : tmp0_elvis_lhs;
  }
  function Companion_15() {
    this.g74_1 = 'request-jwt-store';
    this.h74_1 = 'request-jwt-store-last-cleanup';
  }
  var Companion_instance_24;
  function Companion_getInstance_22() {
    return Companion_instance_24;
  }
  function saveIntoLocalStorage_1($this) {
    var tmp = localStorage;
    // Inline function 'kotlinx.serialization.encodeToString' call
    var this_0 = Default_getInstance();
    var value = $this.e73_1;
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.dp();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(InMemoryRequestJwtStore), arrayOf([]), false));
    var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
    var tmp$ret$2 = this_0.bp(tmp$ret$1, value);
    tmp.setItem('request-jwt-store', tmp$ret$2);
  }
  function LocalStorageRequestJwtStore(delegate, cleanupPeriodInSeconds) {
    delegate = delegate === VOID ? loadFromLocalStorage_1(Companion_instance_24) : delegate;
    this.e73_1 = delegate;
    this.f73_1 = cleanupPeriodInSeconds;
  }
  protoOf(LocalStorageRequestJwtStore).r68 = function (id) {
    return this.e73_1.r68(id);
  };
  protoOf(LocalStorageRequestJwtStore).u68 = function () {
    return this.e73_1.u68();
  };
  protoOf(LocalStorageRequestJwtStore).g73 = function () {
    var nowEpochSeconds = System_instance.u1l().f1m();
    var lastCleanup = localStorage.getItem('request-jwt-store-last-cleanup');
    var tmp;
    if (lastCleanup == null) {
      tmp = true;
    } else {
      // Inline function 'kotlin.Long.plus' call
      var this_0 = toLong_0(lastCleanup);
      var other = this.f73_1;
      tmp = this_0.y2(toLong(other)).j1(nowEpochSeconds) < 0;
    }
    if (tmp) {
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = this.u68().j();
      while (tmp0_iterator.k()) {
        var element = tmp0_iterator.l();
        // Inline function 'LocalStorageRequestJwtStore.cleanupIfAfterPeriod.<anonymous>' call
        var id = element.z9_1;
        var requestJwt = element.aa_1;
        if (requestJwt.l6i_1.j1(System_instance.u1l().f1m()) < 0) {
          this.e73_1.q68(id);
        }
      }
      saveIntoLocalStorage_1(this);
      localStorage.setItem('request-jwt-store-last-cleanup', nowEpochSeconds.toString());
    }
  };
  protoOf(LocalStorageRequestJwtStore).i6f = function (id, requestJwt) {
    this.e73_1.i6f(id, requestJwt);
    saveIntoLocalStorage_1(this);
  };
  protoOf(LocalStorageRequestJwtStore).q68 = function (id) {
    this.e73_1.q68(id);
    saveIntoLocalStorage_1(this);
  };
  function JsOpenIdWalletAuthenticatorCredentialFinder$find$slambda(this$0, $presentationDefinition, resultContinuation) {
    this.q74_1 = this$0;
    this.r74_1 = $presentationDefinition;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(JsOpenIdWalletAuthenticatorCredentialFinder$find$slambda).s74 = function ($completion) {
    var tmp = this.n6r($completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(JsOpenIdWalletAuthenticatorCredentialFinder$find$slambda).o6r = function ($completion) {
    return this.s74($completion);
  };
  protoOf(JsOpenIdWalletAuthenticatorCredentialFinder$find$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            this.v8_1 = 1;
            suspendResult = this.q74_1.t74_1.s6f(this.r74_1.inner, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var credentialFinderResult = suspendResult;
            return new JsCredentialFinderResult(credentialFinderResult);
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  protoOf(JsOpenIdWalletAuthenticatorCredentialFinder$find$slambda).n6r = function (completion) {
    return new JsOpenIdWalletAuthenticatorCredentialFinder$find$slambda(this.q74_1, this.r74_1, completion);
  };
  function JsOpenIdWalletAuthenticatorCredentialFinder$find$slambda_0(this$0, $presentationDefinition, resultContinuation) {
    var i = new JsOpenIdWalletAuthenticatorCredentialFinder$find$slambda(this$0, $presentationDefinition, resultContinuation);
    var l = function ($completion) {
      return i.s74($completion);
    };
    l.$arity = 0;
    return l;
  }
  function JsOpenIdWalletAuthenticatorCredentialFinder(verifiableCredentialStore) {
    this.t74_1 = new OpenIdWalletAuthenticatorCredentialFinder(verifiableCredentialStore.inner);
  }
  protoOf(JsOpenIdWalletAuthenticatorCredentialFinder).find = function (presentationDefinition) {
    var tmp = GlobalScope_instance;
    return safePromise(tmp, VOID, JsOpenIdWalletAuthenticatorCredentialFinder$find$slambda_0(this, presentationDefinition, null));
  };
  function JsCredentialFinderResult$data$delegate$lambda($inner) {
    return function () {
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.map' call
      var this_0 = $inner.v6e_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.j();
      while (tmp0_iterator.k()) {
        var item = tmp0_iterator.l();
        // Inline function 'JsCredentialFinderResult.data$delegate.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.toTypedArray' call
        // Inline function 'kotlin.collections.map' call
        var this_1 = item.aa_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
        var tmp0_iterator_0 = this_1.j();
        while (tmp0_iterator_0.k()) {
          var item_0 = tmp0_iterator_0.l();
          // Inline function 'JsCredentialFinderResult.data$delegate.<anonymous>.<anonymous>.<anonymous>' call
          var tmp$ret$0 = createJsUserVerifiableCredential(item_0);
          destination_0.e(tmp$ret$0);
        }
        var credentials = copyToArray(destination_0);
        var tmp$ret$4 = new JsPair(new JsInputDescriptor(item.z9_1), credentials);
        destination.e(tmp$ret$4);
      }
      return copyToArray(destination);
    };
  }
  function JsCredentialFinderResult(inner) {
    var tmp = this;
    tmp.u74_1 = lazy(JsCredentialFinderResult$data$delegate$lambda(inner));
  }
  protoOf(JsCredentialFinderResult).p72 = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.u74_1;
    data$factory();
    return this_0.b1();
  };
  function data$factory() {
    return getPropertyCallableRef('data', 1, KProperty1, function (receiver) {
      return receiver.data;
    }, null);
  }
  function JsPreRegisteredClientStore$getByClientId$slambda(this$0, $clientId, resultContinuation) {
    this.d75_1 = this$0;
    this.e75_1 = $clientId;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(JsPreRegisteredClientStore$getByClientId$slambda).f75 = function ($completion) {
    var tmp = this.n6r($completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(JsPreRegisteredClientStore$getByClientId$slambda).o6r = function ($completion) {
    return this.f75($completion);
  };
  protoOf(JsPreRegisteredClientStore$getByClientId$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            this.v8_1 = 1;
            suspendResult = this.d75_1.inner.x6e(this.e75_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp16_safe_receiver = suspendResult;
            var tmp_0;
            if (tmp16_safe_receiver == null) {
              tmp_0 = null;
            } else {
              var this_0 = tmp16_safe_receiver.c6f_1;
              var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
              var tmp0_iterator = this_0.j();
              while (tmp0_iterator.k()) {
                var item = tmp0_iterator.l();
                var this_1 = item.k6m_1;
                destination.e(new JsVpFormat(item.j6m_1, copyToArray(this_1)));
              }
              tmp_0 = new JsPreRegisteredClient(tmp16_safe_receiver.z6e_1, tmp16_safe_receiver.a6f_1, tmp16_safe_receiver.b6f_1, copyToArray(destination));
            }

            return tmp_0;
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  protoOf(JsPreRegisteredClientStore$getByClientId$slambda).n6r = function (completion) {
    return new JsPreRegisteredClientStore$getByClientId$slambda(this.d75_1, this.e75_1, completion);
  };
  function JsPreRegisteredClientStore$getByClientId$slambda_0(this$0, $clientId, resultContinuation) {
    var i = new JsPreRegisteredClientStore$getByClientId$slambda(this$0, $clientId, resultContinuation);
    var l = function ($completion) {
      return i.f75($completion);
    };
    l.$arity = 0;
    return l;
  }
  function JsPreRegisteredClientStore$upsert$slambda(this$0, $preRegistredClient, resultContinuation) {
    this.o75_1 = this$0;
    this.p75_1 = $preRegistredClient;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(JsPreRegisteredClientStore$upsert$slambda).q75 = function ($completion) {
    var tmp = this.n6r($completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(JsPreRegisteredClientStore$upsert$slambda).o6r = function ($completion) {
    return this.q75($completion);
  };
  protoOf(JsPreRegisteredClientStore$upsert$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            this.v8_1 = 1;
            var this_0 = this.p75_1.vpFormatsSupported;
            var destination = ArrayList_init_$Create$(this_0.length);
            var inductionVariable = 0;
            var last = this_0.length;
            while (inductionVariable < last) {
              var item = this_0[inductionVariable];
              inductionVariable = inductionVariable + 1 | 0;
              destination.e(new VpFormat(item.format, toSet_0(item.algs)));
            }

            suspendResult = this.o75_1.inner.y6e(new PreRegisteredClient(this.p75_1.clientId, this.p75_1.jwksUri, this.p75_1.redirectUri, destination), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  protoOf(JsPreRegisteredClientStore$upsert$slambda).n6r = function (completion) {
    return new JsPreRegisteredClientStore$upsert$slambda(this.o75_1, this.p75_1, completion);
  };
  function JsPreRegisteredClientStore$upsert$slambda_0(this$0, $preRegistredClient, resultContinuation) {
    var i = new JsPreRegisteredClientStore$upsert$slambda(this$0, $preRegistredClient, resultContinuation);
    var l = function ($completion) {
      return i.q75($completion);
    };
    l.$arity = 0;
    return l;
  }
  function JsPreRegisteredClientStore$getAll$slambda(this$0, resultContinuation) {
    this.z75_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(JsPreRegisteredClientStore$getAll$slambda).a76 = function ($completion) {
    var tmp = this.n6r($completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(JsPreRegisteredClientStore$getAll$slambda).o6r = function ($completion) {
    return this.a76($completion);
  };
  protoOf(JsPreRegisteredClientStore$getAll$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            this.v8_1 = 1;
            suspendResult = this.z75_1.inner.d6f(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_0 = suspendResult;
            var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
            var tmp0_iterator = this_0.j();
            while (tmp0_iterator.k()) {
              var item = tmp0_iterator.l();
              var this_1 = item.c6f_1;
              var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
              var tmp0_iterator_0 = this_1.j();
              while (tmp0_iterator_0.k()) {
                var item_0 = tmp0_iterator_0.l();
                var this_2 = item_0.k6m_1;
                destination_0.e(new JsVpFormat(item_0.j6m_1, copyToArray(this_2)));
              }
              destination.e(new JsPreRegisteredClient(item.z6e_1, item.a6f_1, item.b6f_1, copyToArray(destination_0)));
            }

            return copyToArray(destination);
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  protoOf(JsPreRegisteredClientStore$getAll$slambda).n6r = function (completion) {
    return new JsPreRegisteredClientStore$getAll$slambda(this.z75_1, completion);
  };
  function JsPreRegisteredClientStore$getAll$slambda_0(this$0, resultContinuation) {
    var i = new JsPreRegisteredClientStore$getAll$slambda(this$0, resultContinuation);
    var l = function ($completion) {
      return i.a76($completion);
    };
    l.$arity = 0;
    return l;
  }
  function JsPreRegisteredClientStore(inner) {
    this.inner = inner;
  }
  protoOf(JsPreRegisteredClientStore).o3h = function () {
    return this.inner;
  };
  protoOf(JsPreRegisteredClientStore).getByClientId = function (clientId) {
    var tmp = GlobalScope_instance;
    return safePromise(tmp, VOID, JsPreRegisteredClientStore$getByClientId$slambda_0(this, clientId, null));
  };
  protoOf(JsPreRegisteredClientStore).upsert = function (preRegistredClient) {
    var tmp = GlobalScope_instance;
    safePromise(tmp, VOID, JsPreRegisteredClientStore$upsert$slambda_0(this, preRegistredClient, null));
  };
  protoOf(JsPreRegisteredClientStore).getAll = function () {
    var tmp = GlobalScope_instance;
    return safePromise(tmp, VOID, JsPreRegisteredClientStore$getAll$slambda_0(this, null));
  };
  function JsPreRegisteredClient(clientId, jwksUri, redirectUri, vpFormatsSupported) {
    this.clientId = clientId;
    this.jwksUri = jwksUri;
    this.redirectUri = redirectUri;
    this.vpFormatsSupported = vpFormatsSupported;
  }
  protoOf(JsPreRegisteredClient).b76 = function () {
    return this.clientId;
  };
  protoOf(JsPreRegisteredClient).c76 = function () {
    return this.jwksUri;
  };
  protoOf(JsPreRegisteredClient).u3f = function () {
    return this.redirectUri;
  };
  protoOf(JsPreRegisteredClient).d76 = function () {
    return this.vpFormatsSupported;
  };
  protoOf(JsPreRegisteredClient).ba = function () {
    return this.clientId;
  };
  protoOf(JsPreRegisteredClient).ca = function () {
    return this.jwksUri;
  };
  protoOf(JsPreRegisteredClient).qj = function () {
    return this.redirectUri;
  };
  protoOf(JsPreRegisteredClient).q5v = function () {
    return this.vpFormatsSupported;
  };
  protoOf(JsPreRegisteredClient).e76 = function (clientId, jwksUri, redirectUri, vpFormatsSupported) {
    return new JsPreRegisteredClient(clientId, jwksUri, redirectUri, vpFormatsSupported);
  };
  protoOf(JsPreRegisteredClient).copy = function (clientId, jwksUri, redirectUri, vpFormatsSupported, $super) {
    clientId = clientId === VOID ? this.clientId : clientId;
    jwksUri = jwksUri === VOID ? this.jwksUri : jwksUri;
    redirectUri = redirectUri === VOID ? this.redirectUri : redirectUri;
    vpFormatsSupported = vpFormatsSupported === VOID ? this.vpFormatsSupported : vpFormatsSupported;
    return this.e76(clientId, jwksUri, redirectUri, vpFormatsSupported);
  };
  protoOf(JsPreRegisteredClient).toString = function () {
    return 'JsPreRegisteredClient(clientId=' + this.clientId + ', jwksUri=' + this.jwksUri + ', redirectUri=' + this.redirectUri + ', vpFormatsSupported=' + toString(this.vpFormatsSupported) + ')';
  };
  protoOf(JsPreRegisteredClient).hashCode = function () {
    var result = getStringHashCode(this.clientId);
    result = imul(result, 31) + getStringHashCode(this.jwksUri) | 0;
    result = imul(result, 31) + getStringHashCode(this.redirectUri) | 0;
    result = imul(result, 31) + hashCode(this.vpFormatsSupported) | 0;
    return result;
  };
  protoOf(JsPreRegisteredClient).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsPreRegisteredClient))
      return false;
    var tmp0_other_with_cast = other instanceof JsPreRegisteredClient ? other : THROW_CCE();
    if (!(this.clientId === tmp0_other_with_cast.clientId))
      return false;
    if (!(this.jwksUri === tmp0_other_with_cast.jwksUri))
      return false;
    if (!(this.redirectUri === tmp0_other_with_cast.redirectUri))
      return false;
    if (!equals(this.vpFormatsSupported, tmp0_other_with_cast.vpFormatsSupported))
      return false;
    return true;
  };
  function JsVpFormat(format, algs) {
    this.format = format;
    this.algs = algs;
  }
  protoOf(JsVpFormat).z33 = function () {
    return this.format;
  };
  protoOf(JsVpFormat).f76 = function () {
    return this.algs;
  };
  //region block: post-declaration
  protoOf($serializer).mz = typeParametersSerializers;
  protoOf($serializer_0).mz = typeParametersSerializers;
  protoOf($serializer_1).mz = typeParametersSerializers;
  protoOf($serializer_2).mz = typeParametersSerializers;
  protoOf($serializer_3).mz = typeParametersSerializers;
  protoOf($serializer_4).mz = typeParametersSerializers;
  protoOf(ProxyEngine).r4y = get_supportedCapabilities;
  protoOf(ProxyEngine).b4u = install;
  defineProp(protoOf(JsResolvedOffer), 'issuer', protoOf(JsResolvedOffer).e3c);
  defineProp(protoOf(JsResolvedOffer), 'credentialsSupported', protoOf(JsResolvedOffer).i3h);
  defineProp(protoOf(JsResolvedOffer), 'txCode', protoOf(JsResolvedOffer).k6x);
  defineProp(protoOf(JsOfferResult), 'issuedCredentials', protoOf(JsOfferResult).o6x);
  defineProp(protoOf(JsPresentationDefinition), 'format', protoOf(JsPresentationDefinition).z33);
  defineProp(protoOf(JsPresentationDefinition), 'inputDescriptors', protoOf(JsPresentationDefinition).l71);
  defineProp(protoOf(JsFormat), 'jwtVcJson', protoOf(JsFormat).a3j);
  defineProp(protoOf(JsFormat), 'jwtVpJson', protoOf(JsFormat).r71);
  defineProp(protoOf(JsFormat), 'ldpVc', protoOf(JsFormat).s71);
  defineProp(protoOf(JsFormat), 'ldpVp', protoOf(JsFormat).t71);
  defineProp(protoOf(JsFormat), 'customFormats', protoOf(JsFormat).u71);
  defineProp(protoOf(JsInputDescriptor), 'format', protoOf(JsInputDescriptor).z33);
  defineProp(protoOf(JsConstraint), 'fields', protoOf(JsConstraint).a72);
  defineProp(protoOf(JsField), 'filter', protoOf(JsField).f72);
  defineProp(protoOf(AbstractJsfilter), 'type', function () {
    return this.g36();
  });
  defineProp(protoOf(JsPresentationSubmission), 'descriptorMap', protoOf(JsPresentationSubmission).n72);
  defineProp(protoOf(JsCredentialFinderResult), 'data', protoOf(JsCredentialFinderResult).p72);
  //endregion
  //region block: init
  ProofOfPossessionBuilder_instance = new ProofOfPossessionBuilder();
  Companion_instance_10 = new Companion_1();
  Companion_instance_11 = new Companion_2();
  JwtCredentialValidationHelper_instance = new JwtCredentialValidationHelper();
  Companion_instance_14 = new Companion_5();
  Companion_instance_18 = new Companion_9();
  Companion_instance_19 = new Companion_10();
  Companion_instance_21 = new Companion_12();
  Companion_instance_22 = new Companion_13();
  Companion_instance_23 = new Companion_14();
  Companion_instance_24 = new Companion_15();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    _.JsHttpProxy = JsHttpProxy;
    _.createCredentialIssuerLoader = createCredentialIssuerLoader;
    _.createCredentialIssuerStore = createCredentialIssuerStore;
    _.createVerifiableCredentialStore = createVerifiableCredentialStore;
    _.createOAuthClient = createOAuthClient;
    _.createCredentialIssuanceCoordinator = createCredentialIssuanceCoordinator;
    _.createPreRegisteredClientStore = createPreRegisteredClientStore;
    _.createVerifierClient = createVerifierClient;
    _.createCredentialFinder = createCredentialFinder;
    _.createPresentationResponseCreator = createPresentationResponseCreator;
    _.newUserCancellationException = newUserCancellationException;
    _.createRequestJwtStore = createRequestJwtStore;
    _.createKeyStore = createKeyStore;
    _.createInMemoryKeyAliasStore = createInMemoryKeyAliasStore;
    _.JsVcClient = JsVcClient;
    _.UserCancellationException = UserCancellationException;
    _.JsProxy = JsProxy;
    var $vc_js = _.vc_js || (_.vc_js = {});
    var $vc_js$services = $vc_js.services || ($vc_js.services = {});
    $vc_js$services.createBrowserWindowOAuthSupport = createBrowserWindowOAuthSupport;
    $vc_js$services.JsOAuthSupport = JsOAuthSupport;
    var $vc_js = _.vc_js || (_.vc_js = {});
    var $vc_js$services = $vc_js.services || ($vc_js.services = {});
    $vc_js$services.JsKeyAliasStore = JsKeyAliasStore;
    _.JsCredentialIssuerLoader = JsCredentialIssuerLoader;
    _.JsCredentialIssuerStore = JsCredentialIssuerStore;
    _.JsVerifiableCredentialStore = JsVerifiableCredentialStore;
    _.JsResolvedOffer = JsResolvedOffer;
    _.JsTxCode = JsTxCode;
    _.JsOfferResult = JsOfferResult;
    _.JsCredentialIssuanceCoordinator = JsCredentialIssuanceCoordinator;
    _.JsValidatedRequestJwt = JsValidatedRequestJwt;
    _.JsPresentationDefinition = JsPresentationDefinition;
    _.JsFormat = JsFormat;
    _.JsAlgFormat = JsAlgFormat;
    _.JsProofTypeFormat = JsProofTypeFormat;
    _.JsInputDescriptor = JsInputDescriptor;
    _.JsConstraint = JsConstraint;
    _.JsField = JsField;
    _.AbstractJsfilter = AbstractJsfilter;
    defineProp(_.AbstractJsfilter, 'Companion', Companion_getInstance_20);
    _.JsStringFilter = JsStringFilter;
    _.JsArrayContainsFilter = JsArrayContainsFilter;
    _.JsContains = JsContains;
    _.JsVerifiablePresentationResponseParameters = JsVerifiablePresentationResponseParameters;
    _.JsPresentationSubmission = JsPresentationSubmission;
    _.JsDescriptorMapObject = JsDescriptorMapObject;
    _.JsPathNested = JsPathNested;
    _.JsVerifierDirectPostAuthorizationResponse = JsVerifierDirectPostAuthorizationResponse;
    _.JsUserSelectedCredentials = JsUserSelectedCredentials;
    _.JsUserSelectedCredential = JsUserSelectedCredential;
    _.JsPresentationDisclosure = JsPresentationDisclosure;
    _.JsPresentationResponseCreator = JsPresentationResponseCreator;
    defineProp(_.JsPresentationResponseCreator, 'Companion', Companion_getInstance_21);
    _.JsRequestJwtStore = JsRequestJwtStore;
    _.JsVerifierClient = JsVerifierClient;
    _.JsOpenIdWalletAuthenticatorCredentialFinder = JsOpenIdWalletAuthenticatorCredentialFinder;
    _.JsCredentialFinderResult = JsCredentialFinderResult;
    _.JsPreRegisteredClientStore = JsPreRegisteredClientStore;
    _.JsPreRegisteredClient = JsPreRegisteredClient;
    _.JsVpFormat = JsVpFormat;
  }
  $jsExportAll$(_);
  kotlin_io_curity_ssi_jose.$jsExportAll$(_);
  kotlin_io_curity_ssi_sd_jwt.$jsExportAll$(_);
  kotlin_io_curity_ssi_vc_ks_data.$jsExportAll$(_);
  kotlin_io_curity_ssi_oauth.$jsExportAll$(_);
  //endregion
  return _;
}));

//# sourceMappingURL=curity-ssi-libs-verifiable-credentials-vc-ks-services.js.map
